{
  "level": "mt07",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt07",
    "objects": "AREAS.E3:mt07.e3",
    "mesh": "TREES.E3:mt07.e3"
  },
  "spawn_point": {
    "position": [
      -321.95602336059727,
      -2303.5890756115423,
      33.41556739807129
    ],
    "facing_rad": 0.0,
    "look_point": [
      -321.95602336059727,
      -2203.5890756115423,
      33.41556739807129
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -450.5,
      -2424.0,
      9.415567398071289
    ],
    "bbox_max": [
      33.723262786865234,
      -1318.5909423828125,
      774.9957885742188
    ],
    "vertex_count": 1579,
    "vertices": [
      [
        -330.3215026855469,
        -2270.88525390625,
        750.0
      ],
      [
        -344.0574645996094,
        -2284.621826171875,
        750.0
      ],
      [
        -330.3212585449219,
        -2322.697509765625,
        750.0
      ],
      [
        -332.20172119140625,
        -2320.817138671875,
        750.0
      ],
      [
        -344.0578918457031,
        -2308.961669921875,
        750.0
      ],
      [
        -332.20172119140625,
        -2320.817138671875,
        750.0
      ],
      [
        -345.07513427734375,
        -2287.07861328125,
        750.0
      ],
      [
        -345.0755310058594,
        -2306.504638671875,
        750.0
      ],
      [
        -345.0755310058594,
        -2306.504638671875,
        750.0
      ],
      [
        -344.0578918457031,
        -2308.961669921875,
        750.0
      ],
      [
        -344.0574645996094,
        -2284.621826171875,
        750.0
      ],
      [
        -345.07513427734375,
        -2287.07861328125,
        750.0
      ],
      [
        -327.8636169433594,
        -2323.7158203125,
        750.0
      ],
      [
        -308.4392395019531,
        -2323.7158203125,
        750.0
      ],
      [
        -330.3212585449219,
        -2322.697509765625,
        750.0
      ],
      [
        -327.8636169433594,
        -2323.7158203125,
        750.0
      ],
      [
        -305.9815979003906,
        -2322.697509765625,
        750.0
      ],
      [
        -292.24517822265625,
        -2308.96142578125,
        750.0
      ],
      [
        -308.4392395019531,
        -2323.7158203125,
        750.0
      ],
      [
        -305.9815979003906,
        -2322.697509765625,
        750.0
      ],
      [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      [
        -291.2275390625,
        -2287.078369140625,
        750.0
      ],
      [
        -292.24517822265625,
        -2308.96142578125,
        750.0
      ],
      [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      [
        -292.24517822265625,
        -2284.62158203125,
        750.0
      ],
      [
        -305.9817810058594,
        -2270.8857421875,
        750.0
      ],
      [
        -291.2275390625,
        -2287.078369140625,
        750.0
      ],
      [
        -292.24517822265625,
        -2284.62158203125,
        750.0
      ],
      [
        -305.9817810058594,
        -2270.8857421875,
        750.0
      ],
      [
        -308.4385986328125,
        -2269.867919921875,
        750.0
      ],
      [
        -328.6746826171875,
        -2243.181884765625,
        771.5317993164062
      ],
      [
        -328.6746826171875,
        -2243.181884765625,
        771.5317993164062
      ],
      [
        -328.4978942871094,
        -2243.083984375,
        771.466552734375
      ],
      [
        -312.60009765625,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -312.60009765625,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -312.60009765625,
        -2247.2734375,
        774.2499389648438
      ],
      [
        -312.60009765625,
        -2249.2431640625,
        771.9613037109375
      ],
      [
        -310.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -312.60009765625,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -310.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -310.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -312.60009765625,
        -2249.2431640625,
        771.9613037109375
      ],
      [
        -310.39990234375,
        -2249.823974609375,
        772.3453979492188
      ],
      [
        -277.9519348144531,
        -2269.08544921875,
        774.4052734375
      ],
      [
        -277.61895751953125,
        -2268.75244140625,
        774.9501342773438
      ],
      [
        -287.1449890136719,
        -2259.893798828125,
        774.40380859375
      ],
      [
        -286.8111877441406,
        -2259.56005859375,
        774.9500122070312
      ],
      [
        -288.3668518066406,
        -2258.00439453125,
        774.9500122070312
      ],
      [
        -288.7006530761719,
        -2258.338134765625,
        774.40380859375
      ],
      [
        -279.17462158203125,
        -2267.19677734375,
        774.9501342773438
      ],
      [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      [
        -280.2184753417969,
        -2327.144775390625,
        774.6267700195312
      ],
      [
        -280.0090026855469,
        -2327.354248046875,
        774.96826171875
      ],
      [
        -269.54083251953125,
        -2289.39990234375,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2289.39990234375,
        774.95068359375
      ],
      [
        -289.4108581542969,
        -2336.337158203125,
        774.6267700195312
      ],
      [
        -289.2013854980469,
        -2336.546630859375,
        774.96826171875
      ],
      [
        -366.45758056640625,
        -2304.60009765625,
        774.9932861328125
      ],
      [
        -366.39190673828125,
        -2304.60009765625,
        774.91650390625
      ],
      [
        -366.4573669433594,
        -2291.60009765625,
        774.9934692382812
      ],
      [
        -366.3931884765625,
        -2291.60009765625,
        774.91845703125
      ],
      [
        -366.3933410644531,
        -2289.39990234375,
        774.9186401367188
      ],
      [
        -366.45733642578125,
        -2289.39990234375,
        774.9934692382812
      ],
      [
        -325.60009765625,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -325.60009765625,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -323.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -323.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.545654296875
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.545654296875
      ],
      [
        -318.044921875,
        -2237.298583984375,
        767.6095581054688
      ],
      [
        -312.60009765625,
        -2240.3017578125,
        769.6069946289062
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395263671875
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395263671875
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -270.9585266113281,
        -2277.35400390625,
        773.3617553710938
      ],
      [
        -278.028564453125,
        -2247.666015625,
        765.2129516601562
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.7173156738281,
        -2249.354736328125,
        763.2664794921875
      ],
      [
        -279.0205383300781,
        -2251.76953125,
        764.069580078125
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -274.9033508300781,
        -2266.036865234375,
        768.8150024414062
      ],
      [
        -277.3288879394531,
        -2250.077880859375,
        766.0193481445312
      ],
      [
        -279.0205383300781,
        -2251.76953125,
        764.069580078125
      ],
      [
        -272.5294189453125,
        -2266.46484375,
        771.5512084960938
      ],
      [
        -273.8948669433594,
        -2261.9169921875,
        769.9774169921875
      ],
      [
        -275.60009765625,
        -2263.622314453125,
        768.0119018554688
      ],
      [
        -273.1952209472656,
        -2264.328857421875,
        770.7837524414062
      ],
      [
        -274.9033508300781,
        -2266.036865234375,
        768.8150024414062
      ],
      [
        -310.9726257324219,
        -2233.38427734375,
        765.0
      ],
      [
        -310.5257873535156,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -312.60009765625,
        -2236.657470703125,
        763.6400146484375
      ],
      [
        -312.60009765625,
        -2234.285400390625,
        765.6001586914062
      ],
      [
        -312.60009765625,
        -2236.657470703125,
        763.6400146484375
      ],
      [
        -310.5257873535156,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -310.39990234375,
        -2235.46044921875,
        762.81103515625
      ],
      [
        -270.9575500488281,
        -2316.333251953125,
        773.3629150390625
      ],
      [
        -264.36346435546875,
        -2307.51611328125,
        771.5509033203125
      ],
      [
        -254.537109375,
        -2289.653564453125,
        765.0
      ],
      [
        -254.44439697265625,
        -2289.39990234375,
        764.8689575195312
      ],
      [
        -255.6233367919922,
        -2289.39990234375,
        763.9078979492188
      ],
      [
        -255.6233367919922,
        -2289.39990234375,
        763.9078979492188
      ],
      [
        -256.78173828125,
        -2289.39990234375,
        762.9635620117188
      ],
      [
        -256.78173828125,
        -2289.39990234375,
        762.9635620117188
      ],
      [
        -257.99652099609375,
        -2291.60009765625,
        763.7667236328125
      ],
      [
        -264.36346435546875,
        -2307.51611328125,
        771.5509033203125
      ],
      [
        -271.6867980957031,
        -2244.435791015625,
        750.0
      ],
      [
        -273.2424621582031,
        -2242.8798828125,
        750.0
      ],
      [
        -273.2424621582031,
        -2242.8798828125,
        750.0
      ],
      [
        -271.6867980957031,
        -2244.435791015625,
        750.0
      ],
      [
        -262.4944152832031,
        -2253.628173828125,
        750.0
      ],
      [
        -264.0500793457031,
        -2252.072265625,
        750.0
      ],
      [
        -264.0500793457031,
        -2252.072265625,
        750.0
      ],
      [
        -262.4944152832031,
        -2253.628173828125,
        750.0
      ],
      [
        -248.08302307128906,
        -2304.60009765625,
        750.0
      ],
      [
        -248.08302307128906,
        -2291.60009765625,
        750.0
      ],
      [
        -248.08302307128906,
        -2289.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2289.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2291.60009765625,
        750.0
      ],
      [
        -248.08302307128906,
        -2302.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2302.39990234375,
        750.0
      ],
      [
        -248.08302307128906,
        -2304.60009765625,
        750.0
      ],
      [
        -269.3914489746094,
        -2334.860595703125,
        762.8990478515625
      ],
      [
        -271.8075866699219,
        -2335.5556640625,
        763.70361328125
      ],
      [
        -283.66851806640625,
        -2338.96826171875,
        767.6533813476562
      ],
      [
        -286.084716796875,
        -2339.663330078125,
        768.4579467773438
      ],
      [
        -271.8075866699219,
        -2335.5556640625,
        763.70361328125
      ],
      [
        -270.1214599609375,
        -2337.241943359375,
        765.6557006835938
      ],
      [
        -267.76580810546875,
        -2336.48583984375,
        764.7802734375
      ],
      [
        -269.18792724609375,
        -2335.06396484375,
        763.1345825195312
      ],
      [
        -286.084716796875,
        -2339.663330078125,
        768.4579467773438
      ],
      [
        -284.3819580078125,
        -2341.3662109375,
        770.4290771484375
      ],
      [
        -328.6674499511719,
        -2350.510498046875,
        771.5366821289062
      ],
      [
        -310.9231872558594,
        -2360.3154296875,
        765.0
      ],
      [
        -310.39990234375,
        -2358.21826171875,
        762.8425903320312
      ],
      [
        -310.39990234375,
        -2360.500732421875,
        764.721923828125
      ],
      [
        -312.60009765625,
        -2357.011474609375,
        763.660400390625
      ],
      [
        -310.466796875,
        -2358.194580078125,
        762.878173828125
      ],
      [
        -323.39990234375,
        -2351.021484375,
        767.6207275390625
      ],
      [
        -325.60009765625,
        -2349.80126953125,
        768.427490234375
      ],
      [
        -312.60009765625,
        -2357.011474609375,
        763.660400390625
      ],
      [
        -312.60009765625,
        -2359.388427734375,
        765.6173706054688
      ],
      [
        -323.39990234375,
        -2351.021484375,
        767.6207275390625
      ],
      [
        -323.39990234375,
        -2353.41796875,
        769.5936279296875
      ],
      [
        -325.60009765625,
        -2349.80126953125,
        768.427490234375
      ],
      [
        -325.60009765625,
        -2352.20166015625,
        770.4036865234375
      ],
      [
        -310.39990234375,
        -2358.21826171875,
        762.8425903320312
      ],
      [
        -310.466796875,
        -2358.194580078125,
        762.878173828125
      ],
      [
        -272.5019836425781,
        -2350.134765625,
        750.0
      ],
      [
        -274.0576477050781,
        -2351.6904296875,
        750.0
      ],
      [
        -272.5019836425781,
        -2350.134765625,
        750.0
      ],
      [
        -274.0576477050781,
        -2351.6904296875,
        750.0
      ],
      [
        -264.8652648925781,
        -2342.498046875,
        750.0
      ],
      [
        -263.3096008300781,
        -2340.9423828125,
        750.0
      ],
      [
        -263.3096008300781,
        -2340.9423828125,
        750.0
      ],
      [
        -264.8652648925781,
        -2342.498046875,
        750.0
      ],
      [
        -365.0546569824219,
        -2277.3564453125,
        773.354248046875
      ],
      [
        -365.05645751953125,
        -2316.32958984375,
        773.355224609375
      ],
      [
        -371.66522216796875,
        -2286.17236328125,
        771.5317993164062
      ],
      [
        -371.6573486328125,
        -2307.520263671875,
        771.5370483398438
      ],
      [
        -372.27508544921875,
        -2291.60009765625,
        767.5505981445312
      ],
      [
        -374.6662292480469,
        -2291.60009765625,
        769.5264892578125
      ],
      [
        -372.27508544921875,
        -2291.60009765625,
        767.5505981445312
      ],
      [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      [
        -373.4478454589844,
        -2289.39990234375,
        770.337890625
      ],
      [
        -370.8665771484375,
        -2304.60009765625,
        768.4818725585938
      ],
      [
        -372.0869140625,
        -2302.39990234375,
        767.675048828125
      ],
      [
        -370.8665771484375,
        -2304.60009765625,
        768.4818725585938
      ],
      [
        -373.2669982910156,
        -2304.60009765625,
        770.4583129882812
      ],
      [
        -372.99517822265625,
        -2345.744140625,
        750.0
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.86334228515625,
        -2338.6123046875,
        765.129150390625
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -374.5508728027344,
        -2344.188232421875,
        750.0
      ],
      [
        -367.41888427734375,
        -2337.056396484375,
        765.1295166015625
      ],
      [
        -367.5105285644531,
        -2337.14794921875,
        764.9351196289062
      ],
      [
        -363.8028869628906,
        -2354.936767578125,
        750.0
      ],
      [
        -356.7624206542969,
        -2347.896240234375,
        764.9353637695312
      ],
      [
        -356.7623596191406,
        -2347.896240234375,
        764.935302734375
      ],
      [
        -356.67095947265625,
        -2347.8046875,
        765.129150390625
      ],
      [
        -358.3182067871094,
        -2346.34033203125,
        764.9351806640625
      ],
      [
        -365.35870361328125,
        -2353.380859375,
        750.0
      ],
      [
        -365.92431640625,
        -2338.67333984375,
        764.9998168945312
      ],
      [
        -355.3629150390625,
        -2328.11181640625,
        774.9572143554688
      ],
      [
        -356.9188232421875,
        -2326.555908203125,
        774.9572143554688
      ],
      [
        -367.4798583984375,
        -2337.1171875,
        765.0001831054688
      ],
      [
        -356.7318115234375,
        -2347.86572265625,
        765.0001220703125
      ],
      [
        -346.1705322265625,
        -2337.30419921875,
        774.9572143554688
      ],
      [
        -361.3681335449219,
        -2352.501953125,
        750.0
      ],
      [
        -372.1161804199219,
        -2341.753662109375,
        750.0
      ],
      [
        -370.5605163574219,
        -2343.3095703125,
        750.0
      ],
      [
        -370.5605163574219,
        -2343.3095703125,
        750.0
      ],
      [
        -372.1161804199219,
        -2341.753662109375,
        750.0
      ],
      [
        -362.9237976074219,
        -2350.946044921875,
        750.0
      ],
      [
        -361.3681335449219,
        -2352.501953125,
        750.0
      ],
      [
        -362.9237976074219,
        -2350.946044921875,
        750.0
      ],
      [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      [
        -381.7206726074219,
        -2304.60009765625,
        764.6133422851562
      ],
      [
        -378.27459716796875,
        -2302.39990234375,
        763.5839233398438
      ],
      [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -312.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      [
        -312.60009765625,
        -2366.76416015625,
        750.0
      ],
      [
        -366.78802490234375,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -373.8408203125,
        -2248.795654296875,
        750.0
      ],
      [
        -366.73284912109375,
        -2255.903564453125,
        765.0780029296875
      ],
      [
        -366.7880554199219,
        -2255.848388671875,
        764.9608764648438
      ],
      [
        -368.34393310546875,
        -2257.404296875,
        764.9608764648438
      ],
      [
        -375.396728515625,
        -2250.3515625,
        750.0
      ],
      [
        -357.59564208984375,
        -2246.656005859375,
        764.9608764648438
      ],
      [
        -364.6484375,
        -2239.603271484375,
        750.0
      ],
      [
        -359.15155029296875,
        -2248.2119140625,
        764.9608764648438
      ],
      [
        -366.204345703125,
        -2241.1591796875,
        750.0
      ],
      [
        -356.1874694824219,
        -2266.44921875,
        774.9771118164062
      ],
      [
        -366.76959228515625,
        -2255.866943359375,
        765.0
      ],
      [
        -371.3757019042969,
        -2251.260986328125,
        750.0
      ],
      [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      [
        -372.9313659667969,
        -2252.816650390625,
        750.0
      ],
      [
        -372.9313659667969,
        -2252.816650390625,
        750.0
      ],
      [
        -371.3757019042969,
        -2251.260986328125,
        750.0
      ],
      [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      [
        -387.91162109375,
        -2304.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2304.60009765625,
        750.0
      ],
      [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      [
        -325.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -312.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -312.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -310.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -325.60009765625,
        -2226.935546875,
        750.0
      ],
      [
        -323.39990234375,
        -2226.935546875,
        750.0
      ],
      [
        -363.7389831542969,
        -2243.624267578125,
        750.0
      ],
      [
        -362.1833190917969,
        -2242.068603515625,
        750.0
      ],
      [
        -363.7389831542969,
        -2243.624267578125,
        750.0
      ],
      [
        -362.1833190917969,
        -2242.068603515625,
        750.0
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        712.0
      ],
      [
        -341.653076171875,
        -2287.05810546875,
        712.0
      ],
      [
        -341.6533203125,
        -2297.0,
        746.0
      ],
      [
        -341.6533203125,
        -2297.0,
        712.0
      ],
      [
        -318.5,
        -2273.30517578125,
        746.0
      ],
      [
        -327.900634765625,
        -2273.304931640625,
        712.0
      ],
      [
        -318.5,
        -2273.30517578125,
        712.0
      ],
      [
        -341.6533203125,
        -2297.0,
        746.0
      ],
      [
        -345.0751953125,
        -2290.48046875,
        750.0
      ],
      [
        -345.0753479003906,
        -2297.0,
        750.0
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        712.0
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        729.9920043945312
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        729.9920043945312
      ],
      [
        -369.7396240234375,
        -2237.62353515625,
        730.26025390625
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        730.26025390625
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        729.9920043945312
      ],
      [
        -378.9320068359375,
        -2246.81591796875,
        712.0
      ],
      [
        -378.9320068359375,
        -2246.81591796875,
        729.9920043945312
      ],
      [
        -378.9320068359375,
        -2246.81591796875,
        729.9920043945312
      ],
      [
        -378.9320068359375,
        -2246.81591796875,
        730.26025390625
      ],
      [
        -377.3763427734375,
        -2245.26025390625,
        730.26025390625
      ],
      [
        -377.3763427734375,
        -2245.26025390625,
        729.9920043945312
      ],
      [
        -373.8453063964844,
        -2248.791259765625,
        749.9740600585938
      ],
      [
        -373.8407287597656,
        -2248.795654296875,
        750.0
      ],
      [
        -373.8453063964844,
        -2248.791259765625,
        749.9740600585938
      ],
      [
        -375.4012145996094,
        -2250.34716796875,
        749.9740600585938
      ],
      [
        -375.3966369628906,
        -2250.3515625,
        750.0
      ],
      [
        -375.4012145996094,
        -2250.34716796875,
        749.9740600585938
      ],
      [
        -364.6529846191406,
        -2239.5986328125,
        749.97412109375
      ],
      [
        -364.6484375,
        -2239.603271484375,
        750.0
      ],
      [
        -364.6529846191406,
        -2239.5986328125,
        749.97412109375
      ],
      [
        -366.2088317871094,
        -2241.15478515625,
        749.9740600585938
      ],
      [
        -366.2042541503906,
        -2241.1591796875,
        750.0
      ],
      [
        -366.2088317871094,
        -2241.15478515625,
        749.9740600585938
      ],
      [
        -391.462890625,
        -2297.0,
        750.0
      ],
      [
        -396.462890625,
        -2297.0,
        730.0
      ],
      [
        -318.5,
        -2223.38427734375,
        750.0
      ],
      [
        -318.5,
        -2218.38427734375,
        730.0
      ],
      [
        -318.5,
        -2218.38427734375,
        730.0
      ],
      [
        -318.5,
        -2218.38427734375,
        712.0
      ],
      [
        -396.462890625,
        -2297.0,
        730.0
      ],
      [
        -396.462890625,
        -2297.0,
        721.0
      ],
      [
        -376.84716796875,
        -2297.0,
        716.0
      ],
      [
        -376.84716796875,
        -2297.0,
        712.0
      ],
      [
        -318.5,
        -2238.0,
        716.0
      ],
      [
        -318.5,
        -2238.0,
        712.0
      ],
      [
        -294.697998046875,
        -2287.057861328125,
        712.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -308.451171875,
        -2273.305419921875,
        712.0
      ],
      [
        -294.69818115234375,
        -2297.0,
        712.0
      ],
      [
        -294.697998046875,
        -2297.0,
        746.0
      ],
      [
        -294.697998046875,
        -2287.057861328125,
        712.0
      ],
      [
        -291.2275390625,
        -2297.0,
        750.0
      ],
      [
        -291.2275390625,
        -2290.5283203125,
        750.0
      ],
      [
        -294.697998046875,
        -2297.0,
        746.0
      ],
      [
        -244.537109375,
        -2297.0,
        750.0
      ],
      [
        -239.537109375,
        -2297.0,
        730.0
      ],
      [
        -244.5365753173828,
        -2291.60009765625,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2291.60009765625,
        750.0
      ],
      [
        -239.53695678710938,
        -2291.60009765625,
        729.9993286132812
      ],
      [
        -239.53173828125,
        -2291.60009765625,
        729.9784545898438
      ],
      [
        -244.5365753173828,
        -2291.60009765625,
        749.9978637695312
      ],
      [
        -239.53695678710938,
        -2291.60009765625,
        729.9993286132812
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2289.39990234375,
        750.0
      ],
      [
        -239.53173828125,
        -2289.39990234375,
        729.9784545898438
      ],
      [
        -239.53695678710938,
        -2289.39990234375,
        729.9993286132812
      ],
      [
        -239.53695678710938,
        -2289.39990234375,
        729.9993286132812
      ],
      [
        -244.5365753173828,
        -2289.39990234375,
        749.9978637695312
      ],
      [
        -239.537109375,
        -2297.0,
        730.0
      ],
      [
        -239.537109375,
        -2297.0,
        712.0
      ],
      [
        -239.537109375,
        -2289.39990234375,
        712.0
      ],
      [
        -239.537109375,
        -2291.60009765625,
        712.0
      ],
      [
        -259.15283203125,
        -2297.0,
        716.0
      ],
      [
        -259.15283203125,
        -2297.0,
        712.0
      ],
      [
        -318.5,
        -1351.22705078125,
        31.505361557006836
      ],
      [
        -318.5,
        -1318.5909423828125,
        9.415567398071289
      ],
      [
        -318.5,
        -1351.22705078125,
        31.505361557006836
      ],
      [
        -318.5,
        -1362.2982177734375,
        37.15850067138672
      ],
      [
        -318.5,
        -1562.755859375,
        92.36326599121094
      ],
      [
        -318.5,
        -1434.75,
        70.672119140625
      ],
      [
        -318.5,
        -1434.75,
        70.672119140625
      ],
      [
        -318.5,
        -1403.5745849609375,
        65.35711669921875
      ],
      [
        -318.5,
        -2211.181396484375,
        641.0
      ],
      [
        -318.5,
        -2214.479736328125,
        641.0
      ],
      [
        -347.7600402832031,
        -2297.0,
        620.0
      ],
      [
        -347.1125793457031,
        -2297.0,
        620.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        620.0
      ],
      [
        -347.7600402832031,
        -2297.0,
        620.0
      ],
      [
        -327.0,
        -2238.0,
        641.0
      ],
      [
        -327.0,
        -2237.0,
        641.0
      ],
      [
        -318.5,
        -2238.0,
        637.0
      ],
      [
        -318.5,
        -2286.84716796875,
        637.0
      ],
      [
        -318.5,
        -2238.0,
        637.0
      ],
      [
        -318.5,
        -2238.0,
        638.002197265625
      ],
      [
        -327.0,
        -2225.433349609375,
        637.4000244140625
      ],
      [
        -327.0,
        -2221.608642578125,
        637.4000244140625
      ],
      [
        -318.5,
        -2217.43115234375,
        637.4000244140625
      ],
      [
        -318.5,
        -2221.69384765625,
        637.4000244140625
      ],
      [
        -318.5,
        -2221.69384765625,
        637.4000244140625
      ],
      [
        -318.5,
        -2225.153564453125,
        637.4000244140625
      ],
      [
        -318.5,
        -2225.153564453125,
        637.4000244140625
      ],
      [
        -318.5,
        -2227.60009765625,
        637.4000244140625
      ],
      [
        -318.5,
        -2227.60009765625,
        637.4000244140625
      ],
      [
        -318.5,
        -2234.0,
        637.4000244140625
      ],
      [
        -327.0,
        -2221.608642578125,
        637.4000244140625
      ],
      [
        -327.0,
        -2221.360595703125,
        638.1636352539062
      ],
      [
        -327.0,
        -2221.360595703125,
        638.1636352539062
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -327.0,
        -2237.0,
        641.0
      ],
      [
        -324.0,
        -2237.0,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -326.0,
        -2234.0,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -327.0,
        -2225.433349609375,
        641.0
      ],
      [
        -327.0,
        -2225.433349609375,
        637.4000244140625
      ],
      [
        -324.0,
        -2237.0,
        641.0
      ],
      [
        -324.0,
        -2234.0,
        641.0
      ],
      [
        -318.5,
        -2217.43115234375,
        637.4000244140625
      ],
      [
        -319.199951171875,
        -2217.199951171875,
        641.0
      ],
      [
        -318.5,
        -2217.43115234375,
        641.0
      ],
      [
        -318.5,
        -2234.0,
        638.002197265625
      ],
      [
        -318.5,
        -2237.0,
        638.002197265625
      ],
      [
        -318.5,
        -2237.0,
        638.002197265625
      ],
      [
        -318.5,
        -2238.0,
        638.002197265625
      ],
      [
        -327.0,
        -2288.647216796875,
        638.0
      ],
      [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      [
        -318.5,
        -2287.84716796875,
        638.0
      ],
      [
        -327.0,
        -2288.647216796875,
        638.0
      ],
      [
        -318.5,
        -2287.84716796875,
        638.0
      ],
      [
        -318.5,
        -2297.0,
        638.0
      ],
      [
        -327.0,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2286.84716796875,
        637.0
      ],
      [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        641.0
      ],
      [
        -376.84716796875,
        -2285.141845703125,
        641.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        641.0
      ],
      [
        -376.0,
        -2258.5,
        641.0
      ],
      [
        -376.0,
        -2258.5,
        641.0
      ],
      [
        -358.822265625,
        -2239.822265625,
        641.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        641.0
      ],
      [
        -361.64453125,
        -2242.9482421875,
        641.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        629.0
      ],
      [
        -365.4676818847656,
        -2235.382080078125,
        629.0
      ],
      [
        -367.16650390625,
        -2239.11083984375,
        641.0
      ],
      [
        -367.16650390625,
        -2239.11083984375,
        629.0
      ],
      [
        -420.0,
        -2268.0,
        629.0
      ],
      [
        -406.0,
        -2268.0,
        629.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      [
        -397.0,
        -2295.0,
        629.0
      ],
      [
        -397.0,
        -2293.0,
        629.0
      ],
      [
        -397.0,
        -2293.0,
        629.0
      ],
      [
        -397.0,
        -2281.5,
        629.0
      ],
      [
        -397.0,
        -2277.0634765625,
        626.9635009765625
      ],
      [
        -397.0,
        -2277.0634765625,
        629.0
      ],
      [
        -403.75439453125,
        -2269.844970703125,
        629.0
      ],
      [
        -403.75439453125,
        -2269.844970703125,
        629.0
      ],
      [
        -406.0,
        -2268.0,
        629.0
      ],
      [
        -398.335205078125,
        -2277.95556640625,
        629.0
      ],
      [
        -397.0,
        -2281.5,
        629.0
      ],
      [
        -398.335205078125,
        -2277.95556640625,
        629.0
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      [
        -401.5,
        -2257.5,
        641.0
      ],
      [
        -400.9930114746094,
        -2268.0,
        641.0
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      [
        -376.5,
        -2232.5,
        641.0
      ],
      [
        -376.5,
        -2232.5,
        641.0
      ],
      [
        -386.067138671875,
        -2234.403076171875,
        641.0
      ],
      [
        -401.5,
        -2257.5,
        641.0
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        641.0
      ],
      [
        -394.177734375,
        -2239.822265625,
        641.0
      ],
      [
        -386.067138671875,
        -2234.403076171875,
        641.0
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        641.0
      ],
      [
        -394.177734375,
        -2239.822265625,
        641.0
      ],
      [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      [
        -369.155029296875,
        -2237.72900390625,
        641.0
      ],
      [
        -369.155029296875,
        -2237.72900390625,
        641.0
      ],
      [
        -400.6428527832031,
        -2257.5,
        641.0
      ],
      [
        -398.80499267578125,
        -2266.7392578125,
        641.0
      ],
      [
        -398.80499267578125,
        -2266.7392578125,
        641.0
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      [
        -398.80499267578125,
        -2248.2607421875,
        641.0
      ],
      [
        -400.6428527832031,
        -2257.5,
        641.0
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        641.0
      ],
      [
        -398.80499267578125,
        -2248.2607421875,
        641.0
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        641.0
      ],
      [
        -394.177734375,
        -2275.177734375,
        641.0
      ],
      [
        -397.0,
        -2277.0634765625,
        629.0
      ],
      [
        -394.177734375,
        -2275.177734375,
        641.0
      ],
      [
        -397.0,
        -2277.0634765625,
        641.0
      ],
      [
        -402.50714111328125,
        -2269.01171875,
        641.0
      ],
      [
        -397.08795166015625,
        -2277.122314453125,
        641.0
      ],
      [
        -397.08795166015625,
        -2277.122314453125,
        641.0
      ],
      [
        -402.50714111328125,
        -2269.01171875,
        641.0
      ],
      [
        -329.705322265625,
        -2238.0,
        641.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        641.0
      ],
      [
        -367.88818359375,
        -2263.512939453125,
        641.0
      ],
      [
        -376.84716796875,
        -2285.141845703125,
        641.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        637.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        641.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        637.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        620.0
      ],
      [
        -341.8866882324219,
        -2297.0,
        626.0
      ],
      [
        -347.1125793457031,
        -2297.0,
        620.0
      ],
      [
        -345.90008544921875,
        -2274.0,
        626.5
      ],
      [
        -331.9084167480469,
        -2290.865966796875,
        620.4541625976562
      ],
      [
        -331.0000915527344,
        -2289.23388671875,
        620.0
      ],
      [
        -341.8866882324219,
        -2297.0,
        628.7296142578125
      ],
      [
        -341.8866882324219,
        -2297.0,
        626.0
      ],
      [
        -330.682861328125,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -330.682861328125,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -341.8866882324219,
        -2297.0,
        637.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        637.0
      ],
      [
        -341.8866882324219,
        -2297.0,
        637.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        638.0
      ],
      [
        -327.6781921386719,
        -2297.0,
        638.0
      ],
      [
        -327.6781921386719,
        -2297.0,
        638.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        637.0
      ],
      [
        -328.7605895996094,
        -2297.0,
        638.0
      ],
      [
        -329.705322265625,
        -2238.0,
        641.0
      ],
      [
        -327.0,
        -2238.0,
        641.0
      ],
      [
        -318.5,
        -2238.0,
        652.0
      ],
      [
        -318.5,
        -2238.0,
        653.0
      ],
      [
        -318.5,
        -2238.0,
        709.0
      ],
      [
        -318.5,
        -2238.0,
        712.0
      ],
      [
        -318.5,
        -2238.0,
        709.0
      ],
      [
        -318.5,
        -2238.0,
        653.0
      ],
      [
        -318.5,
        -2214.479736328125,
        655.5214233398438
      ],
      [
        -318.5,
        -2206.781494140625,
        648.0
      ],
      [
        -330.6023254394531,
        -2179.897705078125,
        642.21435546875
      ],
      [
        -335.6024475097656,
        -2171.237548828125,
        642.2142944335938
      ],
      [
        -335.6023864746094,
        -2171.2373046875,
        642.21435546875
      ],
      [
        -318.5,
        -2206.781494140625,
        648.0
      ],
      [
        -318.5,
        -2211.181396484375,
        641.0
      ],
      [
        -318.5,
        -2217.43115234375,
        653.0
      ],
      [
        -321.661865234375,
        -2237.0,
        652.0
      ],
      [
        -323.04638671875,
        -2234.0,
        652.0
      ],
      [
        -324.1583251953125,
        -2217.77197265625,
        651.0
      ],
      [
        -325.60498046875,
        -2218.606689453125,
        651.0
      ],
      [
        -318.5,
        -2237.0,
        652.0
      ],
      [
        -318.5,
        -2234.0,
        652.0
      ],
      [
        -318.5,
        -2237.0,
        652.0
      ],
      [
        -318.5,
        -2238.0,
        652.0
      ],
      [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      [
        -391.450439453125,
        -2238.0,
        641.0
      ],
      [
        -361.549560546875,
        -2238.0,
        660.0
      ],
      [
        -361.549560546875,
        -2238.0,
        645.0
      ],
      [
        -361.549560546875,
        -2238.0,
        660.0
      ],
      [
        -368.28631591796875,
        -2238.0,
        660.0
      ],
      [
        -368.28631591796875,
        -2238.0,
        660.0
      ],
      [
        -376.39422607421875,
        -2238.0,
        660.0
      ],
      [
        -376.39422607421875,
        -2238.0,
        660.0
      ],
      [
        -384.5644226074219,
        -2238.0,
        660.0
      ],
      [
        -384.5644226074219,
        -2238.0,
        660.0
      ],
      [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      [
        -373.2688293457031,
        -2236.142822265625,
        660.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        660.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        659.1760864257812
      ],
      [
        -361.549560546875,
        -2238.0,
        645.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        645.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        645.0
      ],
      [
        -368.76507568359375,
        -2238.0,
        641.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        658.5
      ],
      [
        -361.549560546875,
        -2238.0,
        655.0
      ],
      [
        -366.8457946777344,
        -2238.0,
        658.5
      ],
      [
        -376.84716796875,
        -2297.0,
        709.0
      ],
      [
        -376.84716796875,
        -2297.0,
        712.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        653.0
      ],
      [
        -376.8470458984375,
        -2297.0,
        653.0
      ],
      [
        -376.84716796875,
        -2297.0,
        709.0
      ],
      [
        -450.5,
        -2297.0,
        666.0
      ],
      [
        -450.5,
        -2297.0,
        644.0
      ],
      [
        -450.5,
        -2297.0,
        708.0
      ],
      [
        -450.5,
        -2297.0,
        666.0
      ],
      [
        -376.84722900390625,
        -2282.430908203125,
        660.0
      ],
      [
        -376.8474426269531,
        -2260.360107421875,
        660.0
      ],
      [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      [
        -376.8474426269531,
        -2260.360107421875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.466796875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.12060546875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.466796875,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.629150390625,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.12060546875,
        660.0
      ],
      [
        -376.8476867675781,
        -2238.0,
        660.0
      ],
      [
        -376.8475036621094,
        -2256.471435546875,
        660.0
      ],
      [
        -376.8475036621094,
        -2256.471435546875,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.629150390625,
        660.0
      ],
      [
        -376.8473815917969,
        -2260.360107421875,
        645.0
      ],
      [
        -376.8473815917969,
        -2260.360107421875,
        641.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        645.0
      ],
      [
        -376.8473815917969,
        -2260.360107421875,
        645.0
      ],
      [
        -376.84722900390625,
        -2282.430908203125,
        660.0
      ],
      [
        -376.84716796875,
        -2282.430908203125,
        645.0
      ],
      [
        -401.5,
        -2257.5,
        644.5
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        644.5
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      [
        -401.5,
        -2257.5,
        644.5
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        644.5
      ],
      [
        -394.177734375,
        -2239.822265625,
        644.5
      ],
      [
        -386.067138671875,
        -2280.596923828125,
        644.5
      ],
      [
        -394.177734375,
        -2275.177734375,
        644.5
      ],
      [
        -394.177734375,
        -2239.822265625,
        644.5
      ],
      [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      [
        -396.8251953125,
        -2249.080810546875,
        644.5
      ],
      [
        -398.5,
        -2257.5,
        644.5
      ],
      [
        -396.8251953125,
        -2249.080810546875,
        644.5
      ],
      [
        -399.596923828125,
        -2247.932861328125,
        644.5
      ],
      [
        -398.5,
        -2257.5,
        644.5
      ],
      [
        -396.8251953125,
        -2265.919189453125,
        644.5
      ],
      [
        -396.8251953125,
        -2265.919189453125,
        644.5
      ],
      [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      [
        -399.5714416503906,
        -2262.88623046875,
        641.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        660.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        660.0
      ],
      [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        660.0
      ],
      [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.371337890625,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.371337890625,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.527099609375,
        660.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        645.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      [
        -374.0327453613281,
        -2256.361083984375,
        641.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        645.0
      ],
      [
        -361.6766052246094,
        -2242.926025390625,
        641.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        660.0
      ],
      [
        -353.4643249511719,
        -2247.841064453125,
        645.0
      ],
      [
        -363.03955078125,
        -2251.807373046875,
        660.0
      ],
      [
        -363.03955078125,
        -2251.807373046875,
        645.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -331.650146484375,
        -2297.0,
        687.5
      ],
      [
        -373.14013671875,
        -2297.0,
        687.5
      ],
      [
        -318.5,
        -2241.699951171875,
        687.5
      ],
      [
        -318.5,
        -2283.3046875,
        687.5
      ],
      [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      [
        -318.5,
        -2273.30517578125,
        704.0
      ],
      [
        -319.5,
        -2273.30517578125,
        704.0
      ],
      [
        -319.5,
        -2273.30517578125,
        704.0
      ],
      [
        -318.5,
        -2273.30517578125,
        704.0
      ],
      [
        -318.5,
        -2273.30517578125,
        712.0
      ],
      [
        -319.5,
        -2273.30517578125,
        712.0
      ],
      [
        -319.5,
        -2284.990966796875,
        694.8182373046875
      ],
      [
        -318.5,
        -2284.990966796875,
        694.8182373046875
      ],
      [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      [
        -319.5,
        -2285.02587890625,
        692.279296875
      ],
      [
        -318.5,
        -2283.304931640625,
        687.5
      ],
      [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      [
        -319.5,
        -2283.304931640625,
        687.5
      ],
      [
        -318.5,
        -2285.09130859375,
        687.5
      ],
      [
        -319.5,
        -2285.09130859375,
        687.5
      ],
      [
        -331.6534423828125,
        -2297.0,
        694.0
      ],
      [
        -331.6534118652344,
        -2296.0,
        694.0
      ],
      [
        -341.6532897949219,
        -2296.0,
        704.0
      ],
      [
        -341.6533203125,
        -2297.0,
        704.0
      ],
      [
        -341.6533203125,
        -2297.0,
        704.0
      ],
      [
        -341.6532897949219,
        -2296.0,
        704.0
      ],
      [
        -341.6532897949219,
        -2296.0,
        712.0
      ],
      [
        -331.6534118652344,
        -2296.0,
        694.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        694.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        687.5
      ],
      [
        -331.6534118652344,
        -2296.0,
        687.5
      ],
      [
        -376.840087890625,
        -2297.0,
        692.0
      ],
      [
        -376.840087890625,
        -2296.0,
        692.0
      ],
      [
        -373.14013671875,
        -2297.0,
        690.0
      ],
      [
        -329.9324951171875,
        -2291.9130859375,
        692.2789306640625
      ],
      [
        -323.0456848144531,
        -2285.02587890625,
        692.2792358398438
      ],
      [
        -323.0456848144531,
        -2285.02587890625,
        692.2792358398438
      ],
      [
        -319.5,
        -2285.02587890625,
        692.2792358398438
      ],
      [
        -319.5,
        -2283.304931640625,
        690.98876953125
      ],
      [
        -319.5,
        -2285.060546875,
        689.7472534179688
      ],
      [
        -331.6534118652344,
        -2296.0,
        690.606201171875
      ],
      [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      [
        -329.8670349121094,
        -2291.940185546875,
        687.5
      ],
      [
        -323.0185852050781,
        -2285.09130859375,
        687.5
      ],
      [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      [
        -321.2324523925781,
        -2283.304931640625,
        687.5
      ],
      [
        -321.3250732421875,
        -2283.304931640625,
        692.279296875
      ],
      [
        -323.0185852050781,
        -2285.09130859375,
        687.5
      ],
      [
        -376.840087890625,
        -2294.0,
        687.5
      ],
      [
        -321.5,
        -2238.0,
        687.5
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        652.024169921875
      ],
      [
        -351.062744140625,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -357.6902160644531,
        -2260.25,
        649.0
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        657.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        657.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        657.0
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        649.0
      ],
      [
        -353.80792236328125,
        -2250.87744140625,
        649.0
      ],
      [
        -357.6902160644531,
        -2260.25,
        649.0
      ],
      [
        -351.062744140625,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -353.80792236328125,
        -2250.87744140625,
        649.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        649.4808959960938
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        652.024169921875
      ],
      [
        -318.5,
        -2287.30517578125,
        655.0
      ],
      [
        -327.6531982421875,
        -2297.0,
        655.0
      ],
      [
        -318.5,
        -2297.0,
        655.0
      ],
      [
        -331.0533142089844,
        -2291.44873046875,
        660.0
      ],
      [
        -323.50994873046875,
        -2283.905029296875,
        660.0
      ],
      [
        -330.6533203125,
        -2297.0,
        658.0
      ],
      [
        -327.6531982421875,
        -2297.0,
        655.0
      ],
      [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      [
        -318.5,
        -2287.30517578125,
        655.0
      ],
      [
        -331.0533752441406,
        -2297.0,
        660.0
      ],
      [
        -330.6533203125,
        -2297.0,
        658.0
      ],
      [
        -331.0533142089844,
        -2291.44873046875,
        660.0
      ],
      [
        -323.50994873046875,
        -2283.905029296875,
        660.0
      ],
      [
        -318.5,
        -2284.30517578125,
        658.0
      ],
      [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      [
        -318.5,
        -2241.699951171875,
        687.5
      ],
      [
        -318.5,
        -2238.0,
        670.5
      ],
      [
        -376.840087890625,
        -2297.0,
        670.5
      ],
      [
        -373.14013671875,
        -2297.0,
        687.5
      ],
      [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2278.30517578125,
        663.0
      ],
      [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        674.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        684.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        664.0
      ],
      [
        -333.6534423828125,
        -2297.0,
        674.0
      ],
      [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      [
        -318.5,
        -2283.304931640625,
        684.0
      ],
      [
        -321.9739990234375,
        -2281.304931640625,
        664.0
      ],
      [
        -321.98919677734375,
        -2281.304931640625,
        674.0
      ],
      [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      [
        -331.8057861328125,
        -2297.0,
        664.0
      ],
      [
        -318.5,
        -2283.14208984375,
        673.786865234375
      ],
      [
        -318.5,
        -2283.152587890625,
        664.0
      ],
      [
        -318.5,
        -2281.304931640625,
        664.0
      ],
      [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      [
        -321.8964538574219,
        -2285.09130859375,
        687.5
      ],
      [
        -329.8162841796875,
        -2297.0,
        683.786865234375
      ],
      [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      [
        -318.5,
        -2285.14208984375,
        683.786865234375
      ],
      [
        -318.5,
        -2283.14208984375,
        673.786865234375
      ],
      [
        -318.5,
        -2285.14208984375,
        683.786865234375
      ],
      [
        -318.5,
        -2283.304931640625,
        684.0
      ],
      [
        -322.76873779296875,
        -2283.304931640625,
        687.5
      ],
      [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      [
        -321.587158203125,
        -2278.30517578125,
        664.0
      ],
      [
        -321.587158203125,
        -2278.30517578125,
        663.0
      ],
      [
        -318.5,
        -2278.30517578125,
        663.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        684.0
      ],
      [
        -331.6533508300781,
        -2292.18994140625,
        687.5
      ],
      [
        -336.6533203125,
        -2293.371826171875,
        664.0
      ],
      [
        -336.6533203125,
        -2297.0,
        664.0
      ],
      [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      [
        -336.6533203125,
        -2293.371826171875,
        663.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        663.0
      ],
      [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      [
        33.723262786865234,
        -1359.1781005859375,
        100.52681732177734
      ],
      [
        -315.951416015625,
        -2234.0,
        637.4000244140625
      ],
      [
        -318.5,
        -2232.9443359375,
        637.4000244140625
      ],
      [
        -312.0,
        -2235.636962890625,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      [
        -315.951416015625,
        -2234.0,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      [
        -315.951416015625,
        -2234.0,
        652.0
      ],
      [
        -216.0,
        -2275.4013671875,
        641.0
      ],
      [
        -216.0,
        -2275.4013671875,
        644.5
      ],
      [
        -216.0,
        -2275.4013671875,
        626.0
      ],
      [
        -216.0,
        -2275.4013671875,
        641.0
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        626.0
      ],
      [
        -230.83712768554688,
        -2269.255615234375,
        626.0
      ],
      [
        -230.8371124267578,
        -2269.255615234375,
        626.0
      ],
      [
        -216.0,
        -2275.4013671875,
        626.0
      ],
      [
        -216.0,
        -2275.4013671875,
        644.5
      ],
      [
        -230.83712768554688,
        -2269.255615234375,
        644.5
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        641.0
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        640.1338500976562
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        626.0
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        640.1338500976562
      ],
      [
        -230.8371124267578,
        -2269.255615234375,
        644.5
      ],
      [
        -230.83712768554688,
        -2269.255615234375,
        641.0
      ],
      [
        -230.8371124267578,
        -2269.255615234375,
        641.0
      ],
      [
        -231.29664611816406,
        -2269.0654296875,
        641.0
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        629.0
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        660.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        660.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        660.0
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        660.0
      ],
      [
        -257.08013916015625,
        -2258.385498046875,
        660.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        660.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        660.0
      ],
      [
        -257.08013916015625,
        -2258.385498046875,
        660.0
      ],
      [
        -258.46417236328125,
        -2257.812255859375,
        660.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        660.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        660.0
      ],
      [
        -258.46417236328125,
        -2257.812255859375,
        660.0
      ],
      [
        -259.0816955566406,
        -2257.556396484375,
        660.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        660.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        660.0
      ],
      [
        -259.08172607421875,
        -2257.556396484375,
        660.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        660.0
      ],
      [
        -257.08013916015625,
        -2258.385498046875,
        629.0
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        629.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        629.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        629.0
      ],
      [
        -258.46417236328125,
        -2257.812255859375,
        629.0
      ],
      [
        -257.08013916015625,
        -2258.385498046875,
        629.0
      ],
      [
        -260.59014892578125,
        -2256.931640625,
        629.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        629.0
      ],
      [
        -259.08172607421875,
        -2257.556396484375,
        629.0
      ],
      [
        -258.46417236328125,
        -2257.812255859375,
        629.0
      ],
      [
        -259.9747314453125,
        -2257.1865234375,
        629.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        629.0
      ],
      [
        -259.5284729003906,
        -2257.371337890625,
        629.0
      ],
      [
        -259.0816955566406,
        -2257.556396484375,
        629.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        629.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        645.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        645.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        645.0
      ],
      [
        -261.96685791015625,
        -2256.361328125,
        645.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        629.0
      ],
      [
        -274.32330322265625,
        -2242.92578125,
        645.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        645.0
      ],
      [
        -282.5357971191406,
        -2247.84130859375,
        660.0
      ],
      [
        -267.2978515625,
        -2237.05126953125,
        660.0
      ],
      [
        -267.2978515625,
        -2237.05126953125,
        658.788330078125
      ],
      [
        -267.2978515625,
        -2237.05126953125,
        658.5
      ],
      [
        -267.2978515625,
        -2237.05126953125,
        658.5
      ],
      [
        -259.5,
        -2232.624755859375,
        655.1456909179688
      ],
      [
        -265.29681396484375,
        -2236.653076171875,
        658.5
      ],
      [
        -265.29681396484375,
        -2236.653076171875,
        658.5
      ],
      [
        -265.29681396484375,
        -2236.653076171875,
        660.0
      ],
      [
        -259.36029052734375,
        -2232.52783203125,
        655.0
      ],
      [
        -259.5,
        -2232.624755859375,
        655.1456909179688
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        645.0
      ],
      [
        -239.1532440185547,
        -2265.810791015625,
        645.0
      ],
      [
        -238.1428680419922,
        -2260.731689453125,
        645.0
      ],
      [
        -236.38156127929688,
        -2266.958984375,
        640.0
      ],
      [
        -239.1532440185547,
        -2265.810791015625,
        643.5
      ],
      [
        -239.1532440185547,
        -2265.810791015625,
        643.5
      ],
      [
        -239.1532440185547,
        -2265.810791015625,
        645.0
      ],
      [
        -262.7317199707031,
        -2236.142822265625,
        660.0
      ],
      [
        -236.9537353515625,
        -2278.4306640625,
        641.0
      ],
      [
        -233.04330444335938,
        -2269.31201171875,
        626.5756225585938
      ],
      [
        -233.04330444335938,
        -2269.31201171875,
        640.4593505859375
      ],
      [
        -231.54293823242188,
        -2270.314453125,
        641.0
      ],
      [
        -233.04330444335938,
        -2269.31201171875,
        640.4593505859375
      ],
      [
        -233.04330444335938,
        -2269.31201171875,
        626.5756225585938
      ],
      [
        -237.4330596923828,
        -2272.2451171875,
        642.4797973632812
      ],
      [
        -237.4330596923828,
        -2272.2451171875,
        627.7879028320312
      ],
      [
        -272.96026611328125,
        -2251.8076171875,
        645.0
      ],
      [
        -260.7434387207031,
        -2256.8681640625,
        629.0
      ],
      [
        -272.96026611328125,
        -2251.8076171875,
        660.0
      ],
      [
        -260.7434387207031,
        -2256.8681640625,
        660.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -259.15283203125,
        -2297.0,
        709.0
      ],
      [
        -259.15283203125,
        -2297.0,
        712.0
      ],
      [
        -259.15283203125,
        -2297.0,
        637.0
      ],
      [
        -259.15283203125,
        -2297.0,
        653.0
      ],
      [
        -259.15283203125,
        -2297.0,
        637.0
      ],
      [
        -259.15283203125,
        -2297.0,
        620.0
      ],
      [
        -259.15283203125,
        -2297.0,
        709.0
      ],
      [
        -259.15283203125,
        -2297.0,
        653.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        637.0
      ],
      [
        -294.1133117675781,
        -2297.0,
        637.0
      ],
      [
        -288.8874206542969,
        -2297.0,
        620.0
      ],
      [
        -288.2392272949219,
        -2297.0,
        620.0
      ],
      [
        -259.15283203125,
        -2297.0,
        620.0
      ],
      [
        -288.2392272949219,
        -2297.0,
        620.0
      ],
      [
        -288.8874206542969,
        -2297.0,
        620.0
      ],
      [
        -294.1133117675781,
        -2297.0,
        626.0
      ],
      [
        -290.0999450683594,
        -2274.0,
        626.5
      ],
      [
        -304.9999084472656,
        -2289.23388671875,
        620.0
      ],
      [
        -304.0915832519531,
        -2290.865966796875,
        620.4541625976562
      ],
      [
        -305.317138671875,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -294.1133117675781,
        -2297.0,
        626.0
      ],
      [
        -294.1133117675781,
        -2297.0,
        628.7296752929688
      ],
      [
        -305.317138671875,
        -2292.359130859375,
        634.9540405273438
      ],
      [
        -294.1133117675781,
        -2297.0,
        637.0
      ],
      [
        -262.849853515625,
        -2297.0,
        687.5
      ],
      [
        -304.68994140625,
        -2297.0,
        687.5
      ],
      [
        -304.6982421875,
        -2296.0,
        694.0
      ],
      [
        -304.6982421875,
        -2297.0,
        694.0
      ],
      [
        -294.6982421875,
        -2297.0,
        704.0
      ],
      [
        -294.6982116699219,
        -2296.0,
        704.0
      ],
      [
        -294.6982116699219,
        -2296.0,
        704.0
      ],
      [
        -294.6982421875,
        -2297.0,
        704.0
      ],
      [
        -294.6981506347656,
        -2296.0,
        712.0
      ],
      [
        -304.6982421875,
        -2297.0,
        687.5
      ],
      [
        -304.6982421875,
        -2297.0,
        694.0
      ],
      [
        -304.6982421875,
        -2296.0,
        694.0
      ],
      [
        -304.6982421875,
        -2296.0,
        687.5
      ],
      [
        -262.849853515625,
        -2297.0,
        690.0
      ],
      [
        -259.14990234375,
        -2296.0,
        692.0
      ],
      [
        -259.14990234375,
        -2297.0,
        692.0
      ],
      [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      [
        -317.0,
        -2273.30517578125,
        704.0
      ],
      [
        -317.0,
        -2273.30517578125,
        704.0
      ],
      [
        -317.0,
        -2273.30517578125,
        712.0
      ],
      [
        -317.0,
        -2284.990966796875,
        694.8182373046875
      ],
      [
        -317.0,
        -2285.02587890625,
        692.279296875
      ],
      [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      [
        -318.5,
        -2283.304931640625,
        687.5
      ],
      [
        -317.0,
        -2283.304931640625,
        687.5
      ],
      [
        -317.0,
        -2285.09130859375,
        687.5
      ],
      [
        -318.5,
        -2285.09130859375,
        687.5
      ],
      [
        -313.3061218261719,
        -2285.026123046875,
        692.2791748046875
      ],
      [
        -306.4190673828125,
        -2291.912841796875,
        692.2791137695312
      ],
      [
        -313.3061218261719,
        -2285.026123046875,
        692.2791748046875
      ],
      [
        -317.0,
        -2285.02587890625,
        692.2792358398438
      ],
      [
        -317.0,
        -2283.304931640625,
        690.8841552734375
      ],
      [
        -317.0,
        -2285.06201171875,
        689.6419067382812
      ],
      [
        -304.6982421875,
        -2296.0,
        690.6058349609375
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      [
        -313.3332214355469,
        -2285.091552734375,
        687.5
      ],
      [
        -306.4845275878906,
        -2291.93994140625,
        687.5
      ],
      [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      [
        -315.027099609375,
        -2283.304931640625,
        692.2791137695312
      ],
      [
        -315.1195983886719,
        -2283.304931640625,
        687.5
      ],
      [
        -313.3332214355469,
        -2285.091552734375,
        687.5
      ],
      [
        -259.14990234375,
        -2294.0,
        687.5
      ],
      [
        -315.0,
        -2238.0,
        687.5
      ],
      [
        -284.937255859375,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        652.0241088867188
      ],
      [
        -278.30975341796875,
        -2260.25,
        649.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        657.0
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        657.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        649.0
      ],
      [
        -278.3096923828125,
        -2260.25,
        649.0
      ],
      [
        -282.19207763671875,
        -2250.877197265625,
        649.0
      ],
      [
        -282.19207763671875,
        -2250.87744140625,
        649.0
      ],
      [
        -284.937255859375,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        652.0241088867188
      ],
      [
        -284.665771484375,
        -2246.958984375,
        649.480712890625
      ],
      [
        -307.2394104003906,
        -2297.0,
        638.0
      ],
      [
        -308.3218078613281,
        -2297.0,
        638.0
      ],
      [
        -308.3218078613281,
        -2297.0,
        638.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        637.0
      ],
      [
        -307.2394104003906,
        -2297.0,
        638.0
      ],
      [
        -308.698486328125,
        -2297.0,
        655.0
      ],
      [
        -312.84185791015625,
        -2283.9052734375,
        660.0
      ],
      [
        -305.2982482910156,
        -2291.448486328125,
        660.0
      ],
      [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      [
        -308.698486328125,
        -2297.0,
        655.0
      ],
      [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      [
        -312.84185791015625,
        -2283.9052734375,
        660.0
      ],
      [
        -305.2982482910156,
        -2291.448486328125,
        660.0
      ],
      [
        -305.6983642578125,
        -2297.0,
        658.0
      ],
      [
        -305.2983093261719,
        -2297.0,
        660.0
      ],
      [
        -262.849853515625,
        -2297.0,
        687.5
      ],
      [
        -259.14990234375,
        -2297.0,
        670.5
      ],
      [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        674.0
      ],
      [
        -304.6982421875,
        -2297.0,
        684.0
      ],
      [
        -302.69805908203125,
        -2292.984619140625,
        664.0
      ],
      [
        -302.69805908203125,
        -2292.969482421875,
        674.0
      ],
      [
        -304.5352783203125,
        -2297.0,
        673.786865234375
      ],
      [
        -304.5457763671875,
        -2297.0,
        664.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        664.0
      ],
      [
        -302.6981201171875,
        -2297.0,
        674.0
      ],
      [
        -314.4552917480469,
        -2285.091552734375,
        687.5
      ],
      [
        -306.535400390625,
        -2297.0,
        683.786865234375
      ],
      [
        -304.5352783203125,
        -2297.0,
        673.786865234375
      ],
      [
        -304.6982421875,
        -2297.0,
        684.0
      ],
      [
        -304.6982421875,
        -2292.18994140625,
        687.5
      ],
      [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      [
        -299.6982421875,
        -2293.37109375,
        664.0
      ],
      [
        -299.6982421875,
        -2293.37109375,
        663.0
      ],
      [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      [
        -313.58343505859375,
        -2283.30517578125,
        687.5
      ],
      [
        -314.76513671875,
        -2278.30517578125,
        664.0
      ],
      [
        -314.76513671875,
        -2278.30517578125,
        663.0
      ],
      [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      [
        -306.300048828125,
        -2388.5,
        618.0
      ],
      [
        -329.699951171875,
        -2388.5,
        618.0
      ],
      [
        -341.653564453125,
        -2306.507568359375,
        712.0
      ],
      [
        -327.900390625,
        -2320.260009765625,
        712.0
      ],
      [
        -341.6533203125,
        -2297.0,
        712.0
      ],
      [
        -341.653564453125,
        -2306.507568359375,
        712.0
      ],
      [
        -327.900390625,
        -2320.260009765625,
        712.0
      ],
      [
        -318.5,
        -2320.260009765625,
        746.0
      ],
      [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      [
        -324.4444885253906,
        -2323.7158203125,
        750.0
      ],
      [
        -318.5,
        -2323.7158203125,
        750.0
      ],
      [
        -318.5,
        -2320.260009765625,
        746.0
      ],
      [
        -345.0754699707031,
        -2303.0859375,
        750.0
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        729.9866943359375
      ],
      [
        -376.53070068359375,
        -2349.27978515625,
        730.4326171875
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        730.43212890625
      ],
      [
        -378.0864562988281,
        -2347.723876953125,
        729.9866943359375
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        729.9866943359375
      ],
      [
        -367.3384094238281,
        -2358.47216796875,
        730.43212890625
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        730.431640625
      ],
      [
        -368.8941650390625,
        -2356.916259765625,
        729.9866943359375
      ],
      [
        -365.3587341308594,
        -2353.380859375,
        750.0
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -365.3663330078125,
        -2353.388427734375,
        749.95703125
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -363.802978515625,
        -2354.936767578125,
        750.0
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -374.551025390625,
        -2344.1884765625,
        750.0
      ],
      [
        -374.5586242675781,
        -2344.196044921875,
        749.9569702148438
      ],
      [
        -374.55853271484375,
        -2344.196044921875,
        749.9569091796875
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -372.9952087402344,
        -2345.744140625,
        750.0
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -318.5,
        -2370.3154296875,
        750.0
      ],
      [
        -318.5,
        -2375.3154296875,
        730.0
      ],
      [
        -318.5,
        -2375.3154296875,
        730.0
      ],
      [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      [
        -318.5,
        -2355.699951171875,
        716.0
      ],
      [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      [
        -308.450927734375,
        -2320.260009765625,
        712.0
      ],
      [
        -294.6983947753906,
        -2306.50732421875,
        712.0
      ],
      [
        -308.450927734375,
        -2320.260009765625,
        712.0
      ],
      [
        -294.6983947753906,
        -2306.50732421875,
        712.0
      ],
      [
        -294.69818115234375,
        -2297.0,
        712.0
      ],
      [
        -291.2275390625,
        -2303.036376953125,
        750.0
      ],
      [
        -311.9065246582031,
        -2323.7158203125,
        750.0
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2302.39990234375,
        750.0
      ],
      [
        -239.53173828125,
        -2302.39990234375,
        729.9784545898438
      ],
      [
        -239.53695678710938,
        -2302.39990234375,
        729.9993286132812
      ],
      [
        -239.53695678710938,
        -2302.39990234375,
        729.9993286132812
      ],
      [
        -244.5365753173828,
        -2302.39990234375,
        749.9978637695312
      ],
      [
        -244.5365753173828,
        -2304.60009765625,
        749.9978637695312
      ],
      [
        -244.53712463378906,
        -2304.60009765625,
        750.0
      ],
      [
        -244.5365753173828,
        -2304.60009765625,
        749.9978637695312
      ],
      [
        -239.53695678710938,
        -2304.60009765625,
        729.9993286132812
      ],
      [
        -264.5076904296875,
        -2342.855712890625,
        750.0
      ],
      [
        -239.537109375,
        -2302.39990234375,
        712.0
      ],
      [
        -402.5,
        -2339.0,
        655.25
      ],
      [
        -414.66668701171875,
        -2339.0,
        637.0
      ],
      [
        -414.66668701171875,
        -2313.0,
        637.0
      ],
      [
        -414.66668701171875,
        -2339.0,
        637.0
      ],
      [
        -435.0,
        -2335.0,
        657.0000610351562
      ],
      [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      [
        -377.6445617675781,
        -2388.5,
        625.5
      ],
      [
        -382.04193115234375,
        -2388.5,
        625.5
      ],
      [
        -382.04193115234375,
        -2388.5,
        625.5
      ],
      [
        -403.5135803222656,
        -2388.5,
        625.5
      ],
      [
        -400.74029541015625,
        -2388.5,
        636.5
      ],
      [
        -382.7750244140625,
        -2388.5,
        636.5
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        636.5
      ],
      [
        -351.0,
        -2348.5,
        636.5
      ],
      [
        -385.26593017578125,
        -2312.803955078125,
        637.0
      ],
      [
        -375.2789001464844,
        -2322.791015625,
        637.0
      ],
      [
        -385.26593017578125,
        -2312.803955078125,
        637.0
      ],
      [
        -385.26580810546875,
        -2312.803955078125,
        654.5
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      [
        -398.77520751953125,
        -2336.800048828125,
        654.5
      ],
      [
        -400.5,
        -2337.514404296875,
        653.6070556640625
      ],
      [
        -375.2789611816406,
        -2322.791015625,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        652.0
      ],
      [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      [
        -375.2789611816406,
        -2322.791015625,
        638.002197265625
      ],
      [
        -371.0,
        -2368.5,
        636.5
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        636.5
      ],
      [
        -348.558349609375,
        -2349.511474609375,
        660.5
      ],
      [
        -340.2848815917969,
        -2357.784912109375,
        660.5
      ],
      [
        -332.0113830566406,
        -2366.058349609375,
        660.5
      ],
      [
        -340.2848815917969,
        -2357.784912109375,
        660.5
      ],
      [
        -318.5,
        -2388.5,
        672.0
      ],
      [
        -318.5,
        -2382.64208984375,
        668.0
      ],
      [
        -318.5,
        -2382.64208984375,
        668.0
      ],
      [
        -318.5,
        -2379.56982421875,
        667.2396240234375
      ],
      [
        -329.5697326660156,
        -2368.5,
        664.5
      ],
      [
        -332.0113830566406,
        -2366.058349609375,
        664.5
      ],
      [
        -332.0113830566406,
        -2366.058349609375,
        663.8956909179688
      ],
      [
        -332.0113830566406,
        -2366.058349609375,
        664.5
      ],
      [
        -330.8524169921875,
        -2367.21728515625,
        664.5
      ],
      [
        -330.8524169921875,
        -2367.21728515625,
        664.5
      ],
      [
        -329.5697326660156,
        -2368.5,
        664.5
      ],
      [
        -332.30828857421875,
        -2371.658447265625,
        660.5
      ],
      [
        -332.0113830566406,
        -2366.058349609375,
        660.5
      ],
      [
        -351.0,
        -2388.5,
        636.5
      ],
      [
        -336.85791015625,
        -2382.64208984375,
        636.5
      ],
      [
        -349.6744689941406,
        -2348.3955078125,
        641.228271484375
      ],
      [
        -350.6807556152344,
        -2348.474853515625,
        636.5
      ],
      [
        -351.0,
        -2348.5,
        636.5
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.5668334960938
      ],
      [
        -349.6341552734375,
        -2348.435791015625,
        641.0
      ],
      [
        -345.1445007324219,
        -2352.92529296875,
        641.0
      ],
      [
        -340.2848815917969,
        -2357.784912109375,
        641.0
      ],
      [
        -345.1445007324219,
        -2352.92529296875,
        641.0
      ],
      [
        -340.2848815917969,
        -2357.784912109375,
        641.0
      ],
      [
        -335.42535400390625,
        -2362.64453125,
        641.0
      ],
      [
        -370.5,
        -2368.5,
        636.5
      ],
      [
        -364.78857421875,
        -2354.71142578125,
        636.5
      ],
      [
        -331.5,
        -2368.5,
        636.5
      ],
      [
        -332.8179931640625,
        -2371.68212890625,
        636.5
      ],
      [
        -337.21142578125,
        -2382.28857421875,
        636.5
      ],
      [
        -332.8179931640625,
        -2371.68212890625,
        636.5
      ],
      [
        -351.0,
        -2349.0,
        636.5
      ],
      [
        -354.1820068359375,
        -2350.31787109375,
        636.5
      ],
      [
        -354.1820068359375,
        -2350.31787109375,
        636.5
      ],
      [
        -364.78857421875,
        -2354.71142578125,
        636.5
      ],
      [
        -345.1445007324219,
        -2352.92529296875,
        641.0
      ],
      [
        -351.0,
        -2349.0,
        636.5
      ],
      [
        -347.8179626464844,
        -2350.31787109375,
        636.5
      ],
      [
        -347.66375732421875,
        -2350.406005859375,
        636.5726928710938
      ],
      [
        -347.7051086425781,
        -2350.36474609375,
        636.5
      ],
      [
        -347.66375732421875,
        -2350.406005859375,
        636.5726928710938
      ],
      [
        -347.8179626464844,
        -2350.31787109375,
        636.5
      ],
      [
        -331.5,
        -2368.5,
        636.5
      ],
      [
        -335.42535400390625,
        -2362.64453125,
        641.0
      ],
      [
        -332.9061279296875,
        -2365.163818359375,
        636.5726928710938
      ],
      [
        -332.8180236816406,
        -2365.318115234375,
        636.5
      ],
      [
        -332.8180236816406,
        -2365.318115234375,
        636.5
      ],
      [
        -332.9061279296875,
        -2365.163818359375,
        636.5726928710938
      ],
      [
        -332.8647766113281,
        -2365.205078125,
        636.5
      ],
      [
        -349.1820983886719,
        -2348.887939453125,
        638.422119140625
      ],
      [
        -348.8448181152344,
        -2349.22509765625,
        636.5
      ],
      [
        -350.2032165527344,
        -2348.669921875,
        636.5
      ],
      [
        -350.6807556152344,
        -2348.474853515625,
        636.5
      ],
      [
        -349.7230529785156,
        -2348.3994140625,
        641.0
      ],
      [
        -349.6344299316406,
        -2348.435546875,
        641.0
      ],
      [
        -337.21142578125,
        -2382.28857421875,
        636.5
      ],
      [
        -336.85791015625,
        -2382.64208984375,
        636.5
      ],
      [
        -336.85791015625,
        -2382.64208984375,
        641.0
      ],
      [
        -371.0,
        -2368.5,
        641.0
      ],
      [
        -371.0,
        -2368.5,
        636.5
      ],
      [
        -370.5,
        -2368.5,
        636.5
      ],
      [
        -362.7281494140625,
        -2383.64208984375,
        651.5
      ],
      [
        -353.4143981933594,
        -2387.5,
        651.5
      ],
      [
        -348.558349609375,
        -2349.511474609375,
        660.5
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.5668334960938
      ],
      [
        -349.6744689941406,
        -2348.3955078125,
        641.228271484375
      ],
      [
        -401.0699157714844,
        -2297.0,
        630.3251953125
      ],
      [
        -401.0,
        -2297.06982421875,
        630.5
      ],
      [
        -318.5,
        -2382.64208984375,
        632.5
      ],
      [
        -318.5,
        -2388.5,
        626.0
      ],
      [
        -393.9701843261719,
        -2374.79443359375,
        635.5650634765625
      ],
      [
        -332.0112609863281,
        -2366.05859375,
        632.5
      ],
      [
        -330.8524475097656,
        -2367.217529296875,
        632.5
      ],
      [
        -330.8524475097656,
        -2367.217529296875,
        632.5
      ],
      [
        -329.5699157714844,
        -2368.5,
        632.5
      ],
      [
        -329.5699157714844,
        -2368.5,
        632.5
      ],
      [
        -318.5,
        -2379.56982421875,
        632.5
      ],
      [
        -318.5,
        -2382.64208984375,
        632.5
      ],
      [
        -380.4822998046875,
        -2386.2900390625,
        628.4520874023438
      ],
      [
        -382.4294128417969,
        -2385.861328125,
        625.5
      ],
      [
        -381.01177978515625,
        -2384.444580078125,
        630.5
      ],
      [
        -377.6445617675781,
        -2388.5,
        625.5
      ],
      [
        -380.4822998046875,
        -2386.2900390625,
        628.4520874023438
      ],
      [
        -377.022216796875,
        -2388.5,
        625.9999389648438
      ],
      [
        -392.1980895996094,
        -2373.7158203125,
        632.5
      ],
      [
        -384.3669128417969,
        -2382.64208984375,
        632.5
      ],
      [
        -381.01177978515625,
        -2384.444580078125,
        630.5
      ],
      [
        -393.9701843261719,
        -2374.79443359375,
        635.5650634765625
      ],
      [
        -393.40887451171875,
        -2376.37939453125,
        636.5
      ],
      [
        -391.0771789550781,
        -2379.037109375,
        636.5
      ],
      [
        -335.924560546875,
        -2380.388916015625,
        635.0
      ],
      [
        -335.924560546875,
        -2380.388916015625,
        635.0
      ],
      [
        -335.8646240234375,
        -2379.037109375,
        636.5
      ],
      [
        -348.55865478515625,
        -2349.51123046875,
        635.0
      ],
      [
        -332.0112609863281,
        -2366.05859375,
        635.0
      ],
      [
        -332.0112609863281,
        -2366.05859375,
        635.0
      ],
      [
        -332.0112609863281,
        -2366.05859375,
        632.5
      ],
      [
        -348.55865478515625,
        -2349.51123046875,
        635.0
      ],
      [
        -348.83966064453125,
        -2349.230224609375,
        636.4706420898438
      ],
      [
        -348.83966064453125,
        -2349.230224609375,
        636.4706420898438
      ],
      [
        -350.20343017578125,
        -2348.669921875,
        636.5
      ],
      [
        -400.0160827636719,
        -2354.59619140625,
        632.9597778320312
      ],
      [
        -400.0160827636719,
        -2354.59619140625,
        632.9597778320312
      ],
      [
        -398.60003662109375,
        -2364.682861328125,
        636.5
      ],
      [
        -382.7750244140625,
        -2388.5,
        636.5
      ],
      [
        -381.958251953125,
        -2388.5,
        635.5790405273438
      ],
      [
        -381.958251953125,
        -2388.5,
        635.5790405273438
      ],
      [
        -371.4205322265625,
        -2388.5,
        630.5
      ],
      [
        -371.4205322265625,
        -2388.5,
        630.5
      ],
      [
        -374.943603515625,
        -2388.5,
        627.6697387695312
      ],
      [
        -401.0699157714844,
        -2297.0,
        630.6048583984375
      ],
      [
        -401.0,
        -2297.06982421875,
        630.5
      ],
      [
        -403.9261779785156,
        -2386.733154296875,
        634.8892822265625
      ],
      [
        -405.0,
        -2381.504638671875,
        636.5
      ],
      [
        -400.74029541015625,
        -2388.5,
        636.5
      ],
      [
        -403.9261779785156,
        -2386.733154296875,
        634.8892822265625
      ],
      [
        -403.21514892578125,
        -2388.5,
        633.8226928710938
      ],
      [
        -403.5135803222656,
        -2388.5,
        625.5
      ],
      [
        -406.28662109375,
        -2388.5,
        630.5
      ],
      [
        -406.28662109375,
        -2388.5,
        630.5
      ],
      [
        -326.0799560546875,
        -2357.199951171875,
        632.5
      ],
      [
        -336.7502746582031,
        -2354.61767578125,
        632.5
      ],
      [
        -336.7502746582031,
        -2354.61767578125,
        632.5
      ],
      [
        -336.7180480957031,
        -2354.695556640625,
        632.5
      ],
      [
        -330.6719055175781,
        -2357.2001953125,
        632.5
      ],
      [
        -336.7180480957031,
        -2354.695556640625,
        632.5
      ],
      [
        -329.7441711425781,
        -2357.58447265625,
        632.5
      ],
      [
        -329.7441711425781,
        -2357.58447265625,
        632.5
      ],
      [
        -326.0799560546875,
        -2357.199951171875,
        632.5
      ],
      [
        -318.5,
        -2360.3408203125,
        632.5
      ],
      [
        -318.5,
        -2362.241943359375,
        632.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        650.49609375
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -326.0799560546875,
        -2357.199951171875,
        664.5
      ],
      [
        -318.5,
        -2368.5,
        664.5
      ],
      [
        -318.5,
        -2360.3408203125,
        664.5
      ],
      [
        -318.5,
        -2368.5,
        664.5
      ],
      [
        -326.0799560546875,
        -2357.199951171875,
        664.5
      ],
      [
        -336.1815490722656,
        -2355.99072265625,
        664.5
      ],
      [
        -348.4485778808594,
        -2349.621337890625,
        660.5
      ],
      [
        -336.1562194824219,
        -2356.052001953125,
        664.5
      ],
      [
        -349.67431640625,
        -2348.3955078125,
        658.4395141601562
      ],
      [
        -349.6743469238281,
        -2348.3955078125,
        656.0
      ],
      [
        -318.5,
        -2368.5,
        632.5
      ],
      [
        -318.5,
        -2368.5,
        632.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -318.5,
        -2355.699951171875,
        618.0
      ],
      [
        -318.5,
        -2355.699951171875,
        620.0
      ],
      [
        -318.5,
        -2355.699951171875,
        709.0
      ],
      [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      [
        -318.5,
        -2355.699951171875,
        620.0
      ],
      [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      [
        -318.5,
        -2355.699951171875,
        659.0
      ],
      [
        -318.5,
        -2355.699951171875,
        709.0
      ],
      [
        -318.5,
        -2355.699951171875,
        649.5
      ],
      [
        -318.5,
        -2357.199951171875,
        632.5
      ],
      [
        -318.5,
        -2357.199951171875,
        664.5
      ],
      [
        -318.5,
        -2355.699951171875,
        656.0
      ],
      [
        -318.5,
        -2357.199951171875,
        664.5
      ],
      [
        -318.5,
        -2357.199951171875,
        632.5
      ],
      [
        -318.5,
        -2339.699951171875,
        620.0
      ],
      [
        -318.5,
        -2310.989013671875,
        620.0
      ],
      [
        -318.5,
        -2339.699951171875,
        620.0
      ],
      [
        -318.5,
        -2339.699951171875,
        618.0
      ],
      [
        -318.5,
        -2308.989013671875,
        626.0
      ],
      [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      [
        -318.5,
        -2310.989013671875,
        620.0
      ],
      [
        -318.5,
        -2308.989013671875,
        626.0
      ],
      [
        -318.5,
        -2310.260009765625,
        687.5
      ],
      [
        -318.5,
        -2352.0,
        687.5
      ],
      [
        -318.5,
        -2310.260009765625,
        694.0
      ],
      [
        -319.5,
        -2310.260009765625,
        694.0
      ],
      [
        -319.5,
        -2320.260009765625,
        704.0
      ],
      [
        -318.5,
        -2320.260009765625,
        704.0
      ],
      [
        -318.5,
        -2320.260009765625,
        704.0
      ],
      [
        -319.5,
        -2320.260009765625,
        704.0
      ],
      [
        -319.5,
        -2320.260009765625,
        712.0
      ],
      [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      [
        -319.5,
        -2310.260009765625,
        694.0
      ],
      [
        -318.5,
        -2310.260009765625,
        694.0
      ],
      [
        -318.5,
        -2310.260009765625,
        687.5
      ],
      [
        -319.5,
        -2310.260009765625,
        687.5
      ],
      [
        -318.5,
        -2355.699951171875,
        692.0
      ],
      [
        -319.5,
        -2355.699951171875,
        692.0
      ],
      [
        -318.5,
        -2352.0,
        690.0
      ],
      [
        -331.6534729003906,
        -2298.5,
        694.0
      ],
      [
        -341.6533508300781,
        -2298.5,
        704.0
      ],
      [
        -341.6533508300781,
        -2298.5,
        704.0
      ],
      [
        -341.6533508300781,
        -2298.5,
        712.0
      ],
      [
        -331.6534423828125,
        -2297.0,
        687.5
      ],
      [
        -331.6534729003906,
        -2298.5,
        694.0
      ],
      [
        -331.6534729003906,
        -2298.5,
        687.5
      ],
      [
        -376.840087890625,
        -2298.5,
        692.0
      ],
      [
        -331.6534729003906,
        -2298.5,
        691.2666625976562
      ],
      [
        -319.5,
        -2310.260009765625,
        690.9890747070312
      ],
      [
        -331.653564453125,
        -2302.365234375,
        687.5
      ],
      [
        -323.75830078125,
        -2310.260009765625,
        687.5
      ],
      [
        -323.75830078125,
        -2310.260009765625,
        687.5
      ],
      [
        -331.653564453125,
        -2302.365234375,
        687.5
      ],
      [
        -376.840087890625,
        -2300.5,
        687.5
      ],
      [
        -321.5,
        -2355.699951171875,
        687.5
      ],
      [
        -318.5,
        -2350.796142578125,
        659.0
      ],
      [
        -318.5,
        -2355.699951171875,
        659.0
      ],
      [
        -318.5,
        -2355.699951171875,
        656.0
      ],
      [
        -318.5,
        -2355.03271484375,
        656.0
      ],
      [
        -348.55615234375,
        -2342.578125,
        656.0
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      [
        -318.5,
        -2355.699951171875,
        649.5
      ],
      [
        -318.5,
        -2355.03271484375,
        649.5
      ],
      [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        649.5
      ],
      [
        -318.5,
        -2350.796142578125,
        656.0
      ],
      [
        -318.5,
        -2350.796142578125,
        656.0
      ],
      [
        -318.5,
        -2350.796142578125,
        659.0
      ],
      [
        -318.5,
        -2350.796142578125,
        649.5
      ],
      [
        -318.5,
        -2350.796142578125,
        649.5
      ],
      [
        -318.5,
        -2350.796142578125,
        649.2933349609375
      ],
      [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      [
        -318.5,
        -2307.989013671875,
        638.0
      ],
      [
        -318.5,
        -2307.989013671875,
        638.0
      ],
      [
        -318.5,
        -2297.0,
        638.0
      ],
      [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      [
        -318.5,
        -2350.796142578125,
        646.5
      ],
      [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      [
        -318.5,
        -2350.796142578125,
        646.5
      ],
      [
        -318.5,
        -2306.260009765625,
        655.0
      ],
      [
        -318.5,
        -2297.0,
        655.0
      ],
      [
        -323.42706298828125,
        -2309.4599609375,
        659.0
      ],
      [
        -330.8533630371094,
        -2302.033935546875,
        659.0
      ],
      [
        -318.5,
        -2309.260009765625,
        658.0
      ],
      [
        -318.5,
        -2306.260009765625,
        655.0
      ],
      [
        -330.8533630371094,
        -2302.033935546875,
        659.0
      ],
      [
        -330.85333251953125,
        -2297.0,
        659.0
      ],
      [
        -318.5,
        -2309.4599609375,
        659.0
      ],
      [
        -318.5,
        -2309.260009765625,
        658.0
      ],
      [
        -323.42706298828125,
        -2309.4599609375,
        659.0
      ],
      [
        -318.5,
        -2355.699951171875,
        670.5
      ],
      [
        -318.5,
        -2352.0,
        687.5
      ],
      [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      [
        -318.5,
        -2310.260009765625,
        663.0
      ],
      [
        -318.5,
        -2312.26025390625,
        674.0
      ],
      [
        -318.5,
        -2310.260009765625,
        684.0
      ],
      [
        -318.5,
        -2312.26025390625,
        674.0
      ],
      [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      [
        -318.5,
        -2310.260009765625,
        684.0
      ],
      [
        -322.7683410644531,
        -2310.260009765625,
        687.5
      ],
      [
        -321.58660888671875,
        -2315.26025390625,
        664.0
      ],
      [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      [
        -321.58660888671875,
        -2315.26025390625,
        663.0
      ],
      [
        -331.6535339355469,
        -2301.375244140625,
        687.5
      ],
      [
        -336.6533203125,
        -2300.194091796875,
        664.0
      ],
      [
        -336.6533203125,
        -2300.194091796875,
        663.0
      ],
      [
        -318.5,
        -2310.260009765625,
        663.0
      ],
      [
        -253.95806884765625,
        -2388.5,
        625.5
      ],
      [
        -258.3554382324219,
        -2388.5,
        625.5
      ],
      [
        -232.48643493652344,
        -2388.5,
        625.5
      ],
      [
        -253.95806884765625,
        -2388.5,
        625.5
      ],
      [
        -228.66668701171875,
        -2329.0,
        648.0
      ],
      [
        -226.3333282470703,
        -2331.5,
        644.5
      ],
      [
        -224.33334350585938,
        -2331.5,
        641.5
      ],
      [
        -226.3333282470703,
        -2331.5,
        644.5
      ],
      [
        -222.0,
        -2316.5,
        638.0
      ],
      [
        -222.0,
        -2329.0,
        638.0
      ],
      [
        -222.0,
        -2329.0,
        638.0
      ],
      [
        -224.33334350585938,
        -2331.5,
        641.5
      ],
      [
        -253.22499084472656,
        -2388.5,
        636.5
      ],
      [
        -235.2596893310547,
        -2388.5,
        636.5
      ],
      [
        -265.0,
        -2368.5,
        636.5
      ],
      [
        -270.85791015625,
        -2354.35791015625,
        636.5
      ],
      [
        -245.0,
        -2331.5,
        641.5001220703125
      ],
      [
        -245.0,
        -2329.0,
        638.0
      ],
      [
        -255.0,
        -2331.5,
        652.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        652.0
      ],
      [
        -257.640869140625,
        -2315.35498046875,
        652.0
      ],
      [
        -255.0,
        -2313.5,
        652.0
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        636.5
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        660.5
      ],
      [
        -270.85791015625,
        -2354.35791015625,
        636.5
      ],
      [
        -283.98394775390625,
        -2368.5,
        660.5
      ],
      [
        -284.2815246582031,
        -2369.218505859375,
        660.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        660.5
      ],
      [
        -285.0,
        -2370.952880859375,
        660.5
      ],
      [
        -284.2815246582031,
        -2369.218505859375,
        660.5
      ],
      [
        -285.0,
        -2370.952880859375,
        660.5
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        660.5
      ],
      [
        -283.2654724121094,
        -2366.765380859375,
        660.5
      ],
      [
        -283.2654724121094,
        -2366.765380859375,
        660.5
      ],
      [
        -283.98394775390625,
        -2368.5,
        660.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        670.2453002929688
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        660.5
      ],
      [
        -292.2682189941406,
        -2388.5,
        672.0
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        670.2453002929688
      ],
      [
        -277.76873779296875,
        -2353.4951171875,
        641.0
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        641.0
      ],
      [
        -283.98394775390625,
        -2368.5,
        641.0
      ],
      [
        -284.2815246582031,
        -2369.218505859375,
        641.0
      ],
      [
        -284.2815246582031,
        -2369.218505859375,
        641.0
      ],
      [
        -285.0,
        -2370.952880859375,
        641.0
      ],
      [
        -285.0,
        -2370.952880859375,
        641.0
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        641.0
      ],
      [
        -277.76873779296875,
        -2353.4951171875,
        641.0
      ],
      [
        -283.2654724121094,
        -2366.765380859375,
        641.0
      ],
      [
        -283.2654724121094,
        -2366.765380859375,
        641.0
      ],
      [
        -283.98394775390625,
        -2368.5,
        641.0
      ],
      [
        -265.5,
        -2368.5,
        636.5
      ],
      [
        -266.8179931640625,
        -2365.31787109375,
        636.5
      ],
      [
        -266.8179931640625,
        -2365.31787109375,
        636.5
      ],
      [
        -271.21142578125,
        -2354.71142578125,
        636.5
      ],
      [
        -285.0,
        -2388.5,
        641.0
      ],
      [
        -285.0,
        -2388.5,
        636.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        636.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        641.0
      ],
      [
        -277.76873779296875,
        -2353.4951171875,
        641.0
      ],
      [
        -277.47943115234375,
        -2352.796875,
        638.5452270507812
      ],
      [
        -271.21142578125,
        -2354.71142578125,
        636.5
      ],
      [
        -277.47943115234375,
        -2352.796875,
        638.5452270507812
      ],
      [
        -277.2384338378906,
        -2352.21484375,
        636.5
      ],
      [
        -265.5,
        -2368.5,
        636.5
      ],
      [
        -265.0,
        -2368.5,
        636.5
      ],
      [
        -265.0,
        -2368.5,
        641.0
      ],
      [
        -273.2718200683594,
        -2383.64208984375,
        651.5
      ],
      [
        -287.4140319824219,
        -2387.5,
        651.5
      ],
      [
        -287.4140319824219,
        -2387.5,
        651.5
      ],
      [
        -287.4140319824219,
        -2387.5,
        641.0
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        641.0
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        651.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        651.5
      ],
      [
        -290.4967041015625,
        -2384.22314453125,
        651.5
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        651.5
      ],
      [
        -242.0298614501953,
        -2374.79443359375,
        635.5650024414062
      ],
      [
        -254.04176330566406,
        -2388.5,
        635.5790405273438
      ],
      [
        -253.22499084472656,
        -2388.5,
        636.5
      ],
      [
        -242.59121704101562,
        -2376.379638671875,
        636.5
      ],
      [
        -242.0298614501953,
        -2374.79443359375,
        635.5650024414062
      ],
      [
        -257.68475341796875,
        -2386.160400390625,
        630.5
      ],
      [
        -256.7156677246094,
        -2388.5,
        634.290283203125
      ],
      [
        -254.04176330566406,
        -2388.5,
        635.5790405273438
      ],
      [
        -257.68475341796875,
        -2386.160400390625,
        630.5
      ],
      [
        -257.5509033203125,
        -2386.483642578125,
        629.6275634765625
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        635.0
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        628.8513793945312
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        635.0
      ],
      [
        -264.5794677734375,
        -2388.5,
        630.5
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        635.0
      ],
      [
        -277.0616760253906,
        -2351.7880859375,
        635.0
      ],
      [
        -271.46136474609375,
        -2354.10791015625,
        636.5
      ],
      [
        -264.5794677734375,
        -2388.5,
        630.5
      ],
      [
        -261.05633544921875,
        -2388.5,
        627.6697387695312
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        628.8513793945312
      ],
      [
        -292.2682189941406,
        -2388.5,
        626.0
      ],
      [
        -253.57131958007812,
        -2385.862060546875,
        625.5
      ],
      [
        -258.3554382324219,
        -2388.5,
        625.5
      ],
      [
        -235.98391723632812,
        -2354.59619140625,
        632.9597778320312
      ],
      [
        -237.40000915527344,
        -2364.68310546875,
        636.5
      ],
      [
        -235.98391723632812,
        -2354.59619140625,
        632.9597778320312
      ],
      [
        -230.99996948242188,
        -2381.504638671875,
        636.5
      ],
      [
        -232.0738067626953,
        -2386.7333984375,
        634.8892822265625
      ],
      [
        -232.0738067626953,
        -2386.7333984375,
        634.8892822265625
      ],
      [
        -235.2596893310547,
        -2388.5,
        636.5
      ],
      [
        -232.7848358154297,
        -2388.5,
        633.8226928710938
      ],
      [
        -229.71337890625,
        -2388.5,
        630.5
      ],
      [
        -232.48643493652344,
        -2388.5,
        625.5
      ],
      [
        -229.71337890625,
        -2388.5,
        630.5
      ],
      [
        -309.9205017089844,
        -2357.199951171875,
        632.5
      ],
      [
        -299.2498779296875,
        -2354.6181640625,
        632.5
      ],
      [
        -299.2498779296875,
        -2354.6181640625,
        632.5
      ],
      [
        -299.2821044921875,
        -2354.696044921875,
        632.5
      ],
      [
        -305.326904296875,
        -2357.2001953125,
        632.5
      ],
      [
        -299.2821044921875,
        -2354.696044921875,
        632.5
      ],
      [
        -306.2557678222656,
        -2357.5849609375,
        632.5
      ],
      [
        -309.9205017089844,
        -2357.199951171875,
        632.5
      ],
      [
        -306.2557678222656,
        -2357.5849609375,
        632.5
      ],
      [
        -318.5,
        -2362.656494140625,
        632.5
      ],
      [
        -318.5,
        -2360.755126953125,
        632.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        650.4846801757812
      ],
      [
        -291.20379638671875,
        -2385.93017578125,
        632.5
      ],
      [
        -299.14208984375,
        -2354.35791015625,
        661.0
      ],
      [
        -309.9205017089844,
        -2357.199951171875,
        664.5
      ],
      [
        -318.5,
        -2360.755126953125,
        664.5
      ],
      [
        -299.14208984375,
        -2354.35791015625,
        661.0
      ],
      [
        -300.2277526855469,
        -2354.7890625,
        661.106689453125
      ],
      [
        -300.2277526855469,
        -2354.7890625,
        661.106689453125
      ],
      [
        -306.3016662597656,
        -2356.683837890625,
        661.57568359375
      ],
      [
        -309.9205017089844,
        -2357.199951171875,
        664.5
      ],
      [
        -306.3016662597656,
        -2356.683837890625,
        661.57568359375
      ],
      [
        -308.676513671875,
        -2356.683837890625,
        661.57568359375
      ],
      [
        -303.69171142578125,
        -2371.658447265625,
        660.5
      ],
      [
        -306.30224609375,
        -2356.494140625,
        660.5
      ],
      [
        -306.30224609375,
        -2356.494140625,
        660.5
      ],
      [
        -308.21893310546875,
        -2356.494140625,
        660.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -288.2933349609375,
        -2348.23828125,
        656.0
      ],
      [
        -299.14208984375,
        -2382.64208984375,
        641.0
      ],
      [
        -304.6982421875,
        -2298.5,
        694.0
      ],
      [
        -294.6982727050781,
        -2298.5,
        704.0
      ],
      [
        -294.6982727050781,
        -2298.5,
        704.0
      ],
      [
        -294.6982116699219,
        -2298.5,
        712.0
      ],
      [
        -304.6982421875,
        -2298.5,
        694.0
      ],
      [
        -304.6982421875,
        -2297.0,
        687.5
      ],
      [
        -304.6982421875,
        -2298.5,
        687.5
      ],
      [
        -259.14990234375,
        -2298.5,
        692.0
      ],
      [
        -317.0,
        -2310.260009765625,
        694.0
      ],
      [
        -317.0,
        -2320.260009765625,
        704.0
      ],
      [
        -317.0,
        -2320.260009765625,
        704.0
      ],
      [
        -317.0,
        -2320.260009765625,
        712.0
      ],
      [
        -318.5,
        -2310.260009765625,
        687.5
      ],
      [
        -317.0,
        -2310.260009765625,
        694.0
      ],
      [
        -317.0,
        -2310.260009765625,
        687.5
      ],
      [
        -317.0,
        -2355.699951171875,
        692.0
      ],
      [
        -304.6982421875,
        -2298.5,
        691.2669067382812
      ],
      [
        -317.0,
        -2310.260009765625,
        690.8838500976562
      ],
      [
        -312.59326171875,
        -2310.26025390625,
        687.5
      ],
      [
        -304.6982421875,
        -2302.365234375,
        687.5
      ],
      [
        -312.59326171875,
        -2310.26025390625,
        687.5
      ],
      [
        -304.6982421875,
        -2302.365234375,
        687.5
      ],
      [
        -259.14990234375,
        -2300.5,
        687.5
      ],
      [
        -315.0,
        -2355.699951171875,
        687.5
      ],
      [
        -318.5,
        -2355.44482421875,
        656.0
      ],
      [
        -287.44775390625,
        -2342.578125,
        656.0
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        656.0
      ],
      [
        -318.5,
        -2355.44482421875,
        649.5
      ],
      [
        -287.44775390625,
        -2342.578125,
        649.5
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        649.5
      ],
      [
        -318.5,
        -2350.8935546875,
        649.5
      ],
      [
        -318.2650146484375,
        -2350.796142578125,
        649.5
      ],
      [
        -318.2650146484375,
        -2350.796142578125,
        649.5
      ],
      [
        -305.4984436035156,
        -2302.03369140625,
        659.0
      ],
      [
        -312.92449951171875,
        -2309.460205078125,
        659.0
      ],
      [
        -312.92449951171875,
        -2309.460205078125,
        659.0
      ],
      [
        -318.5,
        -2309.4599609375,
        659.0
      ],
      [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      [
        -305.4984436035156,
        -2302.03369140625,
        659.0
      ],
      [
        -304.6982421875,
        -2301.375,
        687.5
      ],
      [
        -299.6982421875,
        -2300.193359375,
        664.0
      ],
      [
        -299.6982421875,
        -2300.193359375,
        663.0
      ],
      [
        -313.5832824707031,
        -2310.26025390625,
        687.5
      ],
      [
        -314.7646179199219,
        -2315.26025390625,
        664.0
      ],
      [
        -314.7646179199219,
        -2315.26025390625,
        663.0
      ],
      [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      [
        -306.300048828125,
        -2388.5,
        608.0
      ],
      [
        -306.300048828125,
        -2388.5,
        618.0
      ],
      [
        -306.300048828125,
        -2388.5,
        608.0
      ],
      [
        -329.699951171875,
        -2388.5,
        618.0
      ],
      [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      [
        -308.0,
        -2424.0,
        620.0
      ],
      [
        -308.0,
        -2424.0,
        625.0
      ],
      [
        -308.0,
        -2424.0,
        625.0
      ],
      [
        -308.0,
        -2424.0,
        638.0
      ],
      [
        -308.0,
        -2424.0,
        603.0
      ],
      [
        -308.0,
        -2424.0,
        620.0
      ],
      [
        -308.0,
        -2424.0,
        603.0
      ],
      [
        -310.0,
        -2424.0,
        603.0
      ],
      [
        -308.0,
        -2424.0,
        638.0
      ],
      [
        -310.0,
        -2424.0,
        638.0
      ],
      [
        -308.0,
        -2416.0,
        620.0
      ],
      [
        -308.0,
        -2416.0,
        625.0
      ],
      [
        -308.0,
        -2416.0,
        625.0
      ],
      [
        -308.0,
        -2416.0,
        638.0
      ],
      [
        -308.0,
        -2416.0,
        603.0
      ],
      [
        -308.0,
        -2416.0,
        620.0
      ],
      [
        -308.0,
        -2416.0,
        603.0
      ],
      [
        -310.0,
        -2416.0,
        603.0
      ],
      [
        -308.0,
        -2416.0,
        638.0
      ],
      [
        -310.0,
        -2416.0,
        638.0
      ],
      [
        -327.0,
        -2424.0,
        620.0
      ],
      [
        -327.0,
        -2424.0,
        625.0
      ],
      [
        -327.0,
        -2424.0,
        638.0
      ],
      [
        -327.0,
        -2424.0,
        625.0
      ],
      [
        -327.0,
        -2424.0,
        620.0
      ],
      [
        -327.0,
        -2424.0,
        603.0
      ],
      [
        -327.0,
        -2424.0,
        603.0
      ],
      [
        -325.0,
        -2424.0,
        603.0
      ],
      [
        -327.0,
        -2424.0,
        638.0
      ],
      [
        -325.0,
        -2424.0,
        638.0
      ],
      [
        -327.0,
        -2416.0,
        620.0
      ],
      [
        -327.0,
        -2416.0,
        625.0
      ],
      [
        -327.0,
        -2416.0,
        638.0
      ],
      [
        -327.0,
        -2416.0,
        625.0
      ],
      [
        -327.0,
        -2416.0,
        620.0
      ],
      [
        -327.0,
        -2416.0,
        603.0
      ],
      [
        -327.0,
        -2416.0,
        603.0
      ],
      [
        -325.0,
        -2416.0,
        603.0
      ],
      [
        -327.0,
        -2416.0,
        638.0
      ],
      [
        -325.0,
        -2416.0,
        638.0
      ],
      [
        -375.7275390625,
        -2406.199951171875,
        626.0
      ],
      [
        -357.0,
        -2406.199951171875,
        626.0
      ],
      [
        -279.0,
        -2406.199951171875,
        626.0
      ],
      [
        -260.2724609375,
        -2406.199951171875,
        626.0
      ],
      [
        -391.4788513183594,
        -2401.318115234375,
        626.0
      ],
      [
        -403.7908935546875,
        -2388.5,
        626.0
      ],
      [
        -244.52114868164062,
        -2401.318115234375,
        626.0
      ],
      [
        -232.20913696289062,
        -2388.5,
        626.0
      ],
      [
        -391.4788513183594,
        -2401.318115234375,
        626.0
      ],
      [
        -375.7275390625,
        -2406.199951171875,
        626.0
      ],
      [
        -260.2724609375,
        -2406.199951171875,
        626.0
      ],
      [
        -244.52114868164062,
        -2401.318115234375,
        626.0
      ],
      [
        -357.0,
        -2406.199951171875,
        626.0
      ],
      [
        -357.0,
        -2391.800048828125,
        626.0
      ],
      [
        -279.0,
        -2406.199951171875,
        626.0
      ],
      [
        -279.0,
        -2391.800048828125,
        626.0
      ],
      [
        -258.97784423828125,
        -2388.5,
        626.0
      ],
      [
        -268.70294189453125,
        -2391.800048828125,
        626.0
      ],
      [
        -268.70294189453125,
        -2391.800048828125,
        626.0
      ],
      [
        -279.0,
        -2391.800048828125,
        626.0
      ],
      [
        -367.29705810546875,
        -2391.800048828125,
        626.0
      ],
      [
        -377.02215576171875,
        -2388.5,
        626.0
      ],
      [
        -357.0,
        -2391.800048828125,
        626.0
      ],
      [
        -367.29705810546875,
        -2391.800048828125,
        626.0
      ],
      [
        -261.7786560058594,
        -2388.5,
        628.25
      ],
      [
        -374.2214660644531,
        -2388.5,
        628.2498779296875
      ],
      [
        -325.9545593261719,
        -2411.5,
        644.904052734375
      ],
      [
        -325.95684814453125,
        -2411.488525390625,
        644.9042358398438
      ],
      [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      [
        -325.95684814453125,
        -2411.488525390625,
        644.9042358398438
      ],
      [
        -348.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -348.0452880859375,
        -2411.5,
        644.90380859375
      ],
      [
        -337.7247619628906,
        -2411.5,
        637.6590576171875
      ],
      [
        -348.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -337.0868225097656,
        -2411.47021484375,
        637.5350341796875
      ],
      [
        -287.95465087890625,
        -2411.5,
        644.9039306640625
      ],
      [
        -287.95697021484375,
        -2411.488525390625,
        644.9041137695312
      ],
      [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      [
        -287.95709228515625,
        -2411.48828125,
        644.9039306640625
      ],
      [
        -310.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -310.0452880859375,
        -2411.5,
        644.90380859375
      ],
      [
        -299.7253112792969,
        -2411.5,
        637.6591796875
      ],
      [
        -310.04296875,
        -2411.48828125,
        644.904052734375
      ],
      [
        -299.0868225097656,
        -2411.47021484375,
        637.5350341796875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31841254234313965,
        -0.7687152028083801,
        -0.5546984672546387
      ],
      "plane_d": -1187.2174072265625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31841254234313965,
        -0.7687151432037354,
        -0.5546985864639282
      ],
      "plane_d": -1389.7275390625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687151432037354,
        0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": 964.0422973632812,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687151432037354,
        -0.31841254234313965,
        -0.5546985864639282
      ],
      "plane_d": -9.744735717773438,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1433.9423828125,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 212.5579833984375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 741.741943359375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883565545082092,
        0.5883404612541199,
        -0.5546999573707581
      ],
      "plane_d": 1641.380615234375,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2388.246826171875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -353.9089050292969,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": 848.115966796875,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -391.462890625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364239811897278,
        -0.536414384841919,
        -0.6515434980392456
      ],
      "plane_d": -934.4630126953125,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -374.6662292480469,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -366.462890625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.725508987903595,
        0.30051371455192566,
        -0.6191350221633911
      ],
      "plane_d": 901.294677734375,
      "bbox_min": [
        -366.462890625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -366.45758056640625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2996884286403656,
        -0.7232757806777954,
        -0.6221407055854797
      ],
      "plane_d": -1312.3388671875,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29901179671287537,
        -0.7216429114341736,
        -0.6243584752082825
      ],
      "plane_d": -1116.3973388671875,
      "bbox_min": [
        -366.45758056640625,
        -2345.3154296875,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2233.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.537109375,
        -2237.298583984375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29953300952911377,
        0.7231412529945374,
        -0.6223718523979187
      ],
      "plane_d": 2200.6015625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        750.0
      ],
      "bbox_max": [
        -269.54083251953125,
        -2237.298583984375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        771.466552734375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2243.083984375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        771.9613037109375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2247.2734375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8323256373405457,
        0.5542869567871094
      ],
      "plane_d": 1522.48095703125,
      "bbox_min": [
        -312.60009765625,
        -2345.309814453125,
        771.9613037109375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2249.2431640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -310.39990234375,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2336.546630859375,
        771.9613037109375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2249.2431640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -289.4108581542969,
        -2336.546630859375,
        774.40380859375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2258.00439453125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -288.7006530761719,
        -2267.52978515625,
        774.40380859375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2258.00439453125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -288.7006530761719,
        -2258.338134765625,
        774.40380859375
      ],
      "bbox_max": [
        -288.3668518066406,
        -2258.00439453125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -279.5075988769531,
        -2267.52978515625,
        774.4052734375
      ],
      "bbox_max": [
        -279.17462158203125,
        -2267.19677734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1843.6842041015625,
      "bbox_min": [
        -289.4108581542969,
        -2336.546630859375,
        774.6267700195312
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -269.5799560546875,
        -2289.39990234375,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1856.6842041015625,
      "bbox_min": [
        -289.4108581542969,
        -2336.546630859375,
        774.6267700195312
      ],
      "bbox_max": [
        -289.2013854980469,
        -2336.337158203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -366.45758056640625,
        -2345.309814453125,
        774.91650390625
      ],
      "bbox_max": [
        -323.39990234375,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -366.4573669433594,
        -2291.60009765625,
        774.91845703125
      ],
      "bbox_max": [
        -366.3931884765625,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -366.45733642578125,
        -2289.39990234375,
        774.9186401367188
      ],
      "bbox_max": [
        -366.3933410644531,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -323.39990234375,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -323.39990234375,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -328.4978942871094,
        -2255.76220703125,
        767.6095581054688
      ],
      "bbox_max": [
        -290.548095703125,
        -2237.298583984375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2249.823974609375,
        767.6395263671875
      ],
      "bbox_max": [
        -310.39990234375,
        -2242.70654296875,
        772.3453979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -276.9150390625,
        -2287.207275390625,
        773.3617553710938
      ],
      "bbox_max": [
        -269.537109375,
        -2269.395263671875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -289.595703125,
        -2277.35400390625,
        763.2664794921875
      ],
      "bbox_max": [
        -270.9585266113281,
        -2249.354736328125,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -288.0400390625,
        -2277.35400390625,
        764.069580078125
      ],
      "bbox_max": [
        -270.9585266113281,
        -2250.077880859375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -280.4033203125,
        -2277.35400390625,
        768.0119018554688
      ],
      "bbox_max": [
        -270.9585266113281,
        -2261.9169921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -280.4033203125,
        -2269.981201171875,
        768.0119018554688
      ],
      "bbox_max": [
        -273.1952209472656,
        -2261.9169921875,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -278.84765625,
        -2269.981201171875,
        768.8150024414062
      ],
      "bbox_max": [
        -273.1952209472656,
        -2264.328857421875,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -318.044921875,
        -2243.923583984375,
        762.81103515625
      ],
      "bbox_max": [
        -305.37646484375,
        -2233.38427734375,
        771.545654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2242.70654296875,
        763.6400146484375
      ],
      "bbox_max": [
        -312.60009765625,
        -2234.285400390625,
        769.6069946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -310.5257873535156,
        -2235.505126953125,
        762.81103515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.46044921875,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -276.9150390625,
        -2324.299072265625,
        773.3629150390625
      ],
      "bbox_max": [
        -269.537109375,
        -2306.487060546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -279.7173156738281,
        -2316.333251953125,
        750.0
      ],
      "bbox_max": [
        -254.44439697265625,
        -2240.368896484375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -271.2099609375,
        -2316.333251953125,
        762.9635620117188
      ],
      "bbox_max": [
        -256.78173828125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -270.9575500488281,
        -2316.333251953125,
        771.5509033203125
      ],
      "bbox_max": [
        -264.36346435546875,
        -2306.487060546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -279.7173156738281,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -259.983154296875,
        -2240.368896484375,
        770.7837524414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        750.0
      ],
      "bbox_max": [
        -271.6867980957031,
        -2242.8798828125,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -279.7173156738281,
        -2251.76953125,
        762.878173828125
      ],
      "bbox_max": [
        -277.746337890625,
        -2248.939453125,
        764.069580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -259.983154296875,
        -2249.561279296875,
        770.7837524414062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        750.0
      ],
      "bbox_max": [
        -262.4944152832031,
        -2252.072265625,
        768.8150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.543212890625,
      "bbox_min": [
        -275.60009765625,
        -2266.036865234375,
        762.878173828125
      ],
      "bbox_max": [
        -268.553955078125,
        -2258.1318359375,
        768.8150024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2289.39990234375,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -257.99652099609375,
        -2291.60009765625,
        750.0
      ],
      "bbox_max": [
        -248.08302307128906,
        -2289.39990234375,
        763.7667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -257.99652099609375,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2289.39990234375,
        763.7667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -256.652587890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2302.39990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -256.652587890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -248.08302307128906,
        -2302.39990234375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        762.8990478515625
      ],
      "bbox_max": [
        -267.76580810546875,
        -2324.589111328125,
        774.96826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1843.6842041015625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        763.1345825195312
      ],
      "bbox_max": [
        -267.76580810546875,
        -2326.144775390625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707072377204895,
        0.7071411609649658,
        -3.234087489545345e-05
      ],
      "plane_d": 1841.579833984375,
      "bbox_min": [
        -269.18792724609375,
        -2336.48583984375,
        763.1345825195312
      ],
      "bbox_max": [
        -267.76580810546875,
        -2335.06396484375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1856.6842041015625,
      "bbox_min": [
        -290.410888671875,
        -2341.3662109375,
        768.4579467773438
      ],
      "bbox_max": [
        -284.3819580078125,
        -2335.337158203125,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320503234863281
      ],
      "plane_d": 1945.785888671875,
      "bbox_min": [
        -328.6674499511719,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2360.500732421875,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        774.9935302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -325.60009765625,
        -2359.388427734375,
        762.8425903320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2359.388427734375,
        763.660400390625
      ],
      "bbox_max": [
        -310.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8323256373405457,
        0.5542869567871094
      ],
      "plane_d": 1522.48095703125,
      "bbox_min": [
        -312.60009765625,
        -2345.24853515625,
        772.5030517578125
      ],
      "bbox_max": [
        -310.39990234375,
        -2343.63720703125,
        774.922607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2353.41796875,
        767.6207275390625
      ],
      "bbox_max": [
        -323.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2352.20166015625,
        768.427490234375
      ],
      "bbox_max": [
        -325.60009765625,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -310.466796875,
        -2358.21826171875,
        762.8425903320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2358.194580078125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707072377204895,
        0.7071411609649658,
        -3.234087489545345e-05
      ],
      "plane_d": 1854.579833984375,
      "bbox_min": [
        -286.084716796875,
        -2354.20166015625,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        770.4290771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -286.084716796875,
        -2351.6904296875,
        750.0
      ],
      "bbox_max": [
        -272.5019836425781,
        -2338.96826171875,
        768.4579467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -286.084716796875,
        -2345.630859375,
        762.878173828125
      ],
      "bbox_max": [
        -278.5615234375,
        -2338.96826171875,
        768.4579467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071413397789001,
        -0.7070721983909607,
        -3.2521289540454745e-05
      ],
      "plane_d": -1843.5880126953125,
      "bbox_min": [
        -271.8075866699219,
        -2345.00927734375,
        750.0
      ],
      "bbox_max": [
        -260.79833984375,
        -2334.860595703125,
        765.6557006835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -271.8075866699219,
        -2336.4384765625,
        762.878173828125
      ],
      "bbox_max": [
        -269.369140625,
        -2334.860595703125,
        763.70361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124768614768982,
        -0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 347.1290283203125,
      "bbox_min": [
        -366.462890625,
        -2287.207275390625,
        773.354248046875
      ],
      "bbox_max": [
        -359.0849609375,
        -2269.395263671875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -374.6662292480469,
        -2316.32958984375,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -374.6662292480469,
        -2304.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -373.4478454589844,
        -2291.60009765625,
        767.5505981445312
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -373.4478454589844,
        -2289.39990234375,
        768.3587646484375
      ],
      "bbox_max": [
        -364.78466796875,
        -2289.39990234375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -373.2669982910156,
        -2304.60009765625,
        767.675048828125
      ],
      "bbox_max": [
        -364.78466796875,
        -2302.39990234375,
        774.9932861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -373.2669982910156,
        -2304.60009765625,
        768.4818725585938
      ],
      "bbox_max": [
        -364.78466796875,
        -2304.60009765625,
        774.9932861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1394.9432373046875,
      "bbox_min": [
        -374.62744140625,
        -2355.012939453125,
        750.0
      ],
      "bbox_max": [
        -356.67095947265625,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -374.62744140625,
        -2344.264892578125,
        750.0
      ],
      "bbox_max": [
        -367.41888427734375,
        -2337.056396484375,
        765.1295166015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1407.9432373046875,
      "bbox_min": [
        -365.43505859375,
        -2355.012939453125,
        750.0
      ],
      "bbox_max": [
        -356.67095947265625,
        -2346.34033203125,
        765.129150390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -365.43505859375,
        -2353.457275390625,
        750.0
      ],
      "bbox_max": [
        -358.3182067871094,
        -2346.34033203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -381.7206726074219,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -367.4798583984375,
        -2347.86572265625,
        764.9998168945312
      ],
      "bbox_max": [
        -346.1705322265625,
        -2326.555908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070843577384949,
        0.7071292400360107,
        -4.7990044549806044e-05
      ],
      "plane_d": 1392.84130859375,
      "bbox_min": [
        -367.4798583984375,
        -2337.1171875,
        765.0001831054688
      ],
      "bbox_max": [
        -356.9188232421875,
        -2326.555908203125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -356.7318115234375,
        -2347.86572265625,
        765.0001220703125
      ],
      "bbox_max": [
        -346.1705322265625,
        -2337.30419921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -372.99517822265625,
        -2353.380859375,
        750.0
      ],
      "bbox_max": [
        -345.014892578125,
        -2325.400390625,
        774.9572143554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.9451904296875,
      "bbox_min": [
        -372.1161804199219,
        -2343.3095703125,
        750.0
      ],
      "bbox_max": [
        -354.207275390625,
        -2325.400390625,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.1161804199219,
        -2343.3095703125,
        750.0
      ],
      "bbox_max": [
        -364.5009765625,
        -2335.694091796875,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -365.35870361328125,
        -2353.380859375,
        750.0
      ],
      "bbox_max": [
        -345.014892578125,
        -2334.5927734375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -362.9237976074219,
        -2352.501953125,
        750.0
      ],
      "bbox_max": [
        -355.30859375,
        -2344.886474609375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -381.7206726074219,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -370.8665771484375,
        -2302.39990234375,
        770.4583129882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -370.8665771484375,
        -2302.39990234375,
        768.4818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -379.4409484863281,
        -2304.60009765625,
        762.7295532226562
      ],
      "bbox_max": [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2349.80126953125,
        770.4036865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -325.60009765625,
        -2366.76416015625,
        750.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2349.80126953125,
        768.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -325.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -323.39990234375,
        -2349.80126953125,
        768.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2370.3154296875,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2357.011474609375,
        765.6173706054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -312.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -310.466796875,
        -2357.011474609375,
        763.660400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1854.4437255859375,
      "bbox_min": [
        -375.442626953125,
        -2257.404296875,
        750.0
      ],
      "bbox_max": [
        -357.59564208984375,
        -2239.557373046875,
        765.0780029296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1856.7244873046875,
      "bbox_min": [
        -375.442626953125,
        -2257.404296875,
        750.0
      ],
      "bbox_max": [
        -368.34393310546875,
        -2250.3056640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071412801742554,
        0.7070722579956055,
        -3.2557567465119064e-05
      ],
      "plane_d": 1841.4437255859375,
      "bbox_min": [
        -366.250244140625,
        -2248.2119140625,
        750.0
      ],
      "bbox_max": [
        -357.59564208984375,
        -2239.557373046875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1843.7244873046875,
      "bbox_min": [
        -366.250244140625,
        -2248.2119140625,
        750.0
      ],
      "bbox_max": [
        -359.15155029296875,
        -2241.11328125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -104.44863891601562,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071124315261841,
        0.7071011066436768,
        5.3263302106643096e-06
      ],
      "plane_d": 1854.46923828125,
      "bbox_min": [
        -366.76959228515625,
        -2266.44921875,
        765.0
      ],
      "bbox_max": [
        -356.1874694824219,
        -2255.866943359375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124768614768982,
        -0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 347.1290283203125,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071124315261841,
        0.7071011066436768,
        5.3263302106643096e-06
      ],
      "plane_d": 1854.46923828125,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        774.9771118164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -387.91162109375,
        -2291.60009765625,
        750.0
      ],
      "bbox_max": [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -371.0527648925781,
        -2289.39990234375,
        768.3587646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1856.7244873046875,
      "bbox_min": [
        -375.396728515625,
        -2269.169921875,
        750.0
      ],
      "bbox_max": [
        -355.0224609375,
        -2250.3515625,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -372.9313659667969,
        -2258.876220703125,
        750.0
      ],
      "bbox_max": [
        -365.316162109375,
        -2251.260986328125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -391.462890625,
        -2304.60009765625,
        750.0
      ],
      "bbox_max": [
        -378.27459716796875,
        -2302.39990234375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5515210628509521,
        0.0,
        -0.8341609835624695
      ],
      "plane_d": 845.5783081054688,
      "bbox_min": [
        -379.342041015625,
        -2304.3212890625,
        762.878173828125
      ],
      "bbox_max": [
        -378.27459716796875,
        -2302.39990234375,
        763.5839233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -366.204345703125,
        -2259.9775390625,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2223.38427734375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -312.60009765625,
        -2236.657470703125,
        750.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2226.935546875,
        763.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2236.657470703125,
        762.878173828125
      ],
      "bbox_max": [
        -310.5257873535156,
        -2235.505126953125,
        763.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -325.60009765625,
        -2235.505126953125,
        750.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2226.935546875,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070724368095398,
        -0.707141101360321,
        -3.2387317332904786e-05
      ],
      "plane_d": -1843.7244873046875,
      "bbox_min": [
        -366.204345703125,
        -2259.9775390625,
        750.0
      ],
      "bbox_max": [
        -345.830078125,
        -2239.603271484375,
        772.5030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -363.7389831542969,
        -2249.683837890625,
        750.0
      ],
      "bbox_max": [
        -356.123779296875,
        -2242.068603515625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2297.0,
      "bbox_min": [
        -680.0,
        -2427.0,
        -100.0
      ],
      "bbox_max": [
        940.0,
        -1182.3604736328125,
        750.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.7071256041526794,
        0.7070879340171814,
        0.0
      ],
      "plane_d": 1375.5595703125,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -345.0753479003906,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -327.900634765625,
        -2273.30517578125,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2273.304931640625,
        746.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -345.0753479003906,
        -2297.0,
        746.0
      ],
      "bbox_max": [
        -341.653076171875,
        -2287.05810546875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8962944149971008,
        -0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": -314.528564453125,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268521428108215,
        -0.9238787889480591,
        0.0
      ],
      "plane_d": -1921.8516845703125,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        -0.38268521428108215,
        0.0
      ],
      "plane_d": -506.7131652832031,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1320.79345703125,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1843.65576171875,
      "bbox_min": [
        -378.97802734375,
        -2246.81591796875,
        712.0
      ],
      "bbox_max": [
        -368.1839599609375,
        -2236.02197265625,
        730.26025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.22998046875,
        -2236.06787109375,
        729.9920043945312
      ],
      "bbox_max": [
        -368.1839599609375,
        -2236.02197265625,
        730.26025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071220278739929,
        -0.7070915102958679,
        0.0
      ],
      "plane_d": -1856.65576171875,
      "bbox_min": [
        -378.97802734375,
        -2246.81591796875,
        712.0
      ],
      "bbox_max": [
        -377.3763427734375,
        -2245.21435546875,
        730.26025390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1854.429931640625,
      "bbox_min": [
        -377.42236328125,
        -2245.26025390625,
        729.9920043945312
      ],
      "bbox_max": [
        -377.3763427734375,
        -2245.21435546875,
        730.26025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1104.3076171875,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1854.429931640625,
      "bbox_min": [
        -378.9320068359375,
        -2250.3515625,
        729.9920043945312
      ],
      "bbox_max": [
        -364.6484375,
        -2236.06787109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1856.6767578125,
      "bbox_min": [
        -378.9320068359375,
        -2250.3515625,
        729.9920043945312
      ],
      "bbox_max": [
        -375.3966369628906,
        -2246.81591796875,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -369.7396240234375,
        -2241.1591796875,
        729.9920043945312
      ],
      "bbox_max": [
        -364.6484375,
        -2236.06787109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1843.6767578125,
      "bbox_min": [
        -369.7396240234375,
        -2241.1591796875,
        729.9920043945312
      ],
      "bbox_max": [
        -366.2042541503906,
        -2237.62353515625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2218.38427734375,
      "bbox_min": [
        -378.9320068359375,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1843.6767578125,
      "bbox_min": [
        -378.9320068359375,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -368.1839599609375,
        -2243.624267578125,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": -2336.262451171875,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2221.36181640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -325.60009765625,
        -2226.935546875,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2226.1279296875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.1839599609375,
        -2243.624267578125,
        712.0
      ],
      "bbox_max": [
        -362.1833190917969,
        -2236.06787109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -367.68017578125,
        -2243.624267578125,
        712.0
      ],
      "bbox_max": [
        -362.1833190917969,
        -2238.12744140625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -364.31005859375,
        -2243.624267578125,
        748.7863159179688
      ],
      "bbox_max": [
        -362.1833190917969,
        -2241.49755859375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        -0.7071060538291931,
        -8.376671758014709e-06
      ],
      "plane_d": -1856.6767578125,
      "bbox_min": [
        -378.9320068359375,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -371.3757019042969,
        -2245.26025390625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1108.3411865234375,
      "bbox_min": [
        -376.87255859375,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -371.3757019042969,
        -2247.31982421875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -376.87255859375,
        -2252.816650390625,
        712.0
      ],
      "bbox_max": [
        -371.3757019042969,
        -2247.31982421875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -373.50244140625,
        -2252.816650390625,
        748.7863159179688
      ],
      "bbox_max": [
        -371.3757019042969,
        -2250.68994140625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2281.239990234375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -396.462890625,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -393.4853515625,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -387.91162109375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5372592806816101,
        0.5372592806816101,
        -0.6501576900482178
      ],
      "plane_d": 1530.2041015625,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -345.0751953125,
        -2290.48046875,
        746.0
      ],
      "bbox_max": [
        -341.653076171875,
        -2284.621826171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.725508987903595,
        0.30051371455192566,
        -0.6191350221633911
      ],
      "plane_d": 901.294677734375,
      "bbox_min": [
        -345.07513427734375,
        -2287.07861328125,
        746.0
      ],
      "bbox_max": [
        -341.653076171875,
        -2284.621826171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.84716796875,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -329.705322265625,
        -2238.0,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070879340171814,
        0.7071256041526794,
        -0.0
      ],
      "plane_d": 1825.6146240234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -294.697998046875,
        -2297.0,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2287.057861328125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.896294891834259,
        -0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": -884.5740356445312,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1770.5133056640625,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268521428108215,
        -0.9238787889480591,
        -0.0
      ],
      "plane_d": -2165.239501953125,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238787889480591,
        -0.38268521428108215,
        -0.0
      ],
      "plane_d": -1094.300048828125,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -1975.0977783203125,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": -55.33412170410156,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -244.53712463378906,
        -2291.60009765625,
        729.9784545898438
      ],
      "bbox_max": [
        -239.53173828125,
        -2289.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -244.53712463378906,
        -2289.39990234375,
        729.9784545898438
      ],
      "bbox_max": [
        -239.53173828125,
        -2289.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2218.38427734375,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -312.60009765625,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2218.38427734375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -267.19580078125,
        -2218.38427734375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": -2336.262451171875,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2221.36181640625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -312.60009765625,
        -2226.935546875,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2226.1279296875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -267.19580078125,
        -2236.833251953125,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6800045967102051,
        -0.6801113486289978,
        0.2739383578300476
      ],
      "plane_d": -1905.728271484375,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        712.0
      ],
      "bbox_max": [
        -267.74560546875,
        -2238.938720703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -273.2424621582031,
        -2244.435791015625,
        748.7863159179688
      ],
      "bbox_max": [
        -271.11572265625,
        -2242.308837890625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -256.44775390625,
        -2246.025634765625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1544.914794921875,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -258.55322265625,
        -2248.131103515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6800045967102051,
        -0.6801113486289978,
        0.2739383578300476
      ],
      "plane_d": -1905.729248046875,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        712.0
      ],
      "bbox_max": [
        -258.55322265625,
        -2248.131103515625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -264.0500793457031,
        -2253.628173828125,
        748.7863159179688
      ],
      "bbox_max": [
        -261.92333984375,
        -2251.501220703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -239.537109375,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -239.537109375,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2289.39990234375,
        729.9993286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2289.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2289.39990234375,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2289.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.961749255657196,
        0.0,
        0.2739313840866089
      ],
      "plane_d": -433.10260009765625,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -248.08302307128906,
        -2291.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2289.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -308.451171875,
        -2290.5283203125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2269.867919921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -308.451171875,
        -2287.078369140625,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2269.867919921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29953300952911377,
        0.7231412529945374,
        -0.6223718523979187
      ],
      "plane_d": 2200.6015625,
      "bbox_min": [
        -308.451171875,
        -2273.305419921875,
        746.0
      ],
      "bbox_max": [
        -305.9817810058594,
        -2269.867919921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -259.15283203125,
        -2297.0,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2285.141845703125,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06365722417831421,
        0.18072637915611267,
        0.9814711809158325
      ],
      "plane_d": 171.79965209960938,
      "bbox_min": [
        -514.914794921875,
        -1567.767822265625,
        0.0
      ],
      "bbox_max": [
        -318.5,
        -1318.5909423828125,
        92.45507049560547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3707151412963867,
        0.5205857157707214,
        0.7691298723220825
      ],
      "plane_d": 561.1250610351562,
      "bbox_min": [
        -414.674072265625,
        -1409.9949951171875,
        0.0
      ],
      "bbox_max": [
        -318.5,
        -1318.5909423828125,
        37.15850067138672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3091984987258911,
        0.4324801564216614,
        0.8469694256782532
      ],
      "plane_d": 459.2151184082031,
      "bbox_min": [
        -402.0465087890625,
        -1409.9949951171875,
        31.013601303100586
      ],
      "bbox_max": [
        -318.5,
        -1351.22705078125,
        37.15850067138672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09095493704080582,
        0.1663801521062851,
        0.9818578362464905
      ],
      "plane_d": 140.3548126220703,
      "bbox_min": [
        -387.214111328125,
        -1567.767822265625,
        65.35711669921875
      ],
      "bbox_max": [
        -318.5,
        -1403.5745849609375,
        92.45507049560547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.091210275888443,
        0.16736166179180145,
        0.9816673398017883
      ],
      "plane_d": 141.69515991210938,
      "bbox_min": [
        -387.214111328125,
        -1453.253662109375,
        65.35711669921875
      ],
      "bbox_max": [
        -318.5,
        -1403.5745849609375,
        70.672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -450.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -318.5,
        -2139.80908203125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -420.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -327.0,
      "bbox_min": [
        -420.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -327.0,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -327.0,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.4734824299812317,
        -0.8377031087875366,
        0.2721542716026306
      ],
      "plane_d": -1879.69091796875,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48331403732299805,
        -0.8377364873886108,
        0.2541753351688385
      ],
      "plane_d": -1865.0765380859375,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -327.0,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -324.0,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -318.5,
        -2234.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -318.5,
        -2237.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -327.0,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.84716796875,
      "bbox_min": [
        -327.0,
        -2286.84716796875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -508.17803955078125,
      "bbox_min": [
        -420.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2220.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -420.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2220.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -420.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -358.822265625,
        -2232.5,
        641.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.0,
      "bbox_min": [
        -420.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -358.822265625,
        -2232.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -420.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -358.822265625,
        -2232.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7360445261001587,
        0.6769331097602844,
        0.0
      ],
      "plane_d": 1252.1007080078125,
      "bbox_min": [
        -376.0,
        -2258.5,
        629.0
      ],
      "bbox_max": [
        -358.822265625,
        -2235.382080078125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -361.6766052246094,
        -2242.9482421875,
        629.0
      ],
      "bbox_max": [
        -361.64453125,
        -2242.926025390625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -367.16650390625,
        -2242.926025390625,
        629.0
      ],
      "bbox_max": [
        -361.6766052246094,
        -2239.11083984375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2295.0,
      "bbox_min": [
        -420.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -365.4676818847656,
        -2232.5,
        641.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 635.5,
      "bbox_min": [
        -417.10009765625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -403.10009765625,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.0,
        -0.5144957304000854
      ],
      "plane_d": 682.0499267578125,
      "bbox_min": [
        -417.10009765625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -403.10009765625,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": -21.26592254638672,
      "bbox_min": [
        -417.10009765625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -403.10009765625,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138115644454956,
        -0.0,
        0.40613847970962524
      ],
      "plane_d": 125.08058166503906,
      "bbox_min": [
        -417.10009765625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -403.10009765625,
        -2295.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138115644454956,
        0.0,
        0.40613847970962524
      ],
      "plane_d": -624.4278564453125,
      "bbox_min": [
        -405.10009765625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -403.10009765625,
        -2295.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -420.0,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -365.4676818847656,
        -2232.5,
        641.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2268.0,
      "bbox_min": [
        -420.0,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -394.177734375,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        627.9925537109375
      ],
      "bbox_max": [
        -399.596923828125,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -397.0,
      "bbox_min": [
        -406.0,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -394.177734375,
        -2268.0,
        629.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 1672.7745361328125,
      "bbox_min": [
        -397.0,
        -2277.0634765625,
        626.9635009765625
      ],
      "bbox_max": [
        -394.177734375,
        -2275.177734375,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -406.0,
        -2281.5,
        626.0
      ],
      "bbox_max": [
        -397.0,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6348146200180054,
        -0.772664487361908,
        -0.0
      ],
      "plane_d": -2010.1378173828125,
      "bbox_min": [
        -406.0,
        -2269.844970703125,
        626.0
      ],
      "bbox_max": [
        -403.75439453125,
        -2268.0,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9358036518096924,
        -0.35252171754837036,
        0.0
      ],
      "plane_d": -1175.7923583984375,
      "bbox_min": [
        -398.335205078125,
        -2281.5,
        626.0
      ],
      "bbox_max": [
        -397.0,
        -2277.0634765625,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 1672.7745361328125,
      "bbox_min": [
        -398.335205078125,
        -2277.95556640625,
        626.0
      ],
      "bbox_max": [
        -397.0,
        -2277.0634765625,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -401.5,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2232.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -400.99310302734375,
        -2268.0,
        629.0
      ],
      "bbox_max": [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -46.6435432434082,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        629.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        629.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -916.6072998046875,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        629.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314864635467529,
        0.5555450320243835,
        0.0
      ],
      "plane_d": 936.2117919921875,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        629.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2234.403076171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -369.155029296875,
        -2239.11083984375,
        629.0
      ],
      "bbox_max": [
        -367.16650390625,
        -2237.72900390625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507419586181641,
        0.149342879652977,
        -0.6434929966926575
      ],
      "plane_d": 1050.4000244140625,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -398.80499267578125,
        -2247.932861328125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264405727386475,
        -0.9238958358764648,
        0.0
      ],
      "plane_d": -1941.6304931640625,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        640.0
      ],
      "bbox_max": [
        -398.80499267578125,
        -2266.7392578125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507328987121582,
        -0.14934109151363373,
        -0.6435039639472961
      ],
      "plane_d": 376.1243591308594,
      "bbox_min": [
        -401.5,
        -2257.5,
        640.0
      ],
      "bbox_max": [
        -398.80499267578125,
        -2247.932861328125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264408707618713,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 2229.75927734375,
      "bbox_min": [
        -399.596923828125,
        -2248.2607421875,
        640.0
      ],
      "bbox_max": [
        -398.80499267578125,
        -2247.932861328125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -397.0,
      "bbox_min": [
        -406.0,
        -2295.0,
        629.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2268.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 2110.74560546875,
      "bbox_min": [
        -397.0,
        -2280.596923828125,
        629.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2275.177734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 1672.7745361328125,
      "bbox_min": [
        -397.0,
        -2277.0634765625,
        629.0
      ],
      "bbox_max": [
        -394.177734375,
        -2275.177734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6348146200180054,
        -0.772664487361908,
        -0.0
      ],
      "plane_d": -2010.1378173828125,
      "bbox_min": [
        -406.0,
        -2269.844970703125,
        629.0
      ],
      "bbox_max": [
        -403.75439453125,
        -2268.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 1672.7745361328125,
      "bbox_min": [
        -403.75439453125,
        -2281.5,
        629.0
      ],
      "bbox_max": [
        -397.0,
        -2269.01171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9358036518096924,
        -0.35252171754837036,
        0.0
      ],
      "plane_d": -1175.7923583984375,
      "bbox_min": [
        -398.335205078125,
        -2281.5,
        629.0
      ],
      "bbox_max": [
        -397.0,
        -2277.95556640625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -403.75439453125,
        -2277.95556640625,
        639.5
      ],
      "bbox_max": [
        -397.08795166015625,
        -2269.01171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1596.748291015625,
      "bbox_min": [
        -403.75439453125,
        -2277.95556640625,
        639.5
      ],
      "bbox_max": [
        -398.335205078125,
        -2269.844970703125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2220.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2225.433349609375,
        637.4000244140625
      ],
      "bbox_max": [
        -327.0,
        -2220.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4734824299812317,
        -0.8377031087875366,
        0.2721542716026306
      ],
      "plane_d": -1879.69091796875,
      "bbox_min": [
        -328.39990234375,
        -2222.39990234375,
        637.4000244140625
      ],
      "bbox_max": [
        -327.0,
        -2221.360595703125,
        638.1636352539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        0.0
      ],
      "plane_d": 376.8710021972656,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -349.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48564356565475464,
        0.0,
        0.8741569519042969
      ],
      "plane_d": -715.6434326171875,
      "bbox_min": [
        -349.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2258.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2266.0,
      "bbox_min": [
        -347.1125793457031,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3630546033382416,
        0.8764746785163879,
        0.31620171666145325
      ],
      "plane_d": 1691.196533203125,
      "bbox_min": [
        -347.1125793457031,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -406.5151062011719,
      "bbox_min": [
        -345.90008544921875,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -327.0,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -345.90008544921875,
        -2290.865966796875,
        619.9999389648438
      ],
      "bbox_max": [
        -331.0,
        -2274.0,
        627.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7888135313987732,
        0.5270446538925171,
        0.3162231743335724
      ],
      "plane_d": 749.372802734375,
      "bbox_min": [
        -332.0087890625,
        -2290.865966796875,
        620.0
      ],
      "bbox_max": [
        -331.0000915527344,
        -2289.23388671875,
        620.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268962502479553,
        0.923876941204071,
        0.0
      ],
      "plane_d": 1991.308837890625,
      "bbox_min": [
        -341.8866882324219,
        -2297.0,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -331.9084167480469,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7888135313987732,
        0.5270446538925171,
        0.3162231743335724
      ],
      "plane_d": 749.372802734375,
      "bbox_min": [
        -331.9084167480469,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2286.240478515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -349.5,
        -2297.0,
        626.5
      ],
      "bbox_max": [
        -327.0,
        -2258.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -349.5,
      "bbox_min": [
        -349.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -345.0,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -349.5,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -345.0,
        -2274.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268962502479553,
        0.923876941204071,
        0.0
      ],
      "plane_d": 1991.308837890625,
      "bbox_min": [
        -341.8866882324219,
        -2297.0,
        628.7296142578125
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -330.682861328125,
        -2292.359130859375,
        634.9540405273438
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -330.682861328125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8314775824546814,
        0.5555582642555237,
        0.0
      ],
      "plane_d": 998.5836791992188,
      "bbox_min": [
        -330.682861328125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -327.0,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882246017456,
        -0.3826768100261688,
        0.0
      ],
      "plane_d": -1182.7447509765625,
      "bbox_min": [
        -330.682861328125,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -328.7605895996094,
        -2292.359130859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -329.705322265625,
        -2238.0,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -450.5,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2139.80908203125,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7709356546401978,
        -0.44509944319725037,
        -0.4555707275867462
      ],
      "plane_d": -932.5703735351562,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2139.80908203125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4924207925796509,
        -0.8528348207473755,
        -0.17376579344272614
      ],
      "plane_d": -1573.84912109375,
      "bbox_min": [
        -344.200927734375,
        -2179.897705078125,
        642.2142944335938
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -338.16650390625,
        -2179.897705078125,
        642.2142944335938
      ],
      "bbox_max": [
        -327.710693359375,
        -2169.56787109375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -338.16650390625,
        -2172.718017578125,
        642.21435546875
      ],
      "bbox_max": [
        -332.710693359375,
        -2169.56787109375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1983572542667389,
        -0.11451967060565948,
        0.9734165072441101
      ],
      "plane_d": -940.360595703125,
      "bbox_min": [
        -340.07177734375,
        -2182.478271484375,
        641.0
      ],
      "bbox_max": [
        -330.6023254394531,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000067353248596,
        -0.8660215139389038,
        0.0
      ],
      "plane_d": -1712.534912109375,
      "bbox_min": [
        -340.07177734375,
        -2173.81787109375,
        641.0
      ],
      "bbox_max": [
        -335.6023864746094,
        -2171.2373046875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -328.39990234375,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -321.661865234375,
        -2227.60009765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -321.661865234375,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        652.0
      ],
      "bbox_max": [
        -321.661865234375,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11463826894760132,
        -0.9934073090553284,
        0.0
      ],
      "plane_d": -2165.989990234375,
      "bbox_min": [
        -328.39990234375,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2216.699951171875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -324.1583251953125,
        -2217.77197265625,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2216.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.5,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -325.60498046875,
        -2218.606689453125,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.451732337474823,
        -0.7829954028129578,
        -0.42761677503585815
      ],
      "plane_d": -1312.5462646484375,
      "bbox_min": [
        -328.39990234375,
        -2237.0,
        651.0
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.0,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2217.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4385019838809967,
        -0.7758143544197083,
        -0.4536828398704529
      ],
      "plane_d": -1283.910888671875,
      "bbox_min": [
        -328.39990234375,
        -2237.0,
        651.0
      ],
      "bbox_max": [
        -318.5,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -323.04638671875,
        -2237.0,
        652.0
      ],
      "bbox_max": [
        -318.5,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        652.0
      ],
      "bbox_max": [
        -318.5,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2116.147216796875,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -391.450439453125,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.149342879652977,
        -0.7507419586181641,
        -0.6434929966926575
      ],
      "plane_d": -1198.31591796875,
      "bbox_min": [
        -386.067138671875,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2119.08251953125,
      "bbox_min": [
        -386.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -373.2688293457031,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238958358764648,
        -0.38264405727386475,
        0.0
      ],
      "plane_d": -1211.6668701171875,
      "bbox_min": [
        -386.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -384.919189453125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -376.5,
        -2236.142822265625,
        658.5
      ],
      "bbox_max": [
        -373.2688293457031,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -376.5,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -368.080810546875,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2237.1748046875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -369.155029296875,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -361.549560546875,
        -2234.403076171875,
        659.1760864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314864635467529,
        0.5555450320243835,
        0.0
      ],
      "plane_d": 936.2117919921875,
      "bbox_min": [
        -369.155029296875,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -366.932861328125,
        -2234.403076171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -369.155029296875,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -368.76507568359375,
        -2237.72900390625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -368.080810546875,
        -2238.0,
        658.5
      ],
      "bbox_max": [
        -366.8457946777344,
        -2237.1748046875,
        659.1760864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        4.359517788543599e-06
      ],
      "plane_d": 376.8681640625,
      "bbox_min": [
        -450.5,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 450.5,
      "bbox_min": [
        -450.5,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -386.067138671875,
        -2282.430908203125,
        645.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2280.596923828125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 644.5,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -46.6435432434082,
      "bbox_min": [
        -401.5,
        -2280.596923828125,
        644.5
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -401.5,
        -2280.596923828125,
        644.5
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -916.6072998046875,
      "bbox_min": [
        -401.5,
        -2280.596923828125,
        644.5
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 2110.74560546875,
      "bbox_min": [
        -401.5,
        -2280.596923828125,
        644.5
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        0.5555604696273804,
        -0.0
      ],
      "plane_d": 1591.7481689453125,
      "bbox_min": [
        -401.5,
        -2275.177734375,
        644.5
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        644.5
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        644.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807825088500977,
        -0.1951041966676712,
        0.0
      ],
      "plane_d": -49.60589599609375,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264408707618713,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 2229.75927734375,
      "bbox_min": [
        -399.596923828125,
        -2249.080810546875,
        644.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 831.28955078125,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264405727386475,
        -0.9238958358764648,
        0.0
      ],
      "plane_d": -1941.6304931640625,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      "bbox_max": [
        -396.8251953125,
        -2265.919189453125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -1595.8724365234375,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1581.26025390625,
      "bbox_min": [
        -402.50714111328125,
        -2280.596923828125,
        641.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -402.50714111328125,
        -2280.596923828125,
        641.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -1663.02001953125,
      "bbox_min": [
        -402.50714111328125,
        -2269.01171875,
        641.0
      ],
      "bbox_max": [
        -399.596923828125,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 2110.74560546875,
      "bbox_min": [
        -401.5,
        -2280.596923828125,
        641.0
      ],
      "bbox_max": [
        -386.067138671875,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 1672.7745361328125,
      "bbox_min": [
        -397.08795166015625,
        -2277.122314453125,
        641.0
      ],
      "bbox_max": [
        -394.177734375,
        -2275.177734375,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -46.6435432434082,
      "bbox_min": [
        -401.5,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -916.6072998046875,
      "bbox_min": [
        -400.6428527832031,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        -0.1951041966676712,
        0.0
      ],
      "plane_d": -49.60589599609375,
      "bbox_min": [
        -400.6428527832031,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507328987121582,
        -0.14934109151363373,
        -0.6435039639472961
      ],
      "plane_d": 376.1243591308594,
      "bbox_min": [
        -400.6428527832031,
        -2262.88623046875,
        641.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264408707618713,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 2229.75927734375,
      "bbox_min": [
        -399.596923828125,
        -2249.080810546875,
        641.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2247.932861328125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507419586181641,
        0.149342879652977,
        -0.6434929966926575
      ],
      "plane_d": 1050.4000244140625,
      "bbox_min": [
        -400.6428527832031,
        -2262.88623046875,
        641.0
      ],
      "bbox_max": [
        -398.5,
        -2257.5,
        643.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 831.28955078125,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507419586181641,
        0.149342879652977,
        -0.6434929966926575
      ],
      "plane_d": 1050.4000244140625,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2257.5,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38264405727386475,
        -0.9238958358764648,
        0.0
      ],
      "plane_d": -1941.6304931640625,
      "bbox_min": [
        -399.596923828125,
        -2267.067138671875,
        641.0
      ],
      "bbox_max": [
        -396.8251953125,
        -2265.919189453125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -394.177734375,
        -2239.822265625,
        641.0
      ],
      "bbox_max": [
        -391.450439453125,
        -2238.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2268.0,
      "bbox_min": [
        -420.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -397.0,
        -2268.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -397.0,
      "bbox_min": [
        -397.0,
        -2293.0,
        641.0
      ],
      "bbox_max": [
        -397.0,
        -2281.5,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -376.8476867675781,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.8476867675781,
        -2257.527099609375,
        641.0
      ],
      "bbox_max": [
        -353.4643249511719,
        -2238.0,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5706624388694763,
        -0.8211847543716431,
        -0.0
      ],
      "plane_d": -2048.251953125,
      "bbox_min": [
        -361.6766052246094,
        -2242.9482421875,
        641.0
      ],
      "bbox_max": [
        -361.64453125,
        -2242.926025390625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        -0.8314761519432068,
        -0.0
      ],
      "plane_d": -2061.706298828125,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        645.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4252527952194214,
        -0.6364531517028809,
        -0.6434962749481201
      ],
      "plane_d": -1156.64208984375,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555597543716431,
        -0.831476628780365,
        -0.0
      ],
      "plane_d": -2064.6494140625,
      "bbox_min": [
        -366.8457946777344,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2238.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1330.06787109375,
      "bbox_min": [
        -360.943603515625,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -358.822265625,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.84747314453125,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84747314453125,
        -2282.5,
        641.0
      ],
      "bbox_max": [
        -363.03955078125,
        -2251.807373046875,
        660.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -376.8473815917969,
        -2282.5,
        641.0
      ],
      "bbox_max": [
        -363.03955078125,
        -2251.807373046875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7360445261001587,
        0.6769331097602844,
        0.0
      ],
      "plane_d": 1252.1007080078125,
      "bbox_min": [
        -376.8473815917969,
        -2260.360107421875,
        641.0
      ],
      "bbox_max": [
        -374.0327453613281,
        -2256.361083984375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100080132484436,
        0.41459059715270996,
        0.0
      ],
      "plane_d": 594.1898803710938,
      "bbox_min": [
        -376.8473815917969,
        -2260.360107421875,
        641.0
      ],
      "bbox_max": [
        -376.0,
        -2258.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9219129085540771,
        0.38739722967147827,
        0.0
      ],
      "plane_d": 537.717529296875,
      "bbox_min": [
        -376.84722900390625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -367.88818359375,
        -2263.512939453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -375.0616760253906,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2312.093505859375,
      "bbox_min": [
        -376.84722900390625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -375.150390625,
        -2280.794677734375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7841436862945557,
        0.6205793023109436,
        0.0
      ],
      "plane_d": 1121.2421875,
      "bbox_min": [
        -376.5,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -375.150390625,
        -2280.794677734375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        641.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.710696816444397,
        0.7034984827041626,
        0.0
      ],
      "plane_d": 1330.9207763671875,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1841.7906494140625,
      "bbox_min": [
        -354.598388671875,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -367.88818359375,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        -0.0
      ],
      "plane_d": -1542.7088623046875,
      "bbox_min": [
        -354.598388671875,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.841064453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743956089019775,
        0.4852137267589569,
        0.0
      ],
      "plane_d": 781.7138061523438,
      "bbox_min": [
        -354.598388671875,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -353.403076171875,
        -2247.932861328125,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        644.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -319.5,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -319.5,
        -2285.02587890625,
        692.279296875
      ],
      "bbox_max": [
        -318.5,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -319.5,
        -2285.02587890625,
        692.279296875
      ],
      "bbox_max": [
        -318.5,
        -2284.990966796875,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -319.5,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -319.5,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -331.6534118652344,
        -2296.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -341.6533203125,
        -2297.0,
        704.0
      ],
      "bbox_max": [
        -341.6532897949219,
        -2296.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -331.6534118652344,
        -2296.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        -0.0,
        0.8797038793563843
      ],
      "plane_d": -429.5593566894531,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        690.0
      ],
      "bbox_max": [
        -373.14013671875,
        -2296.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.6532897949219,
        -2296.0,
        689.7472534179688
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -341.6532897949219,
        -2296.0,
        689.7472534179688
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -341.6532897949219,
        -2296.0,
        692.2789306640625
      ],
      "bbox_max": [
        -319.5,
        -2273.304931640625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -323.06005859375,
        -2285.02587890625,
        692.2792358398438
      ],
      "bbox_max": [
        -319.5,
        -2284.990966796875,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -323.0456848144531,
        -2285.060546875,
        689.7472534179688
      ],
      "bbox_max": [
        -319.5,
        -2285.02587890625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.6534118652344,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -323.758544921875,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -321.2324523925781,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -323.0456848144531,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        692.279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -321.3250732421875,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2283.304931640625,
        692.279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 2197.236328125,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        -0.0,
        0.8797038793563843
      ],
      "plane_d": -429.5593566894531,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        690.0
      ],
      "bbox_max": [
        -373.14013671875,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8797038793563843,
        -0.47552189230918884,
        0.0
      ],
      "plane_d": -1347.0428466796875,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -376.84716796875,
        -2297.0,
        644.0
      ],
      "bbox_max": [
        -318.5,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1345.3128662109375,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1841.7906494140625,
      "bbox_min": [
        -354.5302734375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        649.4808959960938
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": -531.2314453125,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1950736939907074,
        -0.9807885885238647,
        0.0
      ],
      "plane_d": -2314.75390625,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -370.531005859375,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -150.14930725097656,
      "bbox_min": [
        -367.88818359375,
        -2297.0,
        644.0
      ],
      "bbox_max": [
        -318.5,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1345.3128662109375,
      "bbox_min": [
        -363.73095703125,
        -2266.290771484375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        652.024169921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -357.6902160644531,
        -2260.25,
        649.0
      ],
      "bbox_max": [
        -351.062744140625,
        -2250.87744140625,
        651.1942749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1841.7906494140625,
      "bbox_min": [
        -353.80792236328125,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -351.062744140625,
        -2250.87744140625,
        651.1942749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -331.0533752441406,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.499983549118042,
        0.499983549118042,
        -0.7071300745010376
      ],
      "plane_d": 1445.73974609375,
      "bbox_min": [
        -331.0533752441406,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 231.46905517578125,
      "bbox_min": [
        -331.0533752441406,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2080.52392578125,
      "bbox_min": [
        -331.0533752441406,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": -2044.213623046875,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": 510.8121643066406,
      "bbox_min": [
        -376.840087890625,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 2197.236328125,
      "bbox_min": [
        -376.840087890625,
        -2296.0,
        670.5
      ],
      "bbox_max": [
        -373.14013671875,
        -2294.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071147561073303,
        0.7070987820625305,
        0.0
      ],
      "plane_d": 1380.587890625,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071163058280945,
        0.7070972323417664,
        0.0
      ],
      "plane_d": 1383.583740234375,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933853030204773,
        0.6933665871620178,
        0.19611123204231262
      ],
      "plane_d": 1224.537841796875,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805803894996643,
        1.867060927907005e-05,
        0.19611762464046478
      ],
      "plane_d": -459.3144226074219,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        1.9040366169065237e-05,
        0.0
      ],
      "plane_d": -333.6097106933594,
      "bbox_min": [
        -333.6534423828125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.867096398200374e-05,
        0.9805803894996643,
        0.19611762464046478
      ],
      "plane_d": 2104.82568359375,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071171402931213,
        -0.7070955634117126,
        0.001076003652997315
      ],
      "plane_d": -1386.1417236328125,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -324.5869140625,
        -2281.304931640625,
        664.0
      ],
      "bbox_max": [
        -321.9739990234375,
        -2281.304931640625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999994039535522,
        -2.1604791982099414e-05,
        0.0010726567124947906
      ],
      "plane_d": 331.0437316894531,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1605259462376125e-05,
        -0.9999994039535522,
        0.0010726567124947906
      ],
      "plane_d": -2283.870361328125,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -321.98919677734375,
        -2281.304931640625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2281.304931640625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933979392051697,
        -0.693348228931427,
        -0.19613134860992432
      ],
      "plane_d": -1226.3212890625,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070654034614563,
        -0.7070155739784241,
        0.013692148961126804
      ],
      "plane_d": -1396.6131591796875,
      "bbox_min": [
        -329.8670349121094,
        -2291.961181640625,
        683.786865234375
      ],
      "bbox_max": [
        -321.8964538574219,
        -2285.09130859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -323.0185852050781,
        -2285.14208984375,
        683.786865234375
      ],
      "bbox_max": [
        -321.8964538574219,
        -2285.09130859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805810451507568,
        -2.4826093067531474e-05,
        -0.19611415266990662
      ],
      "plane_d": 457.4548645019531,
      "bbox_min": [
        -331.8162841796875,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.482546551618725e-05,
        -0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": -2106.6748046875,
      "bbox_min": [
        -323.825927734375,
        -2285.14208984375,
        673.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -322.99755859375,
        -2285.14208984375,
        683.786865234375
      ],
      "bbox_max": [
        -318.5,
        -2285.09130859375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -321.587158203125,
        -2278.30517578125,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -336.6533203125,
        -2293.371826171875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707128643989563,
        0.7070848941802979,
        0.0
      ],
      "plane_d": 1385.551513671875,
      "bbox_min": [
        -331.6533508300781,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -322.76873779296875,
        -2283.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -331.6533508300781,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -322.76873779296875,
        -2283.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.6533508300781,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -331.6533203125,
        -2291.2001953125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2293.371826171875,
        663.0
      ],
      "bbox_max": [
        -321.587158203125,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -325.82958984375,
        -2278.30517578125,
        663.0
      ],
      "bbox_max": [
        -321.587158203125,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.69339919090271,
        0.6933562755584717,
        -0.1960984170436859
      ],
      "plane_d": 1488.6630859375,
      "bbox_min": [
        -331.6534423828125,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.144122845493257e-05,
        0.9805718064308167,
        -0.1961604654788971
      ],
      "plane_d": 2369.005859375,
      "bbox_min": [
        -323.758544921875,
        -2283.905029296875,
        660.0
      ],
      "bbox_max": [
        -318.5,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.031418200582265854,
        0.09372557699680328,
        0.9951022267341614
      ],
      "plane_d": 39.018436431884766,
      "bbox_min": [
        -318.5,
        -1691.41845703125,
        9.415567398071289
      ],
      "bbox_max": [
        389.81201171875,
        -1182.3604736328125,
        126.93439483642578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09095493704080582,
        0.1663801521062851,
        0.9818578362464905
      ],
      "plane_d": 140.3548126220703,
      "bbox_min": [
        -318.5,
        -1562.755859375,
        9.415567398071289
      ],
      "bbox_max": [
        54.0048828125,
        -1182.3604736328125,
        92.36326599121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.091210275888443,
        0.16736166179180145,
        0.9816673398017883
      ],
      "plane_d": 141.69515991210938,
      "bbox_min": [
        -318.5,
        -1434.75,
        9.415567398071289
      ],
      "bbox_max": [
        54.0048828125,
        -1182.3604736328125,
        88.18136596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3091984987258911,
        0.4324801564216614,
        0.8469694256782532
      ],
      "plane_d": 459.2151184082031,
      "bbox_min": [
        -318.5,
        -1362.2982177734375,
        9.415567398071289
      ],
      "bbox_max": [
        -47.088134765625,
        -1182.3604736328125,
        57.121009826660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3707151412963867,
        0.5205857157707214,
        0.7691298723220825
      ],
      "plane_d": 561.1250610351562,
      "bbox_min": [
        -318.5,
        -1351.22705078125,
        9.415567398071289
      ],
      "bbox_max": [
        -78.43328094482422,
        -1182.3604736328125,
        32.91841125488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28493207693099976,
        0.23069781064987183,
        0.9303721189498901
      ],
      "plane_d": 210.4232177734375,
      "bbox_min": [
        33.723262786865234,
        -1691.41845703125,
        88.18136596679688
      ],
      "bbox_max": [
        216.49755859375,
        -1334.440185546875,
        126.93439483642578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17420437932014465,
        -0.5765995979309082,
        0.7982391715049744
      ],
      "plane_d": -1686.074462890625,
      "bbox_min": [
        -219.687744140625,
        -2078.106689453125,
        587.62353515625
      ],
      "bbox_max": [
        151.512451171875,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01063776295632124,
        -0.5737824440002441,
        0.818938672542572
      ],
      "plane_d": -1711.553955078125,
      "bbox_min": [
        -219.687744140625,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -99.61474609375,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1719936728477478,
        -0.8070312738418579,
        0.5649059414863586
      ],
      "plane_d": -2035.6072998046875,
      "bbox_min": [
        -219.687744140625,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -106.350830078125,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249415397644043,
        -0.6418299674987793,
        0.7422939538955688
      ],
      "plane_d": -1820.3389892578125,
      "bbox_min": [
        -217.74951171875,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -106.350830078125,
        -2023.7451171875,
        667.1800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -216.0,
        -2206.781494140625,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2138.973388671875,
      "bbox_min": [
        -318.5,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2206.781494140625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -318.5,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2206.781494140625,
        655.5214233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.969547688961029,
        -0.24490270018577576,
        0.0
      ],
      "plane_d": -846.1050415039062,
      "bbox_min": [
        -318.5,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2206.781494140625,
        655.5214233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3135608732700348,
        -0.9495680928230286,
        0.0
      ],
      "plane_d": -2205.470947265625,
      "bbox_min": [
        -318.5,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2206.781494140625,
        655.5214233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7709355354309082,
        -0.44510096311569214,
        -0.45556941628456116
      ],
      "plane_d": -932.5745239257812,
      "bbox_min": [
        -318.5,
        -2214.479736328125,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2206.781494140625,
        655.5214233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8261853456497192,
        -0.4769970178604126,
        0.29981938004493713
      ],
      "plane_d": -1510.0511474609375,
      "bbox_min": [
        -318.5,
        -2214.479736328125,
        641.0
      ],
      "bbox_max": [
        -315.16650390625,
        -2206.781494140625,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -318.5,
        -2214.479736328125,
        641.0
      ],
      "bbox_max": [
        -317.07177734375,
        -2211.181396484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7625132203102112,
        -0.64697265625,
        0.0
      ],
      "plane_d": -1675.384521484375,
      "bbox_min": [
        -318.5,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.43115234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -318.5,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.43115234375,
        652.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -315.951416015625,
        -2235.636962890625,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -315.951416015625,
        -2235.636962890625,
        652.0
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -670.4223022460938,
      "bbox_min": [
        -282.5357971191406,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2268.0,
      "bbox_min": [
        -231.29664611816406,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -216.0,
      "bbox_min": [
        -231.29664611816406,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -231.29664611816406,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 644.5,
      "bbox_min": [
        -231.29664611816406,
        -2275.4013671875,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2268.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6348146796226501,
        -0.7726644277572632,
        0.0
      ],
      "plane_d": -1606.3955078125,
      "bbox_min": [
        -231.29664611816406,
        -2269.255615234375,
        626.0
      ],
      "bbox_max": [
        -230.0,
        -2268.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -1066.6884765625,
      "bbox_min": [
        -231.29664611816406,
        -2269.255615234375,
        641.0
      ],
      "bbox_max": [
        -230.0,
        -2268.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -231.29664611816406,
        -2269.255615234375,
        641.0
      ],
      "bbox_max": [
        -230.0,
        -2268.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        -0.9807842373847961,
        -0.0
      ],
      "plane_d": -2240.22802734375,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1996.7056884765625,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1445.4261474609375,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 210.43450927734375,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7360445261001587,
        0.6769331097602844,
        -0.0
      ],
      "plane_d": 1720.2249755859375,
      "bbox_min": [
        -282.5357971191406,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -282.5357971191406,
        -2256.361328125,
        629.0
      ],
      "bbox_max": [
        -261.96685791015625,
        -2239.822265625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5706624388694763,
        -0.8211847543716431,
        0.0
      ],
      "plane_d": -1685.310546875,
      "bbox_min": [
        -274.35546875,
        -2242.9482421875,
        629.0
      ],
      "bbox_max": [
        -274.32330322265625,
        -2242.92578125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1013.8900146484375,
      "bbox_min": [
        -282.5357971191406,
        -2247.84130859375,
        645.0
      ],
      "bbox_max": [
        -277.177734375,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1708.3697509765625,
      "bbox_min": [
        -277.177734375,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5706624388694763,
        -0.8211847543716431,
        0.0
      ],
      "plane_d": -1685.310546875,
      "bbox_min": [
        -277.177734375,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.5,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314864635467529,
        0.5555450320243835,
        -0.0
      ],
      "plane_d": 1465.0372314453125,
      "bbox_min": [
        -277.177734375,
        -2242.92578125,
        629.0
      ],
      "bbox_max": [
        -259.36029052734375,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -277.177734375,
        -2242.92578125,
        645.0
      ],
      "bbox_max": [
        -266.844970703125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555597543716431,
        -0.831476628780365,
        0.0
      ],
      "plane_d": -1711.3134765625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -267.2978515625,
        -2237.05126953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1779.7877197265625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        655.0
      ],
      "bbox_max": [
        -275.056396484375,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -267.919189453125,
        -2237.1748046875,
        658.5
      ],
      "bbox_max": [
        -267.2978515625,
        -2237.05126953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14933623373508453,
        -0.7507426738739014,
        -0.64349365234375
      ],
      "plane_d": -1215.7918701171875,
      "bbox_min": [
        -269.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -267.2978515625,
        -2234.403076171875,
        658.788330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -267.919189453125,
        -2237.1748046875,
        658.5
      ],
      "bbox_max": [
        -267.2978515625,
        -2237.05126953125,
        658.788330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14933623373508453,
        -0.7507426738739014,
        -0.64349365234375
      ],
      "plane_d": -1215.7918701171875,
      "bbox_min": [
        -269.067138671875,
        -2237.05126953125,
        655.0
      ],
      "bbox_max": [
        -259.36029052734375,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -267.2978515625,
        -2237.05126953125,
        658.5
      ],
      "bbox_max": [
        -265.29681396484375,
        -2236.653076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14933465421199799,
        -0.7507347464561462,
        -0.6435033082962036
      ],
      "plane_d": -1293.27294921875,
      "bbox_min": [
        -259.5,
        -2232.624755859375,
        655.0
      ],
      "bbox_max": [
        -259.36029052734375,
        -2232.5,
        655.1456909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -265.29681396484375,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2232.52783203125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2245.0,
      "bbox_min": [
        -265.0,
        -2266.958984375,
        629.0
      ],
      "bbox_max": [
        -234.5,
        -2240.0,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -265.0,
      "bbox_min": [
        -265.0,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -260.0,
        -2240.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -265.0,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -260.0,
        -2240.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.0,
      "bbox_min": [
        -265.0,
        -2245.0,
        629.0
      ],
      "bbox_max": [
        -260.0,
        -2240.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -265.0,
        -2245.0,
        637.0
      ],
      "bbox_max": [
        -260.0,
        -2240.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7507426738739014,
        -0.14933623373508453,
        -0.64349365234375
      ],
      "plane_d": -101.33976745605469,
      "bbox_min": [
        -239.1748046875,
        -2266.958984375,
        640.0
      ],
      "bbox_max": [
        -234.5,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        -0.1951041966676712,
        0.0
      ],
      "plane_d": -673.383544921875,
      "bbox_min": [
        -239.1748046875,
        -2260.731689453125,
        640.0
      ],
      "bbox_max": [
        -236.403076171875,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38264405727386475,
        0.9238958358764648,
        0.0
      ],
      "plane_d": 1986.3975830078125,
      "bbox_min": [
        -239.1748046875,
        -2249.080810546875,
        640.0
      ],
      "bbox_max": [
        -236.403076171875,
        -2247.932861328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 207.51187133789062,
      "bbox_min": [
        -238.1428680419922,
        -2260.731689453125,
        643.5
      ],
      "bbox_max": [
        -237.5,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 207.51187133789062,
      "bbox_min": [
        -239.1532440185547,
        -2265.810791015625,
        643.5
      ],
      "bbox_max": [
        -237.5,
        -2257.5,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2243.1689453125,
      "bbox_min": [
        -262.7317199707031,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238958358764648,
        -0.38264408707618713,
        0.0
      ],
      "plane_d": -624.0692138671875,
      "bbox_min": [
        -251.080810546875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2234.403076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -262.7317199707031,
        -2236.142822265625,
        658.5
      ],
      "bbox_max": [
        -259.5,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -265.29681396484375,
        -2236.653076171875,
        658.5
      ],
      "bbox_max": [
        -259.5,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -216.0,
        -2232.9443359375,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -318.5,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2232.9443359375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -318.5,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -312.0,
        -2232.9443359375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -318.5,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -312.0,
        -2232.9443359375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -318.5,
        -2237.0,
        652.0
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -318.5,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -318.5,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -318.5,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -216.0,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555604696273804,
        0.8314761519432068,
        0.0
      ],
      "plane_d": 1757.4091796875,
      "bbox_min": [
        -272.96026611328125,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2251.8076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -241.822265625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2269.0654296875,
        644.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 644.5,
      "bbox_min": [
        -241.822265625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2269.0654296875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -241.822265625,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2269.0654296875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -239.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2293.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2295.0,
      "bbox_min": [
        -239.0,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2293.0,
        641.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 635.5,
      "bbox_min": [
        -232.89990234375,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -218.89990234375,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": 136.6844482421875,
      "bbox_min": [
        -232.89990234375,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -218.89990234375,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.0,
        -0.5144957304000854
      ],
      "plane_d": 524.0995483398438,
      "bbox_min": [
        -232.89990234375,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -218.89990234375,
        -2295.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138115644454956,
        0.0,
        0.40613847970962524
      ],
      "plane_d": -456.10357666015625,
      "bbox_min": [
        -232.89990234375,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -218.89990234375,
        -2295.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138115644454956,
        -0.0,
        0.40613847970962524
      ],
      "plane_d": -43.24368667602539,
      "bbox_min": [
        -232.89990234375,
        -2297.0,
        626.0
      ],
      "bbox_max": [
        -230.89990234375,
        -2295.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 239.0,
      "bbox_min": [
        -239.0,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2293.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -216.0,
      "bbox_min": [
        -216.0,
        -2295.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2293.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -216.0,
      "bbox_min": [
        -241.822265625,
        -2293.0,
        626.0
      ],
      "bbox_max": [
        -216.0,
        -2269.0654296875,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -1066.6884765625,
      "bbox_min": [
        -241.822265625,
        -2293.0,
        626.0
      ],
      "bbox_max": [
        -230.8371124267578,
        -2269.0654296875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555562973022461,
        0.8314789533615112,
        0.0
      ],
      "plane_d": 2026.1082763671875,
      "bbox_min": [
        -241.822265625,
        -2281.5,
        626.0
      ],
      "bbox_max": [
        -230.8371124267578,
        -2269.0654296875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9358036518096924,
        -0.352521687746048,
        0.0
      ],
      "plane_d": -580.6211547851562,
      "bbox_min": [
        -239.0,
        -2281.5,
        626.0
      ],
      "bbox_max": [
        -236.9537353515625,
        -2277.95556640625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -239.0,
        -2281.5,
        641.0
      ],
      "bbox_max": [
        -236.9537353515625,
        -2277.95556640625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6348146796226501,
        -0.7726644277572632,
        0.0
      ],
      "plane_d": -1606.3955078125,
      "bbox_min": [
        -232.24560546875,
        -2270.314453125,
        626.0
      ],
      "bbox_max": [
        -230.8371124267578,
        -2269.0654296875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -232.24560546875,
        -2270.314453125,
        641.0
      ],
      "bbox_max": [
        -230.8371124267578,
        -2269.0654296875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -237.664794921875,
        -2278.4306640625,
        641.0
      ],
      "bbox_max": [
        -231.54293823242188,
        -2269.844970703125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -241.822265625,
        -2277.95556640625,
        626.0
      ],
      "bbox_max": [
        -232.24560546875,
        -2269.31201171875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 239.0,
      "bbox_min": [
        -239.0,
        -2293.0,
        626.0
      ],
      "bbox_max": [
        -239.0,
        -2281.5,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 210.43450927734375,
      "bbox_min": [
        -272.96026611328125,
        -2282.5,
        626.5756225585938
      ],
      "bbox_max": [
        -233.04330444335938,
        -2251.8076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555562376976013,
        -0.8314789533615112,
        0.0
      ],
      "plane_d": -2016.353759765625,
      "bbox_min": [
        -237.4330596923828,
        -2272.2451171875,
        626.5756225585938
      ],
      "bbox_max": [
        -233.04330444335938,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -237.4330596923828,
        -2272.2451171875,
        626.5756225585938
      ],
      "bbox_max": [
        -233.04330444335938,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -237.4330596923828,
        -2272.2451171875,
        626.5756225585938
      ],
      "bbox_max": [
        -233.04330444335938,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9100080132484436,
        0.41459059715270996,
        -0.0
      ],
      "plane_d": 1172.9549560546875,
      "bbox_min": [
        -272.96026611328125,
        -2282.5,
        627.7879028320312
      ],
      "bbox_max": [
        -236.38156127929688,
        -2251.8076171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -272.96026611328125,
        -2282.5,
        629.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2251.8076171875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7360445261001587,
        0.6769331097602844,
        -0.0
      ],
      "plane_d": 1720.2249755859375,
      "bbox_min": [
        -261.96685791015625,
        -2258.5,
        629.0
      ],
      "bbox_max": [
        -260.0,
        -2256.361328125,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -261.96685791015625,
        -2258.5,
        629.0
      ],
      "bbox_max": [
        -260.0,
        -2256.361328125,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -272.96026611328125,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2251.8076171875,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9219129085540771,
        0.38739722967147827,
        -0.0
      ],
      "plane_d": 1124.05419921875,
      "bbox_min": [
        -268.11181640625,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2263.512939453125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -268.111572265625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -268.111572265625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509564340114594,
        0.9807842373847961,
        0.0
      ],
      "plane_d": 2188.0126953125,
      "bbox_min": [
        -260.849609375,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -249.932861328125,
        -2280.596923828125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7841436862945557,
        0.6205793023109436,
        0.0
      ],
      "plane_d": 1619.95751953125,
      "bbox_min": [
        -260.849609375,
        -2282.5,
        645.0
      ],
      "bbox_max": [
        -259.5,
        -2280.794677734375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -629.0,
      "bbox_min": [
        -260.7434387207031,
        -2280.596923828125,
        627.7879028320312
      ],
      "bbox_max": [
        -236.38156127929688,
        -2256.8681640625,
        660.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.427785187959671,
        -0.28582966327667236,
        0.8574970960617065
      ],
      "plane_d": -1086.23095703125,
      "bbox_min": [
        -241.822265625,
        -2275.177734375,
        627.7879028320312
      ],
      "bbox_max": [
        -236.403076171875,
        -2267.067138671875,
        629.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -260.7434387207031,
        -2280.596923828125,
        640.0
      ],
      "bbox_max": [
        -236.38156127929688,
        -2256.8681640625,
        660.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.8314761519432068,
        0.5555604696273804,
        0.0
      ],
      "plane_d": 1062.9293212890625,
      "bbox_min": [
        -241.822265625,
        -2275.177734375,
        640.0
      ],
      "bbox_max": [
        -236.38156127929688,
        -2265.810791015625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879369974136353,
        0.3928370177745819,
        -0.7071132659912109
      ],
      "plane_d": 1207.332275390625,
      "bbox_min": [
        -241.822265625,
        -2275.177734375,
        642.4797973632812
      ],
      "bbox_max": [
        -236.403076171875,
        -2267.067138671875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -239.1748046875,
        -2267.067138671875,
        643.5
      ],
      "bbox_max": [
        -236.38156127929688,
        -2265.810791015625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807825088500977,
        0.1951041966676712,
        0.0
      ],
      "plane_d": 207.51187133789062,
      "bbox_min": [
        -239.1748046875,
        -2265.919189453125,
        643.5
      ],
      "bbox_max": [
        -239.1532440185547,
        -2265.810791015625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.710696816444397,
        0.7034984827041626,
        0.0
      ],
      "plane_d": 1782.9239501953125,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2247.84130859375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -268.111572265625,
        -2247.84130859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -268.11181640625,
        -2247.84130859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1013.8900146484375,
      "bbox_min": [
        -282.596923828125,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2247.84130859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743956089019775,
        0.4852137267589569,
        -0.0
      ],
      "plane_d": 1337.829345703125,
      "bbox_min": [
        -282.596923828125,
        -2250.0869140625,
        645.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2247.932861328125,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2258.0,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48564356565475464,
        -0.0,
        0.8741569519042969
      ],
      "plane_d": -406.7741394042969,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2266.0,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -288.8874206542969,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630545735359192,
        0.8764691948890686,
        0.3162168562412262
      ],
      "plane_d": 1922.0771484375,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -288.8874206542969,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -309.0,
        -2297.0,
        619.9999389648438
      ],
      "bbox_max": [
        -290.0999450683594,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -305.0,
        -2290.865966796875,
        619.9999389648438
      ],
      "bbox_max": [
        -290.0999450683594,
        -2274.0,
        627.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7888118624687195,
        0.5270435214042664,
        0.3162292242050171
      ],
      "plane_d": 1251.0513916015625,
      "bbox_min": [
        -304.9999084472656,
        -2290.865966796875,
        620.0
      ],
      "bbox_max": [
        -303.9912109375,
        -2289.23388671875,
        620.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268962502479553,
        0.923876941204071,
        -0.0
      ],
      "plane_d": 2234.699462890625,
      "bbox_min": [
        -309.0,
        -2297.0,
        620.0
      ],
      "bbox_max": [
        -294.1133117675781,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -304.0915832519531,
        -2286.240478515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888118624687195,
        0.5270435214042664,
        0.3162292242050171
      ],
      "plane_d": 1251.0513916015625,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        620.0
      ],
      "bbox_max": [
        -304.0915832519531,
        -2286.240478515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -627.0,
      "bbox_min": [
        -309.0,
        -2297.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 286.5,
      "bbox_min": [
        -291.0,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2258.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268962502479553,
        0.923876941204071,
        -0.0
      ],
      "plane_d": 2234.699462890625,
      "bbox_min": [
        -309.0,
        -2297.0,
        628.7296752929688
      ],
      "bbox_max": [
        -294.1133117675781,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        634.9540405273438
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2296.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -304.6982421875,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2296.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -294.6982421875,
        -2297.0,
        704.0
      ],
      "bbox_max": [
        -294.6981506347656,
        -2296.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2297.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2296.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        0.0,
        0.8797038793563843
      ],
      "plane_d": -731.986572265625,
      "bbox_min": [
        -262.849853515625,
        -2297.0,
        690.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2296.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5105127861024812e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2273.313232421875,
      "bbox_min": [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      "bbox_max": [
        -317.0,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -318.5,
        -2285.02587890625,
        692.279296875
      ],
      "bbox_max": [
        -317.0,
        -2284.990966796875,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -318.5,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -318.5,
        -2285.09130859375,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2285.02587890625,
        692.279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070879340171814,
        0.7071256041526794,
        -0.0
      ],
      "plane_d": 1825.6146240234375,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999903738498688,
        0.500005841255188,
        -0.7071094512939453
      ],
      "plane_d": 1788.6934814453125,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -317.0,
        -2296.0,
        689.6419067382812
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -317.0,
        -2296.0,
        689.6419067382812
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -317.0,
        -2296.0,
        692.2791137695312
      ],
      "bbox_max": [
        -294.697998046875,
        -2273.30517578125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -317.0,
        -2285.026123046875,
        692.2791748046875
      ],
      "bbox_max": [
        -313.291748046875,
        -2284.990966796875,
        694.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -317.0,
        -2285.06201171875,
        689.6419067382812
      ],
      "bbox_max": [
        -313.3061218261719,
        -2285.02587890625,
        692.2792358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -315.1195983886719,
        -2283.30517578125,
        687.5
      ],
      "bbox_max": [
        -312.59326171875,
        -2283.304931640625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -317.0,
        -2285.091552734375,
        687.5
      ],
      "bbox_max": [
        -313.3061218261719,
        -2283.304931640625,
        692.2791748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -317.0,
        -2283.304931640625,
        687.5
      ],
      "bbox_max": [
        -315.027099609375,
        -2283.304931640625,
        692.2791137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552189230918884,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 1894.8092041015625,
      "bbox_min": [
        -317.0,
        -2296.0,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        0.0,
        0.8797038793563843
      ],
      "plane_d": -731.986572265625,
      "bbox_min": [
        -262.849853515625,
        -2296.0,
        690.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        -0.47552192211151123,
        0.0
      ],
      "plane_d": -787.111328125,
      "bbox_min": [
        -317.0,
        -2241.699951171875,
        687.5
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1795.0328369140625,
      "bbox_min": [
        -287.443603515625,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2246.958984375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -287.443603515625,
        -2275.35205078125,
        649.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -287.443603515625,
        -2275.35205078125,
        649.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -287.443603515625,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -281.46978759765625,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314638733863831,
        0.5555787682533264,
        0.0
      ],
      "plane_d": 1011.6734008789062,
      "bbox_min": [
        -287.443603515625,
        -2251.1162109375,
        649.480712890625
      ],
      "bbox_max": [
        -284.665771484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826741576194763,
        8.165456529241055e-05
      ],
      "plane_d": -1118.849365234375,
      "bbox_min": [
        -272.26904296875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1950737088918686,
        -0.9807885885238647,
        0.0
      ],
      "plane_d": -2190.687255859375,
      "bbox_min": [
        -272.26904296875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -272.26904296875,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -272.26904296875,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266947865486145,
        0.9238852858543396,
        0.0
      ],
      "plane_d": 2007.3734130859375,
      "bbox_min": [
        -265.468994140625,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -384.8389587402344,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -268.11181640625,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1795.0328369140625,
      "bbox_min": [
        -287.443603515625,
        -2266.290771484375,
        644.0
      ],
      "bbox_max": [
        -272.26904296875,
        -2246.958984375,
        652.0241088867188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -284.937255859375,
        -2260.25,
        649.0
      ],
      "bbox_max": [
        -278.3096923828125,
        -2250.877197265625,
        651.1942749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -284.937255859375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -282.19207763671875,
        -2250.87744140625,
        651.1942749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882246017456,
        -0.3826768100261688,
        0.0
      ],
      "plane_d": -595.1555786132812,
      "bbox_min": [
        -307.2394104003906,
        -2297.0,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2292.359130859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997347593307495,
        0.49999019503593445,
        -0.7071324586868286
      ],
      "plane_d": 1763.9188232421875,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2080.52392578125,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -318.5,
        -2297.0,
        655.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.144122845493257e-05,
        0.9805718064308167,
        -0.1961604654788971
      ],
      "plane_d": 2369.005859375,
      "bbox_min": [
        -318.5,
        -2297.0,
        658.0
      ],
      "bbox_max": [
        -305.2982482910156,
        -2283.905029296875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": -110.62958526611328,
      "bbox_min": [
        -318.5,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552189230918884,
        0.8797038793563843,
        0.0
      ],
      "plane_d": 1894.8092041015625,
      "bbox_min": [
        -262.849853515625,
        -2296.0,
        670.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2294.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070987820625305,
        0.7071147561073303,
        0.0
      ],
      "plane_d": 1830.5931396484375,
      "bbox_min": [
        -318.5,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -318.5,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070877552032471,
        0.7071258425712585,
        -0.0
      ],
      "plane_d": 1833.614990234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693355143070221,
        0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": 1665.8143310546875,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.867096398200374e-05,
        0.9805803894996643,
        0.19611762464046478
      ],
      "plane_d": 2104.82568359375,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.9040728147956543e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2281.31103515625,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2281.304931640625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805803894996643,
        -1.867096398200374e-05,
        0.19611762464046478
      ],
      "plane_d": 164.5936737060547,
      "bbox_min": [
        -318.5,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070847749710083,
        -0.7071279883384705,
        0.001076010405085981
      ],
      "plane_d": -1836.18115234375,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.69805908203125,
        -2292.984619140625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2290.37158203125,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1605259462376125e-05,
        -0.9999994039535522,
        0.0010726567124947906
      ],
      "plane_d": -2283.870361328125,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999994039535522,
        2.1605259462376125e-05,
        0.0010726567124947906
      ],
      "plane_d": -305.2082214355469,
      "bbox_min": [
        -318.5,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -302.6981201171875,
        -2297.0,
        664.0
      ],
      "bbox_max": [
        -302.69805908203125,
        -2292.969482421875,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933631300926208,
        -0.693388044834137,
        -0.1961136758327484
      ],
      "plane_d": -1667.65869140625,
      "bbox_min": [
        -318.5,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070280909538269,
        -0.7070529460906982,
        0.013692048378288746
      ],
      "plane_d": -1846.6292724609375,
      "bbox_min": [
        -314.4552917480469,
        -2291.9609375,
        683.786865234375
      ],
      "bbox_max": [
        -306.4845275878906,
        -2285.091552734375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.490519364073407e-05,
        -0.9999061822891235,
        0.013697962276637554
      ],
      "plane_d": -2294.30224609375,
      "bbox_min": [
        -314.4552917480469,
        -2285.142333984375,
        683.786865234375
      ],
      "bbox_max": [
        -313.3332214355469,
        -2285.091552734375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.482546551618725e-05,
        -0.9805810451507568,
        -0.19611415266990662
      ],
      "plane_d": -2106.6748046875,
      "bbox_min": [
        -318.5,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2283.14208984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805760979652405,
        -0.0,
        -0.1961391568183899
      ],
      "plane_d": -166.4639129638672,
      "bbox_min": [
        -306.535400390625,
        -2297.0,
        673.786865234375
      ],
      "bbox_max": [
        -304.53515625,
        -2291.132568359375,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2291.199951171875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2297.0,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2293.37109375,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -318.5,
        -2283.30517578125,
        663.0
      ],
      "bbox_max": [
        -312.59326171875,
        -2278.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -318.5,
        -2278.30517578125,
        663.0
      ],
      "bbox_max": [
        -314.76513671875,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -313.58343505859375,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1866047973162495e-05,
        1.0,
        -0.0
      ],
      "plane_d": 2283.31201171875,
      "bbox_min": [
        -313.58343505859375,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2278.30517578125,
      "bbox_min": [
        -314.76513671875,
        -2293.37109375,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2278.30517578125,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2293.37109375,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2289.12890625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933625936508179,
        0.693384051322937,
        -0.19612976908683777
      ],
      "plane_d": 1929.98193359375,
      "bbox_min": [
        -318.5,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.304931640625,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        -0.1961161345243454
      ],
      "plane_d": 428.80621337890625,
      "bbox_min": [
        -305.2983093261719,
        -2297.0,
        660.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2291.199951171875,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        -450.5,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -188.0,
        -2297.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 712.0,
      "bbox_min": [
        -450.5,
        -2388.5,
        618.0
      ],
      "bbox_max": [
        -188.0,
        -2297.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070879340171814,
        -0.7071256041526794,
        0.0
      ],
      "plane_d": -1872.5697021484375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -327.900390625,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.896294891834259,
        0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": 1390.914794921875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2322.099609375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 1251.2257080078125,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1927.423583984375,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -378.162841796875,
        -2358.548583984375,
        729.9866943359375
      ],
      "bbox_max": [
        -367.3384094238281,
        -2347.723876953125,
        730.4326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.162841796875,
        -2347.80029296875,
        729.9866943359375
      ],
      "bbox_max": [
        -378.0864562988281,
        -2347.723876953125,
        730.43212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -368.970458984375,
        -2358.548583984375,
        729.9866943359375
      ],
      "bbox_max": [
        -367.3384094238281,
        -2356.916259765625,
        730.43212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -368.970458984375,
        -2356.99267578125,
        729.9866943359375
      ],
      "bbox_max": [
        -368.8941650390625,
        -2356.916259765625,
        730.431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6860026717185974,
        0.6859864592552185,
        -0.2425343543291092
      ],
      "plane_d": 2046.92529296875,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1405.7440185546875,
      "bbox_min": [
        -378.0864562988281,
        -2358.47216796875,
        729.9866943359375
      ],
      "bbox_max": [
        -363.802978515625,
        -2344.1884765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -367.3384094238281,
        -2358.47216796875,
        729.9866943359375
      ],
      "bbox_max": [
        -363.802978515625,
        -2354.936767578125,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -378.0864562988281,
        -2349.27978515625,
        729.9866943359375
      ],
      "bbox_max": [
        -372.9952087402344,
        -2344.1884765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.53070068359375,
        -2349.27978515625,
        729.9866943359375
      ],
      "bbox_max": [
        -372.9952087402344,
        -2345.744140625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 1231.6060791015625,
      "bbox_min": [
        -396.462890625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1392.7440185546875,
      "bbox_min": [
        -396.462890625,
        -2358.47216796875,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2297.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -367.3384094238281,
        -2358.47216796875,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6801113486289978,
        0.6800045967102051,
        0.2739383578300476
      ],
      "plane_d": 1650.9686279296875,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        712.0
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -363.494873046875,
        -2353.072998046875,
        748.7863159179688
      ],
      "bbox_max": [
        -361.3681335449219,
        -2350.946044921875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.53070068359375,
        -2349.27978515625,
        729.6334228515625
      ],
      "bbox_max": [
        -370.5605163574219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.687255859375,
        -2343.880615234375,
        748.7863159179688
      ],
      "bbox_max": [
        -370.5605163574219,
        -2341.753662109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2312.454345703125,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2297.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -396.462890625,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.832523763179779,
        0.0,
        -0.5539893507957458
      ],
      "plane_d": 738.4376220703125,
      "bbox_min": [
        -388.71923828125,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -387.91162109375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -376.84716796875,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2375.3154296875,
      "bbox_min": [
        -333.60302734375,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2366.76416015625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -325.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -325.60009765625,
      "bbox_min": [
        -325.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": 2081.724609375,
      "bbox_min": [
        -325.60009765625,
        -2372.337890625,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -325.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1907.8232421875,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -345.0755310058594,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -324.4444885253906,
        -2303.0859375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7598690986633301,
        1.9076609532930888e-05,
        -0.650076150894165
      ],
      "plane_d": 225.38882446289062,
      "bbox_min": [
        -345.0755310058594,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -327.8636169433594,
        -2303.0859375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2996884286403656,
        -0.7232757806777954,
        -0.6221407055854797
      ],
      "plane_d": -1312.3388671875,
      "bbox_min": [
        -345.0755310058594,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -327.8636169433594,
        -2306.504638671875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -345.0755310058594,
        -2308.961669921875,
        746.0
      ],
      "bbox_max": [
        -341.653564453125,
        -2306.504638671875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.84716796875,
      "bbox_min": [
        -376.84716796875,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -318.5,
        -2355.699951171875,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071130871772766,
        -0.707100510597229,
        0.0
      ],
      "plane_d": -1422.54736328125,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -294.697998046875,
        -2306.50732421875,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8962944149971008,
        0.3712576925754547,
        -0.2425367832183838
      ],
      "plane_d": 820.87255859375,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6860024333000183,
        0.6859862804412842,
        -0.24253544211387634
      ],
      "plane_d": 1610.6280517578125,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827912509441376,
        0.9238348603248596,
        0.0
      ],
      "plane_d": 2078.644287109375,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 663.6388549804688,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707114577293396,
        0.7070989608764648,
        0.0
      ],
      "plane_d": 1477.69873046875,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": 2481.4453125,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": -55.33412170410156,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -244.53712463378906,
        -2304.60009765625,
        729.9784545898438
      ],
      "bbox_max": [
        -239.53173828125,
        -2302.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -244.53712463378906,
        -2304.60009765625,
        729.9993286132812
      ],
      "bbox_max": [
        -239.53173828125,
        -2304.60009765625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2375.3154296875,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -318.5,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071468830108643,
        -0.7070667147636414,
        -1.4101900887908414e-05
      ],
      "plane_d": -1856.5904541015625,
      "bbox_min": [
        -312.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -257.262939453125,
        -2340.9423828125,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": 1607.2313232421875,
      "bbox_min": [
        -274.0576477050781,
        -2355.631591796875,
        712.0
      ],
      "bbox_max": [
        -268.560791015625,
        -2350.134765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6800597310066223,
        0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": 1218.4066162109375,
      "bbox_min": [
        -274.0576477050781,
        -2355.631591796875,
        712.0
      ],
      "bbox_max": [
        -268.560791015625,
        -2350.134765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -274.0576477050781,
        -2352.261474609375,
        748.7863159179688
      ],
      "bbox_max": [
        -271.930908203125,
        -2350.134765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1841.484130859375,
      "bbox_min": [
        -264.8652648925781,
        -2346.989013671875,
        729.6334228515625
      ],
      "bbox_max": [
        -257.262939453125,
        -2340.9423828125,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071413397789001,
        -0.7070721983909607,
        -3.2521289540454745e-05
      ],
      "plane_d": -1843.5880126953125,
      "bbox_min": [
        -264.5076904296875,
        -2345.00927734375,
        748.7863159179688
      ],
      "bbox_max": [
        -262.354248046875,
        -2342.855712890625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -264.8652648925781,
        -2343.069091796875,
        748.7863159179688
      ],
      "bbox_max": [
        -262.738525390625,
        -2340.9423828125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071413397789001,
        -0.7070721983909607,
        -3.2521289540454745e-05
      ],
      "plane_d": -1843.5880126953125,
      "bbox_min": [
        -264.8652648925781,
        -2343.069091796875,
        748.7863159179688
      ],
      "bbox_max": [
        -264.294189453125,
        -2342.498046875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -312.60009765625,
      "bbox_min": [
        -312.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -312.60009765625,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.961749255657196,
        0.2739313840866089
      ],
      "plane_d": 2081.724609375,
      "bbox_min": [
        -312.60009765625,
        -2372.337890625,
        712.0
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -312.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2366.76416015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -239.537109375,
      "bbox_min": [
        -248.08302307128906,
        -2312.454345703125,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -239.537109375,
        -2302.39990234375,
        712.0
      ],
      "bbox_max": [
        -239.53173828125,
        -2302.39990234375,
        729.9993286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2302.39990234375,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -239.53695678710938,
        -2302.39990234375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9704055190086365,
        -0.0,
        -0.24148114025592804
      ],
      "plane_d": -59.13962936401367,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.961749255657196,
        0.0,
        0.2739313840866089
      ],
      "plane_d": -433.10260009765625,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -242.50927734375,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -248.08302307128906,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -247.275390625,
        -2302.39990234375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2297.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -311.9065246582031,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2303.036376953125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7566943764686584,
        -0.65376877784729
      ],
      "plane_d": -1268.0162353515625,
      "bbox_min": [
        -311.9065246582031,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -308.450927734375,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -291.2275390625,
        -2306.504638671875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29901179671287537,
        -0.7216429114341736,
        -0.6243584752082825
      ],
      "plane_d": -1116.3973388671875,
      "bbox_min": [
        -308.450927734375,
        -2323.7158203125,
        746.0
      ],
      "bbox_max": [
        -305.9815979003906,
        -2320.260009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2297.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -259.15283203125,
        -2308.552490234375,
        712.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2297.0,
        716.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -450.5,
        -2388.5,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 698.3675537109375,
      "bbox_min": [
        -450.5,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 450.5,
      "bbox_min": [
        -450.5,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2297.0,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 659.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2339.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.0,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 782.1765747070312,
      "bbox_min": [
        -435.0,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -433.0,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2335.0,
      "bbox_min": [
        -435.0,
        -2336.5,
        657.0000610351562
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -433.5,
        -2336.5,
        657.7500610351562
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -435.0,
        -2336.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2335.0,
      "bbox_min": [
        -435.0,
        -2335.0,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2335.0,
        657.7500610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 767.5643920898438,
      "bbox_min": [
        -427.0,
        -2337.0,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -422.0,
        -2337.0,
        658.0
      ],
      "bbox_max": [
        -402.5,
        -2306.0,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 415.5,
      "bbox_min": [
        -415.5,
        -2337.0,
        658.0
      ],
      "bbox_max": [
        -407.5,
        -2306.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 658.5,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2323.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 754.12939453125,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2323.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2337.0,
      "bbox_min": [
        -410.5,
        -2337.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2323.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2323.0,
      "bbox_min": [
        -410.5,
        -2323.0,
        658.5
      ],
      "bbox_max": [
        -407.5,
        -2323.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 154.8699188232422,
      "bbox_min": [
        -419.0,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -625.5,
      "bbox_min": [
        -419.0,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        672.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 636.5,
      "bbox_min": [
        -419.0,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2035.4044189453125,
      "bbox_min": [
        -414.66668701171875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -318.5,
        -2312.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -414.66668701171875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2312.800048828125,
        655.25
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2339.0,
      "bbox_min": [
        -414.66668701171875,
        -2339.0,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2312.800048828125,
        655.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 400.5,
      "bbox_min": [
        -402.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2312.800048828125,
        654.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2333.5,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2329.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 472.033935546875,
      "bbox_min": [
        -402.5,
        -2333.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2329.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 1620.03125,
      "bbox_min": [
        -402.5,
        -2333.5,
        644.5
      ],
      "bbox_max": [
        -400.5,
        -2329.5,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.189622163772583,
        0.9818571209907532,
        0.0
      ],
      "plane_d": 2222.25244140625,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269031047821045,
        -0.9238767027854919,
        0.0
      ],
      "plane_d": -1989.30810546875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.000679489690810442,
        -0.9999997615814209,
        0.0
      ],
      "plane_d": -2313.071533203125,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575925201177597,
        -0.987504243850708,
        0.0
      ],
      "plane_d": -2224.256103515625,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005305923405103385,
        -0.7808687090873718,
        -0.6246950030326843
      ],
      "plane_d": -1398.904541015625,
      "bbox_min": [
        -400.5,
        -2314.800048828125,
        652.0
      ],
      "bbox_max": [
        -391.158203125,
        -2312.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38177749514579773,
        0.9242542386054993,
        0.0
      ],
      "plane_d": 2014.5274658203125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2322.791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009321773541159928,
        0.9999995827674866,
        0.0
      ],
      "plane_d": 2338.42578125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        637.0
      ],
      "bbox_max": [
        -371.087890625,
        -2322.791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267284631729126,
        0.9238839149475098,
        0.0
      ],
      "plane_d": 2006.3314208984375,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        638.002197265625
      ],
      "bbox_max": [
        -371.087890625,
        -2322.791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14824633300304413,
        0.7680684924125671,
        -0.622971773147583
      ],
      "plane_d": 2144.59326171875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -371.087890625,
        -2331.060791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29812341928482056,
        0.7217341065406799,
        -0.6246777772903442
      ],
      "plane_d": 1980.3995361328125,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -371.087890625,
        -2331.060791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2994239926338196,
        0.7228582501411438,
        -0.6227529048919678
      ],
      "plane_d": 1981.2764892578125,
      "bbox_min": [
        -381.092041015625,
        -2336.80322265625,
        652.0
      ],
      "bbox_max": [
        -371.853271484375,
        -2331.060791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0007291665533557534,
        0.7822183966636658,
        -0.6230039000511169
      ],
      "plane_d": 2235.35888671875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -390.8095703125,
        -2336.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": 2233.59716796875,
      "bbox_min": [
        -400.5,
        -2338.800048828125,
        652.0
      ],
      "bbox_max": [
        -391.0,
        -2336.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -400.5,
        -2337.514404296875,
        638.002197265625
      ],
      "bbox_max": [
        -372.2547607421875,
        -2322.791015625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7808688282966614,
        -0.6246950626373291
      ],
      "plane_d": 2233.59716796875,
      "bbox_min": [
        -400.5,
        -2337.514404296875,
        653.6070556640625
      ],
      "bbox_max": [
        -398.77520751953125,
        -2336.800048828125,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -375.2789611816406,
        -2326.44140625,
        638.002197265625
      ],
      "bbox_max": [
        -372.2547607421875,
        -2322.791015625,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -371.0,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -318.5,
        -2348.3955078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -371.0,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -318.5,
        -2348.3955078125,
        672.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.5639112591743469,
        -0.8258353471755981
      ],
      "plane_d": -791.940673828125,
      "bbox_min": [
        -351.0,
        -2388.5,
        660.5
      ],
      "bbox_max": [
        -318.5,
        -2366.058349609375,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.24024011194705963,
        -0.9707134962081909
      ],
      "plane_d": 76.03041076660156,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -318.5,
        -2366.058349609375,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -332.0113830566406,
        -2368.5,
        664.5
      ],
      "bbox_max": [
        -329.5697326660156,
        -2366.058349609375,
        664.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -600.5906982421875,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -331.0,
        -2366.058349609375,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -332.0113830566406,
        -2368.5,
        660.5
      ],
      "bbox_max": [
        -331.0,
        -2366.058349609375,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2072.359375,
      "bbox_min": [
        -351.0,
        -2388.5,
        660.5
      ],
      "bbox_max": [
        -332.30828857421875,
        -2371.658447265625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -600.5906982421875,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -332.30828857421875,
        -2371.658447265625,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        -0.0
      ],
      "plane_d": 1249.1529541015625,
      "bbox_min": [
        -371.0,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3955078125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        -0.0
      ],
      "plane_d": 2341.005859375,
      "bbox_min": [
        -371.0,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3955078125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -371.0,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3955078125,
        660.5
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 351.7458190917969,
      "bbox_min": [
        -371.0,
        -2382.64208984375,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3994140625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829615712165833,
        -0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": -760.851318359375,
      "bbox_min": [
        -364.78857421875,
        -2382.64208984375,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3994140625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 1758.37255859375,
      "bbox_min": [
        -364.78857421875,
        -2368.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.3994140625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 2015.1109619140625,
      "bbox_min": [
        -351.0,
        -2368.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2348.669921875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 971.5848388671875,
      "bbox_min": [
        -335.42535400390625,
        -2368.5,
        636.5
      ],
      "bbox_max": [
        -331.5,
        -2362.64453125,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1922.976806640625,
      "bbox_min": [
        -338.27197265625,
        -2382.64208984375,
        636.5
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -371.0,
        -2383.64208984375,
        641.0
      ],
      "bbox_max": [
        -362.7281494140625,
        -2368.5,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -353.4143981933594,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -363.72802734375,
        -2387.5,
        651.5
      ],
      "bbox_max": [
        -351.0,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36527690291404724,
        -0.8818466663360596,
        -0.2981933653354645
      ],
      "plane_d": -2002.2723388671875,
      "bbox_min": [
        -351.0,
        -2349.511474609375,
        641.0
      ],
      "bbox_max": [
        -348.558349609375,
        -2348.3955078125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -349.7230529785156,
        -2348.435546875,
        641.0
      ],
      "bbox_max": [
        -349.6344299316406,
        -2348.3955078125,
        641.228271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.92223060131073,
        -0.10753936320543289,
        0.371383935213089
      ],
      "plane_d": -854.75390625,
      "bbox_min": [
        -403.0,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2332.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7747499346733093,
        -0.303447425365448,
        -0.5546910762786865
      ],
      "plane_d": -673.3114013671875,
      "bbox_min": [
        -400.368408203125,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -318.5,
        -2348.474853515625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6979433298110962,
        -0.6123253703117371,
        0.37139302492141724
      ],
      "plane_d": -1960.143798828125,
      "bbox_min": [
        -392.1980895996094,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -377.022216796875,
        -2373.01220703125,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2983502745628357,
        -0.8792362213134766,
        0.37139028310775757
      ],
      "plane_d": -2445.03076171875,
      "bbox_min": [
        -381.161376953125,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -377.022216796875,
        -2386.2900390625,
        628.4520874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6254514455795288,
        -0.548734724521637,
        -0.5547077655792236
      ],
      "plane_d": -1196.988525390625,
      "bbox_min": [
        -392.1980895996094,
        -2384.444580078125,
        630.5
      ],
      "bbox_max": [
        -381.01177978515625,
        -2373.01220703125,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6254514455795288,
        -0.548734724521637,
        -0.5547077655792236
      ],
      "plane_d": -1196.988525390625,
      "bbox_min": [
        -393.9701843261719,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -384.3669128417969,
        -2373.7158203125,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -600.5906372070312,
      "bbox_min": [
        -365.14208984375,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2348.474853515625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1758.393310546875,
      "bbox_min": [
        -365.14208984375,
        -2380.388916015625,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2348.474853515625,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829648494720459,
        -0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": -760.868896484375,
      "bbox_min": [
        -351.0,
        -2380.388916015625,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2348.5,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 2015.1109619140625,
      "bbox_min": [
        -351.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2348.5,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 971.5848388671875,
      "bbox_min": [
        -332.8647766113281,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2365.205078125,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -332.0112609863281,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -331.0,
        -2366.05859375,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3806573450565338,
        -0.9189779758453369,
        0.10285679250955582
      ],
      "plane_d": -2357.14453125,
      "bbox_min": [
        -351.0,
        -2349.51123046875,
        635.0
      ],
      "bbox_max": [
        -348.55865478515625,
        -2348.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -351.0,
        -2349.230224609375,
        635.0
      ],
      "bbox_max": [
        -348.83966064453125,
        -2348.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -351.0,
        -2348.5,
        635.0
      ],
      "bbox_max": [
        -350.6807556152344,
        -2348.474853515625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2368.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -370.5,
        -2368.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8645309209823608,
        -0.3386213779449463,
        0.3713782727718353
      ],
      "plane_d": -1375.7742919921875,
      "bbox_min": [
        -400.368408203125,
        -2385.861328125,
        625.5
      ],
      "bbox_max": [
        -382.4294128417969,
        -2354.195556640625,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6979433298110962,
        -0.6123253703117371,
        0.37139302492141724
      ],
      "plane_d": -1960.143798828125,
      "bbox_min": [
        -392.776123046875,
        -2385.861328125,
        625.5
      ],
      "bbox_max": [
        -382.4294128417969,
        -2373.01220703125,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7747499346733093,
        -0.303447425365448,
        -0.5546910762786865
      ],
      "plane_d": -673.3114013671875,
      "bbox_min": [
        -400.0160827636719,
        -2376.37939453125,
        630.5
      ],
      "bbox_max": [
        -393.40887451171875,
        -2354.195556640625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6254514455795288,
        -0.548734724521637,
        -0.5547077655792236
      ],
      "plane_d": -1196.988525390625,
      "bbox_min": [
        -394.5107421875,
        -2376.37939453125,
        635.5650634765625
      ],
      "bbox_max": [
        -393.40887451171875,
        -2374.79443359375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2072.359375,
      "bbox_min": [
        -391.0771789550781,
        -2388.5,
        625.9999389648438
      ],
      "bbox_max": [
        -335.8646240234375,
        -2379.037109375,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6254514455795288,
        -0.548734724521637,
        -0.5547077655792236
      ],
      "plane_d": -1196.988525390625,
      "bbox_min": [
        -391.0771789550781,
        -2388.5,
        625.9999389648438
      ],
      "bbox_max": [
        -335.8646240234375,
        -2379.037109375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2673586905002594,
        -0.7879223823547363,
        -0.554705023765564
      ],
      "plane_d": -1631.5135498046875,
      "bbox_min": [
        -381.958251953125,
        -2388.5,
        627.6697387695312
      ],
      "bbox_max": [
        -335.8646240234375,
        -2379.037109375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -600.5906372070312,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -335.924560546875,
        -2380.388916015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1922.976806640625,
      "bbox_min": [
        -337.21142578125,
        -2382.64208984375,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2382.28857421875,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2983502745628357,
        -0.8792362213134766,
        0.37139028310775757
      ],
      "plane_d": -2445.03076171875,
      "bbox_min": [
        -380.01123046875,
        -2388.5,
        627.6697387695312
      ],
      "bbox_max": [
        -371.4205322265625,
        -2385.5849609375,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2983502745628357,
        -0.8792362213134766,
        0.37139028310775757
      ],
      "plane_d": -2445.03076171875,
      "bbox_min": [
        -381.01177978515625,
        -2388.5,
        625.9999389648438
      ],
      "bbox_max": [
        -374.943603515625,
        -2384.444580078125,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6979433298110962,
        -0.6123253703117371,
        0.37139302492141724
      ],
      "plane_d": -1960.143798828125,
      "bbox_min": [
        -381.01177978515625,
        -2386.2900390625,
        628.4520874023438
      ],
      "bbox_max": [
        -380.01123046875,
        -2384.444580078125,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 16.086294174194336,
      "bbox_min": [
        -419.0,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -398.60003662109375,
        -2297.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264503479003906,
        -0.09637215733528137,
        -0.5547000765800476
      ],
      "plane_d": -206.40806579589844,
      "bbox_min": [
        -405.0,
        -2388.5,
        630.5
      ],
      "bbox_max": [
        -398.60003662109375,
        -2332.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7747499346733093,
        -0.303447425365448,
        -0.5546910762786865
      ],
      "plane_d": -673.3114013671875,
      "bbox_min": [
        -402.324951171875,
        -2364.682861328125,
        632.9597778320312
      ],
      "bbox_max": [
        -398.60003662109375,
        -2354.59619140625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7647056579589844,
        0.3279269337654114,
        -0.5546973943710327
      ],
      "plane_d": 1443.730224609375,
      "bbox_min": [
        -405.0,
        -2388.5,
        633.8226928710938
      ],
      "bbox_max": [
        -400.74029541015625,
        -2381.504638671875,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000794172286987,
        0.5763813257217407,
        -0.5546974539756775
      ],
      "plane_d": 1970.227783203125,
      "bbox_min": [
        -403.9261779785156,
        -2388.5,
        633.8226928710938
      ],
      "bbox_max": [
        -400.74029541015625,
        -2386.13037109375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8533220291137695,
        0.3659290075302124,
        0.3713993430137634
      ],
      "plane_d": 986.603759765625,
      "bbox_min": [
        -415.726806640625,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -403.21514892578125,
        -2365.577880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7647056579589844,
        0.3279269337654114,
        -0.5546973943710327
      ],
      "plane_d": 1443.730224609375,
      "bbox_min": [
        -415.726806640625,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -403.21514892578125,
        -2365.577880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6696208715438843,
        0.6431839466094971,
        0.37137895822525024
      ],
      "plane_d": 1574.1484375,
      "bbox_min": [
        -406.405517578125,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -403.21514892578125,
        -2386.733154296875,
        634.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000794172286987,
        0.5763813257217407,
        -0.5546974539756775
      ],
      "plane_d": 1970.227783203125,
      "bbox_min": [
        -406.405517578125,
        -2388.5,
        630.5
      ],
      "bbox_max": [
        -403.21514892578125,
        -2386.733154296875,
        634.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        -9.773058309292537e-07
      ],
      "plane_d": 1231.606689453125,
      "bbox_min": [
        -401.0699157714844,
        -2379.56982421875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38269031047821045,
        -0.9238767027854919,
        0.0
      ],
      "plane_d": -1989.30810546875,
      "bbox_min": [
        -401.0699157714844,
        -2328.06494140625,
        630.3251953125
      ],
      "bbox_max": [
        -368.92333984375,
        -2297.0,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.371390700340271
      ],
      "plane_d": -606.4810180664062,
      "bbox_min": [
        -401.0699157714844,
        -2297.06982421875,
        630.3251953125
      ],
      "bbox_max": [
        -401.0,
        -2297.0,
        630.6048583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 16.086294174194336,
      "bbox_min": [
        -401.0699157714844,
        -2297.06982421875,
        630.5
      ],
      "bbox_max": [
        -401.0,
        -2297.0,
        630.6048583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -385.26593017578125,
        -2328.06494140625,
        637.0
      ],
      "bbox_max": [
        -368.92333984375,
        -2310.735595703125,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -385.26593017578125,
        -2322.791015625,
        637.0
      ],
      "bbox_max": [
        -375.2789001464844,
        -2310.735595703125,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -378.359130859375,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 1232.733154296875,
      "bbox_min": [
        -378.359130859375,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38271352648735046,
        -0.9238670468330383,
        0.0
      ],
      "plane_d": -1994.2769775390625,
      "bbox_min": [
        -378.359130859375,
        -2325.815185546875,
        638.002197265625
      ],
      "bbox_max": [
        -370.995361328125,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267284631729126,
        0.9238839149475098,
        0.0
      ],
      "plane_d": 2006.3314208984375,
      "bbox_min": [
        -372.2547607421875,
        -2325.815185546875,
        638.002197265625
      ],
      "bbox_max": [
        -370.995361328125,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828117847442627,
        -0.9238263368606567,
        0.0
      ],
      "plane_d": -1991.14599609375,
      "bbox_min": [
        -376.735595703125,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2009.4239501953125,
      "bbox_min": [
        -369.84716796875,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -368.92333984375,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        4.359517788543599e-06
      ],
      "plane_d": 376.8681640625,
      "bbox_min": [
        -376.84716796875,
        -2379.56982421875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -376.8470458984375,
        -2379.56982421875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3806573450565338,
        -0.9189779758453369,
        0.10285679250955582
      ],
      "plane_d": -2357.14453125,
      "bbox_min": [
        -349.6744689941406,
        -2379.56982421875,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2348.16796875,
        667.2396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -336.85791015625,
        -2362.241943359375,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2354.35791015625,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2312.496337890625,
      "bbox_min": [
        -336.85791015625,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -336.85791015625,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2354.695556640625,
        632.5
      ],
      "bbox_max": [
        -336.7180480957031,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -330.6719055175781,
        -2362.241943359375,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2357.199951171875,
        632.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3765573501586914,
        -0.9214465022087097,
        0.09560827910900116
      ],
      "plane_d": -2356.89990234375,
      "bbox_min": [
        -349.6744689941406,
        -2379.56982421875,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2348.16796875,
        667.2396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -347.9140625,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        650.49609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.9140625,
        -2348.256591796875,
        649.5
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        650.49609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -349.6744689941406,
        -2379.56982421875,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2348.16796875,
        667.2396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.24024011194705963,
        -0.9707134962081909
      ],
      "plane_d": 76.03041076660156,
      "bbox_min": [
        -329.5697326660156,
        -2379.56982421875,
        664.5
      ],
      "bbox_max": [
        -318.5,
        -2368.5,
        667.2396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -336.85791015625,
        -2357.199951171875,
        656.0
      ],
      "bbox_max": [
        -326.0799560546875,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2819654643535614,
        -0.9448255300521851,
        -0.16673390567302704
      ],
      "plane_d": -2209.31201171875,
      "bbox_min": [
        -336.85791015625,
        -2357.199951171875,
        656.0
      ],
      "bbox_max": [
        -329.699951171875,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2355.99072265625,
        660.5
      ],
      "bbox_max": [
        -336.1815490722656,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -349.67431640625,
        -2356.052001953125,
        656.0
      ],
      "bbox_max": [
        -336.1562194824219,
        -2348.256591796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2356.052001953125,
        660.5
      ],
      "bbox_max": [
        -336.1562194824219,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.67431640625,
        -2348.3955078125,
        656.0
      ],
      "bbox_max": [
        -347.9140625,
        -2348.256591796875,
        658.5668334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -349.6743469238281,
        -2366.058349609375,
        656.0
      ],
      "bbox_max": [
        -332.0113830566406,
        -2348.256591796875,
        664.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2366.058349609375,
        660.5
      ],
      "bbox_max": [
        -332.0113830566406,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.6743469238281,
        -2348.3955078125,
        656.0
      ],
      "bbox_max": [
        -347.9140625,
        -2348.256591796875,
        658.4395141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -349.6744689941406,
        -2379.56982421875,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2348.16796875,
        656.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -349.6744689941406,
        -2366.05859375,
        632.5
      ],
      "bbox_max": [
        -332.0112609863281,
        -2348.16796875,
        656.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 2015.142822265625,
      "bbox_min": [
        -348.55865478515625,
        -2366.05859375,
        632.5
      ],
      "bbox_max": [
        -332.0112609863281,
        -2349.51123046875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 971.6419067382812,
      "bbox_min": [
        -338.27197265625,
        -2366.05859375,
        632.5
      ],
      "bbox_max": [
        -332.0112609863281,
        -2354.35791015625,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2366.05859375,
        632.5
      ],
      "bbox_max": [
        -332.0112609863281,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07863236218690872,
        -0.996903657913208,
        0.0
      ],
      "plane_d": -2313.628173828125,
      "bbox_min": [
        -349.6744689941406,
        -2348.3955078125,
        641.228271484375
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.9140625,
        -2348.256591796875,
        649.5
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -376.8470458984375,
        -2360.3408203125,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -326.0799560546875,
        -2360.3408203125,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2357.199951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -326.0799560546875,
        -2360.3408203125,
        632.5
      ],
      "bbox_max": [
        -318.5,
        -2357.199951171875,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -376.8470458984375,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2339.699951171875,
      "bbox_min": [
        -325.699951171875,
        -2339.699951171875,
        618.0
      ],
      "bbox_max": [
        -318.5,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.840087890625,
        -2355.699951171875,
        620.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": -2009.306640625,
      "bbox_min": [
        -376.576904296875,
        -2329.530029296875,
        620.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268962502479553,
        0.923876941204071,
        0.0
      ],
      "plane_d": 1991.308837890625,
      "bbox_min": [
        -376.576904296875,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -341.8866882324219,
        -2297.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3630546033382416,
        0.8764746785163879,
        0.31620171666145325
      ],
      "plane_d": 1691.196533203125,
      "bbox_min": [
        -376.576904296875,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -341.8866882324219,
        -2297.0,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630538284778595,
        -0.8764702081680298,
        0.31621500849723816
      ],
      "plane_d": -2104.15576171875,
      "bbox_min": [
        -368.92333984375,
        -2329.530029296875,
        620.0
      ],
      "bbox_max": [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -323.794677734375,
        -2310.989013671875,
        620.0
      ],
      "bbox_max": [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2388.4580078125,
      "bbox_min": [
        -323.794677734375,
        -2310.989013671875,
        620.0
      ],
      "bbox_max": [
        -318.5,
        -2308.989013671875,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -376.840087890625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -319.5,
      "bbox_min": [
        -376.840087890625,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -319.5,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2310.260009765625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -319.5,
        -2320.260009765625,
        704.0
      ],
      "bbox_max": [
        -318.5,
        -2320.260009765625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -319.5,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -318.5,
        -2310.260009765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": 511.431884765625,
      "bbox_min": [
        -319.5,
        -2355.699951171875,
        690.0
      ],
      "bbox_max": [
        -318.5,
        -2352.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -341.6533508300781,
        -2298.5,
        704.0
      ],
      "bbox_max": [
        -341.6533203125,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -376.840087890625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -331.6534423828125,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552192211151123,
        -0.0,
        0.8797038793563843
      ],
      "plane_d": -429.5593566894531,
      "bbox_min": [
        -376.840087890625,
        -2298.5,
        690.0
      ],
      "bbox_max": [
        -373.14013671875,
        -2297.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        690.9890747070312
      ],
      "bbox_max": [
        -319.5,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707112193107605,
        1.54620865941979e-05,
        -0.7071013450622559
      ],
      "plane_d": 256.2476501464844,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        691.2666625976562
      ],
      "bbox_max": [
        -319.5,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        704.0
      ],
      "bbox_max": [
        -319.5,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.5105127861024812e-05,
        0.0
      ],
      "plane_d": -341.5956726074219,
      "bbox_min": [
        -341.653564453125,
        -2306.507568359375,
        704.0
      ],
      "bbox_max": [
        -341.6533508300781,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.653564453125,
        -2302.365234375,
        691.2666625976562
      ],
      "bbox_max": [
        -331.6534729003906,
        -2298.5,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -323.75830078125,
        -2310.260009765625,
        690.9890747070312
      ],
      "bbox_max": [
        -319.5,
        -2310.260009765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070848941802979,
        -0.707128643989563,
        0.0
      ],
      "plane_d": -1862.57568359375,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2298.5,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552189230918884,
        -0.8797038793563843,
        0.0
      ],
      "plane_d": -1844.5631103515625,
      "bbox_min": [
        -376.840087890625,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -319.5,
        -2298.5,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": 511.431884765625,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        690.0
      ],
      "bbox_max": [
        -319.5,
        -2352.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.0,
      "bbox_min": [
        -376.840087890625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22238557040691376,
        0.5366692543029785,
        -0.8139599561691284
      ],
      "plane_d": 1860.9285888671875,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38281548023223877,
        0.9238248467445374,
        -0.0
      ],
      "plane_d": 2297.564453125,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -318.5,
        -2342.578125,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -318.5,
        -2342.578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -351.334228515625,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -318.5,
        -2342.578125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831441342830658,
        0.5556125640869141,
        0.0
      ],
      "plane_d": 1011.7618408203125,
      "bbox_min": [
        -351.334228515625,
        -2348.16796875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2343.637451171875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -328.72412109375,
        -2355.03271484375,
        646.5
      ],
      "bbox_max": [
        -318.5,
        -2350.796142578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        656.0
      ],
      "bbox_max": [
        -318.5,
        -2350.796142578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -328.72412109375,
        -2355.03271484375,
        646.5
      ],
      "bbox_max": [
        -318.5,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -318.5,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -330.8533630371094,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -323.794677734375,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -318.5,
        -2308.989013671875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5809391736984253,
        -0.8139470219612122
      ],
      "plane_d": 1891.8863525390625,
      "bbox_min": [
        -330.8533630371094,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -318.5,
        -2350.796142578125,
        649.2933349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -330.8533630371094,
        -2309.4599609375,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999878406524658,
        -0.5000045299530029,
        -0.7071121335029602
      ],
      "plane_d": -851.0288696289062,
      "bbox_min": [
        -330.8533630371094,
        -2309.4599609375,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 231.46905517578125,
      "bbox_min": [
        -330.8533630371094,
        -2309.4599609375,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.670008168730419e-05,
        -0.7070814967155457,
        -0.70713210105896
      ],
      "plane_d": -1167.5474853515625,
      "bbox_min": [
        -330.8533630371094,
        -2309.4599609375,
        655.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805718064308167,
        2.144169957318809e-05,
        -0.1961604505777359
      ],
      "plane_d": -195.10638427734375,
      "bbox_min": [
        -330.8533630371094,
        -2309.4599609375,
        658.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": 2444.40576171875,
      "bbox_min": [
        -336.6533203125,
        -2355.699951171875,
        659.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8797038793563843,
        0.47552192211151123,
        0.0
      ],
      "plane_d": 837.3621826171875,
      "bbox_min": [
        -321.5,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -319.5,
        -2352.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1867.5323486328125,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        659.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        659.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070877552032471,
        -0.7071258425712585,
        0.0
      ],
      "plane_d": -1864.5701904296875,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.693355143070221,
        -0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": -1960.546875,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805803894996643,
        1.867060927907005e-05,
        0.19611762464046478
      ],
      "plane_d": -459.3144226074219,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805760979652405,
        0.1961391568183899
      ],
      "plane_d": -2399.544921875,
      "bbox_min": [
        -333.653564453125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        1.9040366169065237e-05,
        0.0
      ],
      "plane_d": -333.6097106933594,
      "bbox_min": [
        -333.653564453125,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805810451507568,
        -2.4826093067531474e-05,
        -0.19611415266990662
      ],
      "plane_d": 457.4548645019531,
      "bbox_min": [
        -331.81640625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999994039535522,
        -2.1604791982099414e-05,
        0.0010726567124947906
      ],
      "plane_d": 331.0437316894531,
      "bbox_min": [
        -331.81640625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2310.460205078125,
        674.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.986572265625,
      "bbox_min": [
        -320.986572265625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -320.986572265625,
        -2312.26025390625,
        672.0
      ],
      "bbox_max": [
        -318.5,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -323.75830078125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2310.260009765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -321.58660888671875,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -318.5,
        -2315.26025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -336.6533203125,
        -2302.365234375,
        663.0
      ],
      "bbox_max": [
        -331.6534423828125,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2300.194091796875,
        663.0
      ],
      "bbox_max": [
        -336.6533203125,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070848941802979,
        -0.707128643989563,
        0.0
      ],
      "plane_d": -1862.57568359375,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        684.0
      ],
      "bbox_max": [
        -322.7683410644531,
        -2301.375244140625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.1866526367375627e-05,
        0.0
      ],
      "plane_d": -331.60321044921875,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        684.0
      ],
      "bbox_max": [
        -322.7683410644531,
        -2301.375244140625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -323.75830078125,
        -2310.260009765625,
        684.0
      ],
      "bbox_max": [
        -322.7683410644531,
        -2310.260009765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -336.6533203125,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -321.58660888671875,
        -2300.194091796875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6533203125,
      "bbox_min": [
        -336.6533203125,
        -2304.436279296875,
        663.0
      ],
      "bbox_max": [
        -336.6533203125,
        -2300.194091796875,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6933562755584717,
        -0.69339919090271,
        -0.1960984170436859
      ],
      "plane_d": -1696.3990478515625,
      "bbox_min": [
        -331.653564453125,
        -2310.260009765625,
        659.0
      ],
      "bbox_max": [
        -318.5,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.144189966202248e-05,
        -0.9805810451507568,
        -0.1961144208908081
      ],
      "plane_d": -2135.38037109375,
      "bbox_min": [
        -323.75830078125,
        -2310.260009765625,
        659.0
      ],
      "bbox_max": [
        -318.5,
        -2309.4599609375,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -318.5,
        -2388.5,
        618.0
      ],
      "bbox_max": [
        -207.0,
        -2297.0,
        712.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -625.5,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -207.0,
        -2297.0,
        672.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 169.1835479736328,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -207.0,
        -2297.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -228.66668701171875,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2316.5,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -226.3333282470703,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2316.5,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -224.33334350585938,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2316.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -224.33334350585938,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -435.6412658691406,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -217.0,
        -2297.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 636.5,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -217.0,
        -2297.0,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1151.221923828125,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -222.0,
        -2311.052490234375,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -222.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -255.0,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -222.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -222.0,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -222.0,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -245.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2329.0,
        641.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -226.3333282470703,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -245.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -226.3333282470703,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -245.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -226.3333282470703,
        -2325.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2325.0,
      "bbox_min": [
        -245.0,
        -2325.0,
        638.0
      ],
      "bbox_max": [
        -243.39990234375,
        -2325.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -262.233154296875,
        -2331.5,
        652.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5747867226600647,
        -0.8183032274246216,
        0.0
      ],
      "plane_d": -1746.5738525390625,
      "bbox_min": [
        -257.640869140625,
        -2315.35498046875,
        652.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -267.07666015625,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.1622924804688,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267284631729126,
        0.9238839149475098,
        -0.0
      ],
      "plane_d": 2249.711181640625,
      "bbox_min": [
        -265.004638671875,
        -2326.44140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2252.759765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5747867226600647,
        -0.8183032274246216,
        0.0
      ],
      "plane_d": -1746.5738525390625,
      "bbox_min": [
        -260.41259765625,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.161376953125,
      "bbox_min": [
        -260.41259765625,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -260.41259765625,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828117847442627,
        -0.9238263368606567,
        -0.0
      ],
      "plane_d": -2234.6142578125,
      "bbox_min": [
        -260.188232421875,
        -2311.435302734375,
        638.002197265625
      ],
      "bbox_max": [
        -259.264404296875,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2351.7880859375,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2351.7880859375,
        672.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": -2315.74853515625,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        660.5
      ],
      "bbox_max": [
        -285.0,
        -2385.93017578125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5639112591743469,
        -0.8258353471755981
      ],
      "plane_d": -791.940673828125,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        670.2453002929688
      ],
      "bbox_max": [
        -285.0,
        -2385.93017578125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 661.5665893554688,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2351.7880859375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": 2097.616943359375,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2351.7880859375,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2351.7880859375,
        651.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.8829615712165833,
        0.3657243251800537,
        0.2943204939365387
      ],
      "plane_d": 913.3093872070312,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -265.0,
        -2352.21484375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": -2315.74853515625,
      "bbox_min": [
        -291.20379638671875,
        -2388.5,
        636.5
      ],
      "bbox_max": [
        -271.21142578125,
        -2352.21484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1991.0040283203125,
      "bbox_min": [
        -277.76873779296875,
        -2355.77197265625,
        636.5
      ],
      "bbox_max": [
        -271.21142578125,
        -2352.21484375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -273.2718200683594,
        -2383.64208984375,
        641.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -287.4140319824219,
        -2388.5,
        641.0
      ],
      "bbox_max": [
        -272.27197265625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -291.20379638671875,
        -2387.5,
        651.5
      ],
      "bbox_max": [
        -285.0,
        -2384.22314453125,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7747375965118408,
        -0.30344969034194946,
        -0.5547070503234863
      ],
      "plane_d": -180.56866455078125,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -235.631591796875,
        -2351.7880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1151.221923828125,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -254.04176330566406,
        -2351.7880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26736271381378174,
        -0.787924587726593,
        -0.5546998977661133
      ],
      "plane_d": -1461.48095703125,
      "bbox_min": [
        -257.68475341796875,
        -2388.5,
        629.6275634765625
      ],
      "bbox_max": [
        -254.04176330566406,
        -2385.5849609375,
        635.5790405273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983483672142029,
        -0.8792400360107422,
        0.37138280272483826
      ],
      "plane_d": -2255.284912109375,
      "bbox_min": [
        -257.68475341796875,
        -2386.483642578125,
        629.6275634765625
      ],
      "bbox_max": [
        -255.98876953125,
        -2385.5849609375,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 913.3662109375,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -256.7156677246094,
        -2351.7880859375,
        636.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26736271381378174,
        -0.787924587726593,
        -0.5546998977661133
      ],
      "plane_d": -1461.48095703125,
      "bbox_min": [
        -277.2384338378906,
        -2388.5,
        627.6697387695312
      ],
      "bbox_max": [
        -256.7156677246094,
        -2351.7880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1991.0040283203125,
      "bbox_min": [
        -277.2384338378906,
        -2354.71142578125,
        635.0
      ],
      "bbox_max": [
        -270.85791015625,
        -2351.7880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -277.0616760253906,
        -2354.35791015625,
        635.0
      ],
      "bbox_max": [
        -270.85791015625,
        -2351.7880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983483672142029,
        -0.8792400360107422,
        0.37138280272483826
      ],
      "plane_d": -2255.284912109375,
      "bbox_min": [
        -264.5794677734375,
        -2388.5,
        627.6697387695312
      ],
      "bbox_max": [
        -257.5509033203125,
        -2386.160400390625,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7428444623947144,
        0.6694639921188354
      ],
      "plane_d": -2193.368408203125,
      "bbox_min": [
        -292.2682189941406,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -285.0,
        -2385.93017578125,
        628.8513793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -271.46136474609375,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -265.0,
        -2354.10791015625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2368.5,
      "bbox_min": [
        -265.5,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -265.0,
        -2368.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6979441046714783,
        -0.6123308539390564,
        0.3713825047016144
      ],
      "plane_d": -1516.258056640625,
      "bbox_min": [
        -261.05633544921875,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -244.958251953125,
        -2373.01220703125,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983483672142029,
        -0.8792400360107422,
        0.37138280272483826
      ],
      "plane_d": -2255.284912109375,
      "bbox_min": [
        -261.05633544921875,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -254.838623046875,
        -2385.5849609375,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8645297288894653,
        -0.33861953020095825,
        0.37138277292251587
      ],
      "plane_d": -825.931396484375,
      "bbox_min": [
        -253.57131958007812,
        -2385.862060546875,
        625.5
      ],
      "bbox_max": [
        -235.631591796875,
        -2354.195556640625,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6979441046714783,
        -0.6123308539390564,
        0.3713825047016144
      ],
      "plane_d": -1516.258056640625,
      "bbox_min": [
        -253.57131958007812,
        -2385.862060546875,
        625.5
      ],
      "bbox_max": [
        -243.223876953125,
        -2373.01220703125,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7747375965118408,
        -0.30344969034194946,
        -0.5547070503234863
      ],
      "plane_d": -180.56866455078125,
      "bbox_min": [
        -242.59121704101562,
        -2376.379638671875,
        630.5
      ],
      "bbox_max": [
        -235.98391723632812,
        -2354.195556640625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6254568099975586,
        -0.5487351417541504,
        -0.5547012686729431
      ],
      "plane_d": -799.2052612304688,
      "bbox_min": [
        -242.59121704101562,
        -2376.379638671875,
        635.5650024414062
      ],
      "bbox_max": [
        -241.4892578125,
        -2374.79443359375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 545.270263671875,
      "bbox_min": [
        -237.40000915527344,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -217.0,
        -2297.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8264561295509338,
        -0.09636972099542618,
        -0.5546919703483582
      ],
      "plane_d": 319.2162780761719,
      "bbox_min": [
        -237.40000915527344,
        -2388.5,
        630.5
      ],
      "bbox_max": [
        -230.99996948242188,
        -2332.0,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7747375965118408,
        -0.30344969034194946,
        -0.5547070503234863
      ],
      "plane_d": -180.56866455078125,
      "bbox_min": [
        -237.40000915527344,
        -2364.68310546875,
        632.9597778320312
      ],
      "bbox_max": [
        -233.675048828125,
        -2354.59619140625,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7646957635879517,
        0.32792800664901733,
        -0.554710328578949
      ],
      "plane_d": 957.390380859375,
      "bbox_min": [
        -235.2596893310547,
        -2388.5,
        633.8226928710938
      ],
      "bbox_max": [
        -230.99996948242188,
        -2381.504638671875,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.600075364112854,
        0.5763806104660034,
        -0.5547025799751282
      ],
      "plane_d": 1588.5797119140625,
      "bbox_min": [
        -235.2596893310547,
        -2388.5,
        633.8226928710938
      ],
      "bbox_max": [
        -232.0738067626953,
        -2386.13037109375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8533269762992859,
        0.36593613028526306,
        0.371381014585495
      ],
      "plane_d": 443.9182434082031,
      "bbox_min": [
        -232.7848358154297,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -220.273193359375,
        -2365.577880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7646957635879517,
        0.32792800664901733,
        -0.554710328578949
      ],
      "plane_d": 957.390380859375,
      "bbox_min": [
        -232.7848358154297,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -220.273193359375,
        -2365.577880859375,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6696200370788574,
        0.6431792378425598,
        0.37138861417770386
      ],
      "plane_d": 1148.25244140625,
      "bbox_min": [
        -232.7848358154297,
        -2388.5,
        625.5
      ],
      "bbox_max": [
        -229.594482421875,
        -2386.7333984375,
        634.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.600075364112854,
        0.5763806104660034,
        -0.5547025799751282
      ],
      "plane_d": 1588.5797119140625,
      "bbox_min": [
        -232.7848358154297,
        -2388.5,
        630.5
      ],
      "bbox_max": [
        -229.594482421875,
        -2386.7333984375,
        634.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -318.5,
        -2388.5,
        618.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -318.5,
        -2388.5,
        618.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2278.793212890625,
      "bbox_min": [
        -318.5,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3806525468826294,
        -0.9189664125442505,
        0.10297729074954987
      ],
      "plane_d": -2115.09716796875,
      "bbox_min": [
        -318.5,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9961298704147339,
        0.08789381384849548
      ],
      "plane_d": -2403.670166015625,
      "bbox_min": [
        -318.5,
        -2362.656494140625,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2077.7978515625,
      "bbox_min": [
        -306.300048828125,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -306.300048828125,
        -2357.199951171875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -299.2821044921875,
        -2354.696044921875,
        632.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -318.5,
        -2362.656494140625,
        632.5
      ],
      "bbox_max": [
        -305.326904296875,
        -2357.199951171875,
        632.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.37654542922973633,
        -0.9214403629302979,
        0.09571424126625061
      ],
      "plane_d": -2117.4658203125,
      "bbox_min": [
        -318.5,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -306.3046875,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        650.4846801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -288.1221923828125,
        -2348.2548828125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        650.4846801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -318.5,
        -2388.5,
        626.0
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        672.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": -2315.74853515625,
      "bbox_min": [
        -299.14208984375,
        -2385.93017578125,
        628.8513793945312
      ],
      "bbox_max": [
        -291.20379638671875,
        -2382.64208984375,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -318.5,
        -2388.5,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        672.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.5639112591743469,
        -0.8258353471755981
      ],
      "plane_d": -791.940673828125,
      "bbox_min": [
        -318.5,
        -2388.5,
        660.5
      ],
      "bbox_max": [
        -291.20379638671875,
        -2354.35791015625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.24024011194705963,
        -0.9707134962081909
      ],
      "plane_d": 76.03041076660156,
      "bbox_min": [
        -318.5,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -318.5,
        -2368.5,
        661.0
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -318.5,
        -2368.5,
        661.0
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        664.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.28187909722328186,
        -0.9448241591453552,
        -0.16688749194145203
      ],
      "plane_d": -2029.9031982421875,
      "bbox_min": [
        -309.9205017089844,
        -2357.199951171875,
        661.106689453125
      ],
      "bbox_max": [
        -300.2277526855469,
        -2354.7890625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -309.9205017089844,
        -2357.199951171875,
        661.57568359375
      ],
      "bbox_max": [
        -306.300048828125,
        -2356.683837890625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1188.177001953125,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2368.5,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -308.676513671875,
        -2356.683837890625,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        661.57568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3690228760242462,
        -0.9294202923774719,
        0.0
      ],
      "plane_d": -2077.7978515625,
      "bbox_min": [
        -300.2277526855469,
        -2354.7890625,
        660.5
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        661.106689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1188.177001953125,
      "bbox_min": [
        -303.69171142578125,
        -2385.93017578125,
        660.5
      ],
      "bbox_max": [
        -291.20379638671875,
        -2371.658447265625,
        670.2453002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": -2315.74853515625,
      "bbox_min": [
        -299.14208984375,
        -2385.93017578125,
        660.5
      ],
      "bbox_max": [
        -291.20379638671875,
        -2382.64208984375,
        670.2453002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07918098568916321,
        -0.9968602657318115,
        -0.0
      ],
      "plane_d": -2363.69287109375,
      "bbox_min": [
        -308.21893310546875,
        -2385.93017578125,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.16748046875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -288.2933349609375,
        -2348.2548828125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -288.2933349609375,
        -2348.2548828125,
        656.0
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -308.21893310546875,
        -2385.93017578125,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.23828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3652403652667999,
        -0.8817585110664368,
        -0.2984985113143921
      ],
      "plane_d": -1769.55810546875,
      "bbox_min": [
        -308.21893310546875,
        -2356.494140625,
        656.0
      ],
      "bbox_max": [
        -285.0,
        -2348.2548828125,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28187909722328186,
        -0.9448241591453552,
        -0.16688749194145203
      ],
      "plane_d": -2029.9031982421875,
      "bbox_min": [
        -308.21893310546875,
        -2356.494140625,
        656.0
      ],
      "bbox_max": [
        -299.14208984375,
        -2354.35791015625,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9847835302352905,
        -0.17378532886505127
      ],
      "plane_d": -2205.851318359375,
      "bbox_min": [
        -308.21893310546875,
        -2356.494140625,
        656.0
      ],
      "bbox_max": [
        -306.30224609375,
        -2355.699951171875,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": -2315.74853515625,
      "bbox_min": [
        -305.0,
        -2385.93017578125,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.398681640625,
        651.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -305.0,
        -2385.93017578125,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.398681640625,
        651.5
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        -0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": -1322.4345703125,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8829648494720459,
        0.3657400906085968,
        0.2942911386489868
      ],
      "plane_d": 410.0762634277344,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3657400906085968,
        0.8829648494720459,
        0.2942911386489868
      ],
      "plane_d": 1782.5321044921875,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": -1188.177001953125,
      "bbox_min": [
        -305.0,
        -2382.64208984375,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 624.6114501953125,
      "bbox_min": [
        -305.0,
        -2368.5,
        632.5
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3657243251800537,
        0.8829615712165833,
        0.2943204939365387
      ],
      "plane_d": 1990.97314453125,
      "bbox_min": [
        -285.0,
        -2353.4951171875,
        635.0
      ],
      "bbox_max": [
        -277.0616760253906,
        -2348.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1473.2569580078125,
      "bbox_min": [
        -299.14208984375,
        -2382.64208984375,
        635.0
      ],
      "bbox_max": [
        -297.72802734375,
        -2381.22802734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1473.2569580078125,
      "bbox_min": [
        -299.14208984375,
        -2385.93017578125,
        641.0
      ],
      "bbox_max": [
        -290.4967041015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.5,
      "bbox_min": [
        -299.14208984375,
        -2385.93017578125,
        651.5
      ],
      "bbox_max": [
        -290.4967041015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -318.5,
        -2360.755126953125,
        618.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -318.5,
        -2360.755126953125,
        618.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 664.5,
      "bbox_min": [
        -318.5,
        -2360.755126953125,
        632.5
      ],
      "bbox_max": [
        -309.9205017089844,
        -2357.199951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -632.5,
      "bbox_min": [
        -318.5,
        -2360.755126953125,
        632.5
      ],
      "bbox_max": [
        -309.9205017089844,
        -2357.199951171875,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.24253562092781067,
        -0.0
      ],
      "plane_d": -868.495849609375,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        618.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2339.699951171875,
      "bbox_min": [
        -318.5,
        -2339.699951171875,
        618.0
      ],
      "bbox_max": [
        -310.300048828125,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        620.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        -0.9238762259483337,
        -0.0
      ],
      "plane_d": -2252.6982421875,
      "bbox_min": [
        -318.5,
        -2329.530029296875,
        620.0
      ],
      "bbox_max": [
        -259.423095703125,
        -2297.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268962502479553,
        0.923876941204071,
        -0.0
      ],
      "plane_d": 2234.699462890625,
      "bbox_min": [
        -294.1133117675781,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -259.423095703125,
        -2297.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630545735359192,
        0.8764691948890686,
        0.3162168562412262
      ],
      "plane_d": 1922.0771484375,
      "bbox_min": [
        -294.1133117675781,
        -2311.052490234375,
        620.0
      ],
      "bbox_max": [
        -259.423095703125,
        -2297.0,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3630545437335968,
        -0.8764698505401611,
        0.31621500849723816
      ],
      "plane_d": -2335.057373046875,
      "bbox_min": [
        -318.5,
        -2329.530029296875,
        620.0
      ],
      "bbox_max": [
        -267.07666015625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -318.5,
        -2310.989013671875,
        620.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2388.4580078125,
      "bbox_min": [
        -318.5,
        -2310.989013671875,
        620.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -304.6982421875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -294.6982727050781,
        -2298.5,
        704.0
      ],
      "bbox_max": [
        -294.69818115234375,
        -2297.0,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        0.0,
        0.8797038793563843
      ],
      "plane_d": -731.986572265625,
      "bbox_min": [
        -262.849853515625,
        -2298.5,
        690.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -318.5,
        -2320.260009765625,
        704.0
      ],
      "bbox_max": [
        -317.0,
        -2320.260009765625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2310.260009765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": 511.431884765625,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2352.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -317.0,
        -2320.260009765625,
        690.8838500976562
      ],
      "bbox_max": [
        -294.6982116699219,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -317.0,
        -2320.260009765625,
        691.2669067382812
      ],
      "bbox_max": [
        -294.6982116699219,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -317.0,
        -2320.260009765625,
        704.0
      ],
      "bbox_max": [
        -294.6982116699219,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -294.698486328125,
        -2306.50732421875,
        704.0
      ],
      "bbox_max": [
        -294.6982116699219,
        -2298.5,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2302.365234375,
        691.2669067382812
      ],
      "bbox_max": [
        -304.6982421875,
        -2298.5,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -317.0,
        -2310.26025390625,
        690.8838500976562
      ],
      "bbox_max": [
        -312.59326171875,
        -2310.260009765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1412.5638427734375,
      "bbox_min": [
        -317.0,
        -2310.26025390625,
        687.5
      ],
      "bbox_max": [
        -304.6982421875,
        -2298.5,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        -0.8797038793563843,
        -0.0
      ],
      "plane_d": -2146.990234375,
      "bbox_min": [
        -317.0,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -259.14990234375,
        -2298.5,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": 511.431884765625,
      "bbox_min": [
        -317.0,
        -2355.699951171875,
        690.0
      ],
      "bbox_max": [
        -315.0,
        -2352.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.0,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2297.0,
        687.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22233350574970245,
        0.536557674407959,
        -0.8140476942062378
      ],
      "plane_d": 1719.30078125,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38280341029167175,
        0.9238297939300537,
        0.0
      ],
      "plane_d": 2054.107421875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -290.0,
        -2348.16748046875,
        649.5
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -1165.0810546875,
      "bbox_min": [
        -290.0,
        -2348.16748046875,
        649.5
      ],
      "bbox_max": [
        -288.1221923828125,
        -2343.6357421875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -318.5,
        -2355.44482421875,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -318.5,
        -2350.796142578125,
        656.0
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -318.5,
        -2355.44482421875,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -318.2650146484375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        637.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -318.5,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5809391736984253,
        -0.8139470219612122
      ],
      "plane_d": 1891.8863525390625,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -318.5,
        -2350.8935546875,
        649.5
      ],
      "bbox_max": [
        -318.2650146484375,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500011146068573,
        -0.49997779726982117,
        -0.707114577293396
      ],
      "plane_d": -532.790283203125,
      "bbox_min": [
        -318.5,
        -2309.460205078125,
        655.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.670008168730419e-05,
        -0.7070814967155457,
        -0.70713210105896
      ],
      "plane_d": -1167.5474853515625,
      "bbox_min": [
        -318.5,
        -2309.460205078125,
        655.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -318.5,
        -2309.460205078125,
        655.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.144189966202248e-05,
        -0.9805810451507568,
        -0.1961144208908081
      ],
      "plane_d": -2135.38037109375,
      "bbox_min": [
        -318.5,
        -2309.460205078125,
        658.0
      ],
      "bbox_max": [
        -305.49835205078125,
        -2297.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": 2444.40576171875,
      "bbox_min": [
        -318.5,
        -2355.699951171875,
        659.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        0.47552189230918884,
        -0.0
      ],
      "plane_d": 1397.2935791015625,
      "bbox_min": [
        -317.0,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2352.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1417.5638427734375,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        659.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        659.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071163058280945,
        -0.7070972323417664,
        0.0
      ],
      "plane_d": -1414.5389404296875,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693382978439331,
        -0.6933642625808716,
        0.1961275041103363
      ],
      "plane_d": -1519.2562255859375,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805760979652405,
        0.1961391568183899
      ],
      "plane_d": -2399.544921875,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805803894996643,
        -1.867096398200374e-05,
        0.19611762464046478
      ],
      "plane_d": 164.5936737060547,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2297.0,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805760979652405,
        -0.0,
        -0.1961391568183899
      ],
      "plane_d": -166.4639129638672,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -304.5352783203125,
        -2297.0,
        683.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999994039535522,
        2.1605259462376125e-05,
        0.0010726567124947906
      ],
      "plane_d": -305.2082214355469,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -304.5352783203125,
        -2297.0,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -311.7646484375,
        -2310.460205078125,
        674.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.964599609375,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -318.5,
        -2312.26025390625,
        672.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2302.365234375,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -299.6982421875,
        -2300.193359375,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2297.0,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -312.59326171875,
        -2310.260009765625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -318.5,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -314.7646179199219,
        -2315.26025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1412.5638427734375,
      "bbox_min": [
        -313.5832824707031,
        -2310.26025390625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2301.375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -313.5832824707031,
        -2310.26025390625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2301.375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -313.5832824707031,
        -2310.26025390625,
        684.0
      ],
      "bbox_max": [
        -312.59326171875,
        -2310.26025390625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 299.6982421875,
      "bbox_min": [
        -314.7646179199219,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -299.6982421875,
        -2300.193359375,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2315.26025390625,
      "bbox_min": [
        -314.7646179199219,
        -2315.26025390625,
        663.0
      ],
      "bbox_max": [
        -310.522216796875,
        -2315.26025390625,
        664.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933689117431641,
        -0.6933689117431641,
        -0.19616110622882843
      ],
      "plane_d": -1255.0654296875,
      "bbox_min": [
        -318.5,
        -2310.26025390625,
        659.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        -0.1961161345243454
      ],
      "plane_d": 428.80621337890625,
      "bbox_min": [
        -305.4984436035156,
        -2302.365234375,
        659.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2297.0,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.0,
      "bbox_min": [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.847998321056366
      ],
      "plane_d": -1764.1014404296875,
      "bbox_min": [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.300048828125,
      "bbox_min": [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -868.495849609375,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2339.699951171875,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2371.0,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2361.0,
      "bbox_min": [
        -329.699951171875,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2360.0,
      "bbox_min": [
        -329.699951171875,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2360.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2361.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2360.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2361.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2361.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2361.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2360.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2370.0,
      "bbox_min": [
        -329.699951171875,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2370.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2370.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2371.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2371.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2370.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2371.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2371.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2371.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2370.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2381.0,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2380.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2380.0,
      "bbox_min": [
        -329.699951171875,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2380.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2380.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2381.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2380.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2381.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2381.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2380.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2411.5,
      "bbox_min": [
        -406.28662109375,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        672.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2411.5,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -310.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -310.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        -310.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -310.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -310.0,
        -2427.0,
        638.0
      ],
      "bbox_max": [
        -308.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2416.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -310.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1925.4517822265625,
      "bbox_min": [
        -310.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -310.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -310.0,
        -2416.0,
        638.0
      ],
      "bbox_max": [
        -308.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -308.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2416.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -308.0,
        -2416.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -310.0,
        -2424.0,
        638.0
      ],
      "bbox_max": [
        -308.0,
        -2416.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -310.0,
        -2411.5,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1945.9578857421875,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -327.0,
        -2427.0,
        638.0
      ],
      "bbox_max": [
        -325.0,
        -2424.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2416.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1476.43896484375,
      "bbox_min": [
        -327.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -327.0,
        -2416.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -327.0,
        -2416.0,
        638.0
      ],
      "bbox_max": [
        -325.0,
        -2413.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2416.0,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        603.0
      ],
      "bbox_max": [
        -325.0,
        -2416.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -327.0,
        -2424.0,
        638.0
      ],
      "bbox_max": [
        -325.0,
        -2416.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2427.0,
      "bbox_min": [
        -325.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -310.0,
        -2411.5,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -603.0,
      "bbox_min": [
        -325.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -310.0,
        -2411.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 638.0,
      "bbox_min": [
        -325.0,
        -2427.0,
        603.0
      ],
      "bbox_max": [
        -310.0,
        -2411.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2413.0,
      "bbox_min": [
        -325.0,
        -2413.0,
        603.0
      ],
      "bbox_max": [
        -310.0,
        -2411.5,
        638.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 616.9500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 635.9500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.9500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.5,
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -311.5,
      "bbox_min": [
        -311.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.4500122070312,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.5,
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -311.5,
      "bbox_min": [
        -311.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        672.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        -403.7908935546875,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -232.20913696289062,
        -2388.5,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -625.5,
      "bbox_min": [
        -403.7908935546875,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -232.20913696289062,
        -2388.5,
        626.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2001.610107421875,
      "bbox_min": [
        -403.7908935546875,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -232.20913696289062,
        -2388.5,
        626.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6696208715438843,
        0.6431839466094971,
        0.37137895822525024
      ],
      "plane_d": 1574.1484375,
      "bbox_min": [
        -403.7908935546875,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -232.20913696289062,
        -2388.5,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2748695909976959,
        0.8868590593338013,
        0.3713861405849457
      ],
      "plane_d": 1829.9315185546875,
      "bbox_min": [
        -377.6445617675781,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -244.52114868164062,
        -2388.5,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -357.0,
      "bbox_min": [
        -377.6445617675781,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -258.3554382324219,
        -2388.5,
        626.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 279.0,
      "bbox_min": [
        -279.0,
        -2406.199951171875,
        625.5
      ],
      "bbox_max": [
        -258.3554382324219,
        -2388.5,
        626.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2453.22119140625,
      "bbox_min": [
        -367.330078125,
        -2392.0,
        625.5
      ],
      "bbox_max": [
        -357.0,
        -2391.800048828125,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.0,
      "bbox_min": [
        -329.699951171875,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2388.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.699951171875,
      "bbox_min": [
        -329.699951171875,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2388.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.300048828125,
      "bbox_min": [
        -329.699951171875,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2388.5,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2390.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2401.0,
      "bbox_min": [
        -329.699951171875,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2400.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2400.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2401.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2400.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2401.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2401.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2400.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2391.0,
      "bbox_min": [
        -329.699951171875,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2390.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2390.0,
      "bbox_min": [
        -329.699951171875,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -306.300048828125,
        -2390.0,
        618.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2390.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2391.0,
        616.0
      ],
      "bbox_max": [
        -325.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -650.5382080078125,
      "bbox_min": [
        -311.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        608.0
      ],
      "bbox_max": [
        -311.0,
        -2390.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -309.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        611.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 215.66757202148438,
      "bbox_min": [
        -311.0,
        -2391.0,
        614.0
      ],
      "bbox_max": [
        -309.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -311.0,
        -2391.0,
        616.0
      ],
      "bbox_max": [
        -311.0,
        -2390.0,
        618.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.0,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        -285.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6696200370788574,
        0.6431792378425598,
        0.37138861417770386
      ],
      "plane_d": 1148.25244140625,
      "bbox_min": [
        -285.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -229.71337890625,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2748695909976959,
        0.8868590593338013,
        0.3713861405849457
      ],
      "plane_d": 1829.9315185546875,
      "bbox_min": [
        -285.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -235.2596893310547,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -281.0,
      "bbox_min": [
        -285.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -235.2596893310547,
        -2388.5,
        640.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 636.5,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -235.2596893310547,
        -2388.5,
        636.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2353.315673828125,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -243.544677734375,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2001.610107421875,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -243.544677734375,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24632346630096436,
        0.794755756855011,
        -0.5546963214874268
      ],
      "plane_d": 2199.4638671875,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -243.544677734375,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1638.86181640625,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -253.22499084472656,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26736271381378174,
        -0.787924587726593,
        -0.5546998977661133
      ],
      "plane_d": -1461.48095703125,
      "bbox_min": [
        -269.0,
        -2394.0,
        628.25
      ],
      "bbox_max": [
        -253.22499084472656,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6254568099975586,
        -0.5487351417541504,
        -0.5547012686729431
      ],
      "plane_d": -799.2052612304688,
      "bbox_min": [
        -254.04176330566406,
        -2389.028564453125,
        635.5790405273438
      ],
      "bbox_max": [
        -253.22499084472656,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983483672142029,
        -0.8792400360107422,
        0.37138280272483826
      ],
      "plane_d": -2255.284912109375,
      "bbox_min": [
        -269.0,
        -2390.0,
        628.25
      ],
      "bbox_max": [
        -261.7786560058594,
        -2388.5,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2453.22119140625,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -258.97784423828125,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983483672142029,
        -0.8792400360107422,
        0.37138280272483826
      ],
      "plane_d": -2255.284912109375,
      "bbox_min": [
        -269.0,
        -2391.800048828125,
        626.0
      ],
      "bbox_max": [
        -258.97784423828125,
        -2388.5,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 279.0,
      "bbox_min": [
        -281.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2390.0,
        636.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -1726.7335205078125,
      "bbox_min": [
        -281.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2392.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": 1942.560302734375,
      "bbox_min": [
        -281.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2392.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": -2441.907470703125,
      "bbox_min": [
        -281.0,
        -2394.0,
        626.0
      ],
      "bbox_max": [
        -279.0,
        -2392.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.936329185962677,
        0.0
      ],
      "plane_d": 2157.8876953125,
      "bbox_min": [
        -285.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -281.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        -0.936329185962677,
        0.0
      ],
      "plane_d": -2336.492431640625,
      "bbox_min": [
        -285.0,
        -2390.0,
        626.0
      ],
      "bbox_max": [
        -281.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -287.038330078125,
        -2388.5,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6696208715438843,
        0.6431839466094971,
        0.37137895822525024
      ],
      "plane_d": 1574.1484375,
      "bbox_min": [
        -406.28662109375,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2748698890209198,
        0.8868584632873535,
        0.3713874816894531
      ],
      "plane_d": 2004.7464599609375,
      "bbox_min": [
        -400.74029541015625,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -400.74029541015625,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 636.5,
      "bbox_min": [
        -400.74029541015625,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2353.315673828125,
      "bbox_min": [
        -392.455322265625,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2001.610107421875,
      "bbox_min": [
        -392.455322265625,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24631951749324799,
        0.7947531342506409,
        -0.5547018647193909
      ],
      "plane_d": 2356.12109375,
      "bbox_min": [
        -392.455322265625,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1638.8616943359375,
      "bbox_min": [
        -382.7750244140625,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2673586905002594,
        -0.7879223823547363,
        -0.554705023765564
      ],
      "plane_d": -1631.5135498046875,
      "bbox_min": [
        -382.7750244140625,
        -2394.0,
        628.2498779296875
      ],
      "bbox_max": [
        -367.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6254514455795288,
        -0.548734724521637,
        -0.5547077655792236
      ],
      "plane_d": -1196.988525390625,
      "bbox_min": [
        -382.7750244140625,
        -2389.028564453125,
        635.5790405273438
      ],
      "bbox_max": [
        -381.958251953125,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2983502745628357,
        -0.8792362213134766,
        0.37139028310775757
      ],
      "plane_d": -2445.03076171875,
      "bbox_min": [
        -374.2214660644531,
        -2390.0,
        628.2498779296875
      ],
      "bbox_max": [
        -367.0,
        -2388.5,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -2453.22119140625,
      "bbox_min": [
        -377.02215576171875,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2388.5,
        636.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2983502745628357,
        -0.8792362213134766,
        0.37139028310775757
      ],
      "plane_d": -2445.03076171875,
      "bbox_min": [
        -377.02215576171875,
        -2391.800048828125,
        626.0
      ],
      "bbox_max": [
        -367.0,
        -2388.5,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -357.0,
      "bbox_min": [
        -357.0,
        -2408.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2390.0,
        636.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -1726.7335205078125,
      "bbox_min": [
        -357.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2392.0,
        635.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": 1942.560302734375,
      "bbox_min": [
        -357.0,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2392.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9138115644454956,
        0.40613847970962524
      ],
      "plane_d": -2441.907470703125,
      "bbox_min": [
        -357.0,
        -2394.0,
        626.0
      ],
      "bbox_max": [
        -355.0,
        -2392.0,
        630.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.936329185962677,
        -0.0
      ],
      "plane_d": 2381.2021484375,
      "bbox_min": [
        -355.0,
        -2411.5,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        -0.936329185962677,
        0.0
      ],
      "plane_d": -2113.177978515625,
      "bbox_min": [
        -355.0,
        -2390.0,
        626.0
      ],
      "bbox_max": [
        -351.0,
        -2388.5,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 800.5827026367188,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.038330078125,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 140.16561889648438,
      "bbox_min": [
        -348.961669921875,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2421.395263671875,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2289.90234375,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2099.217041015625,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -325.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.960491418838501,
        0.195743128657341,
        -0.1978406459093094
      ],
      "plane_d": 912.6994018554688,
      "bbox_min": [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -325.047607421875,
        -2407.21142578125,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203608989715576,
        0.17341561615467072,
        -0.5449174642562866
      ],
      "plane_d": 1037.0115966796875,
      "bbox_min": [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -325.9545593261719,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5541775226593018,
        0.1150112897157669,
        -0.8244147300720215
      ],
      "plane_d": 987.8859252929688,
      "bbox_min": [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -328.529541015625,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.546083927154541,
        0.12711937725543976,
        -0.8280296325683594
      ],
      "plane_d": 1016.7019653320312,
      "bbox_min": [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -329.16162109375,
        -2408.55322265625,
        641.013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19263438880443573,
        0.04233338683843613,
        -0.9803569912910461
      ],
      "plane_d": 791.9986572265625,
      "bbox_min": [
        -336.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -332.410888671875,
        -2410.043212890625,
        638.4183959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 1024.0538330078125,
      "bbox_min": [
        -329.16162109375,
        -2411.488525390625,
        641.013671875
      ],
      "bbox_max": [
        -325.95684814453125,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 1024.0538330078125,
      "bbox_min": [
        -326.757568359375,
        -2411.5,
        644.904052734375
      ],
      "bbox_max": [
        -325.9443359375,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2357.167724609375,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.960491955280304,
        0.19574043154716492,
        -0.19784054160118103
      ],
      "plane_d": 265.32147216796875,
      "bbox_min": [
        -348.952392578125,
        -2411.5,
        637.6590576171875
      ],
      "bbox_max": [
        -337.7247619628906,
        -2407.21142578125,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8203592896461487,
        0.1734265685081482,
        -0.5449163913726807
      ],
      "plane_d": 484.1146545410156,
      "bbox_min": [
        -348.0452880859375,
        -2411.5,
        637.6590576171875
      ],
      "bbox_max": [
        -337.7247619628906,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5541764497756958,
        0.11502812802791595,
        -0.8244131207466125
      ],
      "plane_d": 614.4102172851562,
      "bbox_min": [
        -345.470458984375,
        -2411.5,
        637.6590576171875
      ],
      "bbox_max": [
        -337.7247619628906,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5460926294326782,
        0.12712153792381287,
        -0.8280234932899475
      ],
      "plane_d": 648.6397094726562,
      "bbox_min": [
        -344.83837890625,
        -2411.5,
        637.6590576171875
      ],
      "bbox_max": [
        -337.7247619628906,
        -2408.55322265625,
        641.0137329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19263438880443573,
        0.042333390563726425,
        -0.9803569912910461
      ],
      "plane_d": 662.1630859375,
      "bbox_min": [
        -341.589111328125,
        -2411.5,
        637.6590576171875
      ],
      "bbox_max": [
        -337.7247619628906,
        -2410.043212890625,
        638.4183959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 471.93133544921875,
      "bbox_min": [
        -348.04296875,
        -2411.48828125,
        641.0137329101562
      ],
      "bbox_max": [
        -344.83837890625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 471.93133544921875,
      "bbox_min": [
        -348.0556640625,
        -2411.5,
        644.90380859375
      ],
      "bbox_max": [
        -347.242431640625,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2371.898681640625,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2500.950927734375,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -327.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160831928253174,
        0.5453042387962341,
        -0.1914459615945816
      ],
      "plane_d": 1704.902587890625,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -327.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5452976226806641,
        0.8160732388496399,
        -0.19150692224502563
      ],
      "plane_d": 2266.728271484375,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5453042387962341,
        0.8160831928253174,
        -0.1914459615945816
      ],
      "plane_d": 1899.1796875,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160732388496399,
        0.5452976226806641,
        -0.19150692224502563
      ],
      "plane_d": 1154.8895263671875,
      "bbox_min": [
        -346.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16313675045967102,
        0.8203286528587341,
        -0.5481306910514832
      ],
      "plane_d": 2269.825927734375,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16313259303569794,
        0.8203077912330627,
        -0.5481631755828857
      ],
      "plane_d": 2379.749755859375,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4647390842437744,
        0.6954092383384705,
        -0.5481091141700745
      ],
      "plane_d": 2180.12548828125,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4647216498851776,
        0.6953831315040588,
        -0.5481569766998291
      ],
      "plane_d": 1866.865478515625,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19263438880443573,
        0.042333390563726425,
        -0.9803569912910461
      ],
      "plane_d": 662.1630859375,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -328.46435546875,
        -2404.72900390625,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.324804425239563,
        0.9457812309265137,
        0.0
      ],
      "plane_d": 2171.292236328125,
      "bbox_min": [
        -337.0868225097656,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -332.758056640625,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2390.21044921875,
      "bbox_min": [
        -337.0868225097656,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -337.0,
        -2411.47021484375,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31816256046295166,
        0.9476114511489868,
        0.028374386951327324
      ],
      "plane_d": 2374.240478515625,
      "bbox_min": [
        -345.53564453125,
        -2411.5,
        637.5350341796875
      ],
      "bbox_max": [
        -330.46728515625,
        -2404.72900390625,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2390.21044921875,
      "bbox_min": [
        -341.241943359375,
        -2411.5,
        637.5350341796875
      ],
      "bbox_max": [
        -337.0,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1821.836181640625,
      "bbox_min": [
        -343.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -330.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1439.19287109375,
      "bbox_min": [
        -343.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -330.46728515625,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1761.5289306640625,
      "bbox_min": [
        -343.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -332.0,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1550.692626953125,
      "bbox_min": [
        -343.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -333.46435546875,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1123.6630859375,
      "bbox_min": [
        -343.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -333.46435546875,
        -2406.800048828125,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1726299226284027,
        0.11533552408218384,
        -0.9782109260559082
      ],
      "plane_d": 961.873779296875,
      "bbox_min": [
        -340.53564453125,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -333.46435546875,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1726299226284027,
        0.11533553153276443,
        -0.9782109260559082
      ],
      "plane_d": 845.521240234375,
      "bbox_min": [
        -340.53564453125,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -334.2939453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11793964356184006,
        0.17652766406536102,
        -0.9772042632102966
      ],
      "plane_d": 1090.3642578125,
      "bbox_min": [
        -339.7060546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -334.2939453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11793964356184006,
        0.17652764916419983,
        -0.9772042632102966
      ],
      "plane_d": 1010.8728637695312,
      "bbox_min": [
        -339.7060546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -335.53564453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04192692041397095,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1147.015380859375,
      "bbox_min": [
        -338.46435546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -335.53564453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04192691668868065,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1118.756591796875,
      "bbox_min": [
        -338.46435546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -337.0,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9798362851142883,
        0.19980166852474213,
        -0.000400588265620172
      ],
      "plane_d": 177.39939880371094,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.038330078125,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9798362851142883,
        0.19980166852474213,
        -0.000411680230172351
      ],
      "plane_d": 763.3489379882812,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.038330078125,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2297.31591796875,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509324431419373,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 2413.981689453125,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827075958251953,
        0.9238695502281189,
        -8.666777375765378e-07
      ],
      "plane_d": 2113.759765625,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -287.047607421875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.960491418838501,
        0.195743128657341,
        -0.1978406459093094
      ],
      "plane_d": 876.2007446289062,
      "bbox_min": [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -287.047607421875,
        -2407.21142578125,
        649.3076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203608989715576,
        0.17341561615467072,
        -0.5449174642562866
      ],
      "plane_d": 1005.837890625,
      "bbox_min": [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -287.95465087890625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5541775226593018,
        0.1150112897157669,
        -0.8244147300720215
      ],
      "plane_d": 966.8271484375,
      "bbox_min": [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -290.529541015625,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.546083927154541,
        0.12711937725543976,
        -0.8280296325683594
      ],
      "plane_d": 995.9508056640625,
      "bbox_min": [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -291.16162109375,
        -2408.55322265625,
        641.013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19263438880443573,
        0.04233338683843613,
        -0.9803569912910461
      ],
      "plane_d": 784.6785888671875,
      "bbox_min": [
        -298.2746887207031,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -294.410888671875,
        -2410.043212890625,
        638.4183959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 992.9251098632812,
      "bbox_min": [
        -291.16162109375,
        -2411.48828125,
        641.013671875
      ],
      "bbox_max": [
        -287.95709228515625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8191777467727661,
        0.16721095144748688,
        -0.5486240386962891
      ],
      "plane_d": 992.9251098632812,
      "bbox_min": [
        -288.757568359375,
        -2411.5,
        644.9039306640625
      ],
      "bbox_max": [
        -287.9443359375,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38269850611686707,
        0.9238733053207397,
        -8.707995675649727e-07
      ],
      "plane_d": 2342.625244140625,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.960491955280304,
        0.19574043154716492,
        -0.19784054160118103
      ],
      "plane_d": 301.8201599121094,
      "bbox_min": [
        -310.952392578125,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -299.7253112792969,
        -2407.21142578125,
        649.3076782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8203592896461487,
        0.1734265685081482,
        -0.5449163913726807
      ],
      "plane_d": 515.2882690429688,
      "bbox_min": [
        -310.0452880859375,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -299.7253112792969,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5541764497756958,
        0.11502812802791595,
        -0.8244131207466125
      ],
      "plane_d": 635.4688720703125,
      "bbox_min": [
        -307.470458984375,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -299.7253112792969,
        -2408.55322265625,
        641.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5460926294326782,
        0.12712153792381287,
        -0.8280234932899475
      ],
      "plane_d": 669.3912353515625,
      "bbox_min": [
        -306.83837890625,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -299.7253112792969,
        -2408.55322265625,
        641.0137329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19263438880443573,
        0.042333390563726425,
        -0.9803569912910461
      ],
      "plane_d": 669.4832153320312,
      "bbox_min": [
        -303.589111328125,
        -2411.5,
        637.6591796875
      ],
      "bbox_max": [
        -299.7253112792969,
        -2410.043212890625,
        638.4183959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 503.0599670410156,
      "bbox_min": [
        -310.04296875,
        -2411.48828125,
        641.0137329101562
      ],
      "bbox_max": [
        -306.83837890625,
        -2407.557373046875,
        644.9067993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8191738724708557,
        0.1672101467847824,
        -0.5486300587654114
      ],
      "plane_d": 503.0599670410156,
      "bbox_min": [
        -310.0556640625,
        -2411.5,
        644.90380859375
      ],
      "bbox_max": [
        -309.242431640625,
        -2407.557373046875,
        644.91943359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19148309528827667,
        0.9626355767250061,
        -0.1914861500263214
      ],
      "plane_d": 2379.175048828125,
      "bbox_min": [
        -308.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19148465991020203,
        0.9626434445381165,
        -0.19144512712955475
      ],
      "plane_d": 2493.674560546875,
      "bbox_min": [
        -308.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2401.800048828125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5453042387962341,
        0.8160831928253174,
        -0.1914459615945816
      ],
      "plane_d": 1919.9012451171875,
      "bbox_min": [
        -308.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8160732388496399,
        0.5452976226806641,
        -0.19150692224502563
      ],
      "plane_d": 1185.900390625,
      "bbox_min": [
        -308.23876953125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8160831928253174,
        0.5453042387962341,
        -0.1914459615945816
      ],
      "plane_d": 1673.891357421875,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -289.76123046875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5452976226806641,
        0.8160732388496399,
        -0.19150692224502563
      ],
      "plane_d": 2246.0068359375,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2402.561279296875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16313675045967102,
        0.8203286528587341,
        -0.5481306910514832
      ],
      "plane_d": 2276.025146484375,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16313259303569794,
        0.8203077912330627,
        -0.5481631755828857
      ],
      "plane_d": 2373.550537109375,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2402.561279296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4647390842437744,
        0.6954092383384705,
        -0.5481091141700745
      ],
      "plane_d": 2162.46533203125,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4647216498851776,
        0.6953831315040588,
        -0.5481569766998291
      ],
      "plane_d": 1884.52490234375,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2403.264404296875,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19263438880443573,
        0.04233338683843613,
        -0.9803569912910461
      ],
      "plane_d": 784.6785888671875,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -290.46435546875,
        -2404.72900390625,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.324804425239563,
        0.9457812309265137,
        0.0
      ],
      "plane_d": 2183.635009765625,
      "bbox_min": [
        -299.0868225097656,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -294.758056640625,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2377.867919921875,
      "bbox_min": [
        -299.0868225097656,
        -2411.5,
        637.5166625976562
      ],
      "bbox_max": [
        -299.0,
        -2411.47021484375,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31816256046295166,
        0.9476114511489868,
        0.028374386951327324
      ],
      "plane_d": 2362.150146484375,
      "bbox_min": [
        -307.53564453125,
        -2411.5,
        637.5350341796875
      ],
      "bbox_max": [
        -292.46728515625,
        -2404.72900390625,
        645.6731567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.324804425239563,
        0.9457812309265137,
        -0.0
      ],
      "plane_d": 2377.867919921875,
      "bbox_min": [
        -303.241943359375,
        -2411.5,
        637.5350341796875
      ],
      "bbox_max": [
        -299.0,
        -2410.043212890625,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10985572636127472,
        0.5522180795669556,
        -0.8264302611351013
      ],
      "plane_d": 1826.0107421875,
      "bbox_min": [
        -305.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -292.46728515625,
        -2404.72900390625,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46815043687820435,
        0.312797874212265,
        -0.8264337182044983
      ],
      "plane_d": 1421.403076171875,
      "bbox_min": [
        -305.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -292.46728515625,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31280118227005005,
        0.46815547347068787,
        -0.8264296054840088
      ],
      "plane_d": 1749.6424560546875,
      "bbox_min": [
        -305.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -294.0,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.312797874212265,
        0.46815043687820435,
        -0.8264337182044983
      ],
      "plane_d": 1562.578857421875,
      "bbox_min": [
        -305.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -295.46435546875,
        -2405.267333984375,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46815547347068787,
        0.31280118227005005,
        -0.8264296054840088
      ],
      "plane_d": 1141.4530029296875,
      "bbox_min": [
        -305.53271484375,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -295.46435546875,
        -2406.800048828125,
        642.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1726299226284027,
        0.11533552408218384,
        -0.9782109260559082
      ],
      "plane_d": 955.3138427734375,
      "bbox_min": [
        -302.53564453125,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -295.46435546875,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1726299226284027,
        0.11533553153276443,
        -0.9782109260559082
      ],
      "plane_d": 852.0811767578125,
      "bbox_min": [
        -302.53564453125,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -296.2939453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11793964356184006,
        0.17652766406536102,
        -0.9772042632102966
      ],
      "plane_d": 1085.882568359375,
      "bbox_min": [
        -301.7060546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -296.2939453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11793964356184006,
        0.17652764916419983,
        -0.9772042632102966
      ],
      "plane_d": 1015.3546142578125,
      "bbox_min": [
        -301.7060546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -297.53564453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04192692041397095,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1145.422119140625,
      "bbox_min": [
        -300.46435546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -297.53564453125,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04192691668868065,
        0.2107943445444107,
        -0.9766308665275574
      ],
      "plane_d": 1120.349853515625,
      "bbox_min": [
        -300.46435546875,
        -2411.5,
        639.5
      ],
      "bbox_max": [
        -299.0,
        -2407.97314453125,
        640.26123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.993532657623291,
        -0.0,
        -0.11354659497737885
      ],
      "plane_d": -246.19747924804688,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.993532657623291,
        0.0,
        -0.11354658752679825
      ],
      "plane_d": 385.68927001953125,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9684929251670837,
        -0.24904105067253113
      ],
      "plane_d": 2488.8330078125,
      "bbox_min": [
        -324.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -311.39990234375,
        -2397.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5,
      "bbox_min": [
        -322.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -313.39990234375,
        -2401.5,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.4000244140625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 314.39990234375,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -321.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2411.5,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2403.60009765625,
      "bbox_min": [
        -321.60009765625,
        -2403.60009765625,
        652.4000244140625
      ],
      "bbox_max": [
        -314.39990234375,
        -2403.60009765625,
        654.5
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elev2dr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr1",
      "offset": 2369,
      "centroid": [
        -317.5,
        -2412.25,
        612.7000122070312
      ],
      "bbox_min": [
        -323.5,
        -2413.0,
        608.4500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        616.9500122070312
      ],
      "dimensions_source": {
        "span_x": 12.0,
        "span_y": 1.5,
        "height_z": 8.5,
        "door_width": 12.0,
        "door_depth": 1.5,
        "leaf_depth": 1.46,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -311.5,
          -2411.5,
          608.4500122070312
        ],
        [
          -311.5,
          -2411.5,
          616.9500122070312
        ],
        [
          -311.5,
          -2413.0,
          616.9500122070312
        ],
        [
          -311.5,
          -2413.0,
          608.4500122070312
        ],
        [
          -323.5,
          -2413.0,
          616.9500122070312
        ],
        [
          -323.5,
          -2413.0,
          608.4500122070312
        ],
        [
          -323.5,
          -2411.5,
          608.4500122070312
        ],
        [
          -323.5,
          -2411.5,
          616.9500122070312
        ]
      ],
      "plane_distance": -2413.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev2dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr2",
      "offset": 3440,
      "centroid": [
        -317.5,
        -2412.25,
        631.4500122070312
      ],
      "bbox_min": [
        -323.5,
        -2413.0,
        626.9500122070312
      ],
      "bbox_max": [
        -311.5,
        -2411.5,
        635.9500122070312
      ],
      "dimensions_source": {
        "span_x": 12.0,
        "span_y": 1.5,
        "height_z": 9.0,
        "door_width": 12.0,
        "door_depth": 1.5,
        "leaf_depth": 1.46,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -311.5,
          -2413.0,
          635.9500122070312
        ],
        [
          -311.5,
          -2413.0,
          626.9500122070312
        ],
        [
          -311.5,
          -2411.5,
          635.9500122070312
        ],
        [
          -311.5,
          -2411.5,
          626.9500122070312
        ],
        [
          -323.5,
          -2413.0,
          635.9500122070312
        ],
        [
          -323.5,
          -2413.0,
          626.9500122070312
        ],
        [
          -323.5,
          -2411.5,
          626.9500122070312
        ],
        [
          -323.5,
          -2411.5,
          635.9500122070312
        ]
      ],
      "plane_distance": -2413.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: rdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "rdr1",
      "offset": 6376,
      "centroid": [
        -280.0,
        -2399.0,
        630.75
      ],
      "bbox_min": [
        -280.6000061035156,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -279.3999938964844,
        -2392.0,
        635.5
      ],
      "dimensions_source": {
        "span_x": 1.20001220703125,
        "span_y": 14.0,
        "height_z": 9.5,
        "door_width": 14.0,
        "door_depth": 1.20001220703125,
        "leaf_depth": 1.16001220703125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -280.6000061035156,
          -2392.0,
          635.5
        ],
        [
          -280.6000061035156,
          -2406.0,
          635.5
        ],
        [
          -279.3999938964844,
          -2392.0,
          635.5
        ],
        [
          -279.3999938964844,
          -2406.0,
          635.5
        ],
        [
          -280.6000061035156,
          -2392.0,
          626.0
        ],
        [
          -280.6000061035156,
          -2406.0,
          626.0
        ],
        [
          -279.3999938964844,
          -2406.0,
          626.0
        ],
        [
          -279.3999938964844,
          -2392.0,
          626.0
        ]
      ],
      "plane_distance": 626.0,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CSlidingDoor piece: rdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "rdr2",
      "offset": 7431,
      "centroid": [
        -356.0,
        -2399.0,
        630.75
      ],
      "bbox_min": [
        -356.6000061035156,
        -2406.0,
        626.0
      ],
      "bbox_max": [
        -355.3999938964844,
        -2392.0,
        635.5
      ],
      "dimensions_source": {
        "span_x": 1.20001220703125,
        "span_y": 14.0,
        "height_z": 9.5,
        "door_width": 14.0,
        "door_depth": 1.20001220703125,
        "leaf_depth": 1.16001220703125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -356.6000061035156,
          -2392.0,
          635.5
        ],
        [
          -356.6000061035156,
          -2406.0,
          635.5
        ],
        [
          -355.3999938964844,
          -2392.0,
          635.5
        ],
        [
          -355.3999938964844,
          -2406.0,
          635.5
        ],
        [
          -356.6000061035156,
          -2392.0,
          626.0
        ],
        [
          -356.6000061035156,
          -2406.0,
          626.0
        ],
        [
          -355.3999938964844,
          -2406.0,
          626.0
        ],
        [
          -355.3999938964844,
          -2392.0,
          626.0
        ]
      ],
      "plane_distance": 626.0,
      "authentic_texture": "chkptdoor1"
    }
  ],
  "tutorial_messages": []
}